
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2TweP", function(module, exports) {
/**
 * @generated SignedSource<<cef7be4cc9cb54a56eb338c662523382>>
 * @relayHash 5d42554987a7deb7d918e30e0c782f3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ff16a4a9a4ee0c23a78cff28ab639a88978f4bf29a6d1536290b0ed4211323b
const $4f8f3df3514c68cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "doPublish"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "suppressDraftPropertyUpdate"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "doPublish",
                    "variableName": "doPublish"
                },
                {
                    "kind": "Variable",
                    "name": "suppressDraftPropertyUpdate",
                    "variableName": "suppressDraftPropertyUpdate"
                }
            ],
            "kind": "ScalarField",
            "name": "removeContentState"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5d42554987a7deb7d918e30e0c782f3d",
            "id": "6ff16a4a9a4ee0c23a78cff28ab639a88978f4bf29a6d1536290b0ed4211323b",
            "metadata": {},
            "name": "EditorContentStateComponentRemoveContentStateAndPublishMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentRemoveContentStateAndPublishMutation($contentId:ID!,$doPublish:Boolean,$suppressDraftPropertyUpdate:Boolean){removeContentState(contentId:$contentId,doPublish:$doPublish,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate)}"
        }
    };
}();
$4f8f3df3514c68cc$var$node.hash = "026930d5205574a785b2cb15e054e188";
var $4f8f3df3514c68cc$export$2e2bcd8739ae039 = $4f8f3df3514c68cc$var$node;


/**
 * @generated SignedSource<<69e042a0e951839f69fc8fadbc8133c3>>
 * @relayHash 00432588237c35020eabadd88a19f1e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 389b5f223a40ee0ff7e763305001da55ecad5e2e73dacfaf2a80a389635ad5c5
const $6e181beeac9c50b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStateInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "suppressDraftPropertyUpdate"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentStateInput"
                },
                {
                    "kind": "Variable",
                    "name": "suppressDraftPropertyUpdate",
                    "variableName": "suppressDraftPropertyUpdate"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "setContentStateAndPublish",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "00432588237c35020eabadd88a19f1e9",
            "id": "389b5f223a40ee0ff7e763305001da55ecad5e2e73dacfaf2a80a389635ad5c5",
            "metadata": {},
            "name": "EditorContentStateComponentSetContentStateAndPublishMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentSetContentStateAndPublishMutation($contentId:ID!,$contentStateInput:ContentStateInput!,$suppressDraftPropertyUpdate:Boolean,$cloudId:ID!){setContentStateAndPublish(cloudId:$cloudId,contentId:$contentId,contentState:$contentStateInput,suppressDraftPropertyUpdate:$suppressDraftPropertyUpdate){name,color,id,restrictionLevel}}"
        }
    };
}();
$6e181beeac9c50b9$var$node.hash = "ceadf0b25d9333173e88de88519cfc8d";
var $6e181beeac9c50b9$export$2e2bcd8739ae039 = $6e181beeac9c50b9$var$node;


/**
 * @generated SignedSource<<39101869367651ed62d9a14d0b55945a>>
 * @relayHash 21160f4c08969a5c7a1dd4965219e591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ffc88b0828b5ecff8c5d4370181b8f3911e255debdd1d51343da5a90c2c445b9
const $428215775b659cb2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStateInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentStateInput"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "setContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentSetContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentSetContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21160f4c08969a5c7a1dd4965219e591",
            "id": "ffc88b0828b5ecff8c5d4370181b8f3911e255debdd1d51343da5a90c2c445b9",
            "metadata": {},
            "name": "EditorContentStateComponentSetContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentSetContentStateMutation($contentId:ID!,$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId,contentState:$contentStateInput){name,color,id,restrictionLevel}}"
        }
    };
}();
$428215775b659cb2$var$node.hash = "60cf99b28a7e5ae862709c088b41effb";
var $428215775b659cb2$export$2e2bcd8739ae039 = $428215775b659cb2$var$node;


/**
 * @generated SignedSource<<8467b4f40f470a67e40da3ccba4cdd98>>
 * @relayHash 370782061cad5b018a7abb99340247cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5de0f70aba791c6859f3a88d7e11961699651b6e643b08c9b5dd24567157c729
const $da22f1c63dfdcbcc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "kind": "ScalarField",
            "name": "removeContentState"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorContentStateComponentRemoveContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorContentStateComponentRemoveContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "370782061cad5b018a7abb99340247cc",
            "id": "5de0f70aba791c6859f3a88d7e11961699651b6e643b08c9b5dd24567157c729",
            "metadata": {},
            "name": "EditorContentStateComponentRemoveContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation EditorContentStateComponentRemoveContentStateMutation($contentId:ID!){removeContentState(contentId:$contentId)}"
        }
    };
}();
$da22f1c63dfdcbcc$var$node.hash = "239fd93c05e6cc0bc826fd776d1a8efd";
var $da22f1c63dfdcbcc$export$2e2bcd8739ae039 = $da22f1c63dfdcbcc$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $g5lKx = parcelRequire("g5lKx");


var $7aRa9 = parcelRequire("7aRa9");


var $laFNM = parcelRequire("laFNM");


var $2QUbq = parcelRequire("2QUbq");


var $jmjWc = parcelRequire("jmjWc");


const $b4b201f77954c660$export$64f482d2cfabd4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "h7-4D",
    name: "ApprovalActionConfirmationModal",
    loader: async ()=>(await (parcelRequire("ikX4p"))).ApprovalActionConfirmationModal
});






const $b9e4b1108156656e$export$e3890091771f43d6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5zzIF",
    name: "ChangeStatusAndCancelApprovalModal",
    loader: async ()=>(await (parcelRequire("35oNg"))).ChangeStatusAndCancelApprovalModal
});






const $5fbc7aa463b11615$export$666ae2a1d01b224a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gU_WY",
    name: "CancelApprovalModal",
    loader: async ()=>(await (parcelRequire("9E7R3"))).CancelApprovalModal
});



var $3jwuS = parcelRequire("3jwuS");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $308Wd = parcelRequire("308Wd");


var $1vpkQ = parcelRequire("1vpkQ");


var $jln20 = parcelRequire("jln20");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");


var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<97e8e7ee63ed39a7a914845b3a713e09>>
 * @relayHash f27419cc2a41803e37b81fbaa9e240db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f85fe9fd52a5b3bd2cfe98ec4942522a0d6ec515fc73a02aec597a4ccb039edf
const $e0338e3998362f07$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUserProfileDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUserProfileDataQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f27419cc2a41803e37b81fbaa9e240db",
            "id": "f85fe9fd52a5b3bd2cfe98ec4942522a0d6ec515fc73a02aec597a4ccb039edf",
            "metadata": {},
            "name": "useUserProfileDataQuery",
            "operationKind": "query",
            "text": "query useUserProfileDataQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}"
        }
    };
}();
$e0338e3998362f07$var$node.hash = "b2eb262782f15f63fa811f144e86e487";
var $e0338e3998362f07$export$2e2bcd8739ae039 = $e0338e3998362f07$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $1b65ee0f5f746ca1$export$54fd6c163aea68e2 = (accountId)=>{
    const $ = (0, $frIzR.c)(12);
    let t0;
    if ($[0] !== accountId) {
        t0 = {
            accountIds: accountId ? [
                accountId
            ] : []
        };
        $[0] = accountId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !accountId;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $e0338e3998362f07$export$2e2bcd8739ae039), {
        ...t2,
        __callerPackage__: "@confluence/content-state"
    });
    const userNode = data?.confluenceUsers?.nodes?.[0];
    let updatedBy;
    if (userNode && userNode.displayName) {
        const accountIdValue = userNode.accountId;
        if (accountIdValue) {
            const t3 = userNode.profilePicture?.path;
            let t4;
            if ($[5] !== accountIdValue || $[6] !== t3 || $[7] !== userNode.displayName) {
                t4 = {
                    displayName: userNode.displayName,
                    avatarUrl: t3,
                    userId: accountIdValue
                };
                $[5] = accountIdValue;
                $[6] = t3;
                $[7] = userNode.displayName;
                $[8] = t4;
            } else t4 = $[8];
            updatedBy = t4;
        }
    }
    let t3;
    if ($[9] !== loading || $[10] !== updatedBy) {
        t3 = {
            updatedBy: updatedBy,
            loading: loading
        };
        $[9] = loading;
        $[10] = updatedBy;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
};



var $8miSe = parcelRequire("8miSe");











var $imt6g = parcelRequire("imt6g");


var $cO1el = parcelRequire("cO1el");


var $gITTQ = parcelRequire("gITTQ");


var $bJRX9 = parcelRequire("bJRX9");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $aoVih = parcelRequire("aoVih");


var $9hlns = parcelRequire("9hlns");














var $euL71 = parcelRequire("euL71");











var $4S6vT = parcelRequire("4S6vT");











var $4BqOc = parcelRequire("4BqOc");




var $fVUfS = parcelRequire("fVUfS");





const $3880951f7018d493$var$styles = {
    wrapper: "_1bsb1gwv _bfhk1bhr _16qs130s",
    changeBtn: "_1yt4pxbi _1bsb1osq _bfhksm61 _uwhke4h9 _15a5nqa1 _1i531l7x _y3gn1e5h _irr31dpa"
};
const $3880951f7018d493$var$i18n = (0, $aXWIB.defineMessages)({
    changeStatus: {
        id: "content-state.popup-base.change-status",
        defaultMessage: "Change status"
    }
});
const $3880951f7018d493$export$7f90d9bc9f9f2bd4 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, footer: footer } = t0;
    let t1;
    if ($[0] !== children || $[1] !== footer) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $3880951f7018d493$var$styles.wrapper,
            space: "space.050"
        }, children, footer);
        $[0] = children;
        $[1] = footer;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $3880951f7018d493$export$4ea950e74969538a = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onClick: onClick, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $3880951f7018d493$var$styles.changeBtn,
            onClick: onClick
        }, children);
        $[0] = children;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $3880951f7018d493$export$1d5dafbf93c17eee = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { onClick: onClick, label: label } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label ?? formatMessage($3880951f7018d493$var$i18n.changeStatus);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    const buttonLabel = t1;
    let t2;
    if ($[3] !== buttonLabel) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
            label: buttonLabel
        });
        $[3] = buttonLabel;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== buttonLabel || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center"
        }, t2, buttonLabel));
        $[5] = buttonLabel;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== onClick || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3880951f7018d493$export$4ea950e74969538a, {
            onClick: onClick
        }, t3);
        $[8] = onClick;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



var $917iu = parcelRequire("917iu");

var $8uR5k = parcelRequire("8uR5k");

var $d6omw = parcelRequire("d6omw");

const $1c1fbaf2024b64b3$export$75233be2408e9faa = ({ lastRelevantDate: lastRelevantDate, intl: intl })=>{
    // Convert string (milliseconds) to Date
    const date = new Date(parseInt(lastRelevantDate, 10));
    const now = new Date();
    const diffInMinutes = (0, $d6omw.default)(now, date);
    const diffInHours = (0, $8uR5k.default)(now, date);
    const diffInDays = (0, $917iu.default)(now, date);
    // Create a RelativeTimeFormat instance for the intl locale
    const rtf = new Intl.RelativeTimeFormat(intl.locale || 'en-US', {
        numeric: 'always',
        style: 'narrow'
    });
    if (diffInMinutes < 1) return {
        type: 'relative',
        value: 'now'
    };
    if (diffInMinutes < 60) // Returns something like "5m ago" with numeric: 'auto'
    return {
        type: 'relative',
        value: rtf.format(-diffInMinutes, 'minute')
    };
    if (diffInHours < 24) // Returns something like "3h ago" with numeric: 'auto'
    return {
        type: 'relative',
        value: rtf.format(-diffInHours, 'hour')
    };
    if (diffInDays <= 7) // Returns something like "2d ago" with numeric: 'auto'
    return {
        type: 'relative',
        value: rtf.format(-diffInDays, 'day')
    };
    // For >7 days, use truncated date format (Aug 8, 2018)
    const formattedDate = intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    return {
        type: 'absolute',
        value: formattedDate
    };
};









var $esRft = parcelRequire("esRft");







var $a6t12 = parcelRequire("a6t12");

const $61bfb0a94444c1f4$export$1b0eac9d6652f18c = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { avatarUrl: avatarUrl, displayName: displayName, userId: userId } = t0;
    let t1;
    if ($[0] !== avatarUrl || $[1] !== displayName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarUrl,
            name: displayName,
            size: "xsmall"
        });
        $[0] = avatarUrl;
        $[1] = displayName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== displayName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small"
        }, displayName);
        $[3] = displayName;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3 || $[9] !== userId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId
        }, t3);
        $[8] = t3;
        $[9] = userId;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};












var $1s5hv = parcelRequire("1s5hv");













var $1bHXt = parcelRequire("1bHXt");









var $6R5uz = parcelRequire("6R5uz");


var $2Pg7f = parcelRequire("2Pg7f");

const $b46c8b8b93feb0bd$var$MAX_AVATARS_SHOWN = 2;
const $b46c8b8b93feb0bd$var$styles = {
    approvalStatusButton: "_1yt4pxbi _2rko1qi0 _1h6d1l7x _189ee4h9 _1dqonqa1 _syazi7uo _bfhksm61 _irr31dpa _1di6fcek",
    approvalStatusContainer: "_19bvpxbi _u5f3pxbi _n3tdpxbi",
    fullWidth: "_1bsb1osq",
    chevronContainer: ""
};
const $b46c8b8b93feb0bd$export$6f1e346faba6dd06 = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { children: children, onClick: onClick, avatarProps: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const avatarProps = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $1bHXt.cx)($b46c8b8b93feb0bd$var$styles.fullWidth, $b46c8b8b93feb0bd$var$styles.approvalStatusContainer);
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $1bHXt.cx)($b46c8b8b93feb0bd$var$styles.approvalStatusButton, $b46c8b8b93feb0bd$var$styles.fullWidth);
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== avatarProps) {
        t5 = avatarProps && avatarProps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            inert: "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
            size: "small",
            appearance: "stack",
            data: avatarProps,
            maxCount: $b46c8b8b93feb0bd$var$MAX_AVATARS_SHOWN
        }));
        $[4] = avatarProps;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            justifyContent: "center",
            direction: "column",
            xcss: $b46c8b8b93feb0bd$var$styles.chevronContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: ""
        }));
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            gap: "space.150",
            alignItems: "center"
        }, t5, t6);
        $[7] = t5;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== children || $[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            xcss: $b46c8b8b93feb0bd$var$styles.fullWidth,
            justifyContent: "space-between",
            alignItems: "center",
            gap: "space.200"
        }, children, t7);
        $[9] = children;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== onClick || $[13] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: t4,
            onClick: onClick,
            testId: "approval-status-button"
        }, t8));
        $[12] = onClick;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    return t9;
};


const $90f769427d65b87f$var$i18n = (0, $aXWIB.defineMessages)({
    startApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.start-approval-title",
        defaultMessage: "Start approval"
    },
    startApprovalDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.start-approval-description",
        defaultMessage: "Get feedback and move work forward"
    }
});
const $90f769427d65b87f$export$96dd91754b6dc986 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($90f769427d65b87f$var$i18n.startApprovalTitle);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall"
        }, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage($90f769427d65b87f$var$i18n.startApprovalDescription);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "column",
            alignItems: "start",
            gap: "space.025"
        }, t2, t4);
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== onClick || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b46c8b8b93feb0bd$export$6f1e346faba6dd06), {
            onClick: onClick
        }, t5);
        $[11] = onClick;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
};



















var $j3QkC = parcelRequire("j3QkC");


const $71ab3b007df7d173$var$styles = {
    fullWidth: "_1bsb1osq",
    progressRow: "_1bsbd36x",
    textContainer: "_1o9zidpf _y3gnv2br",
    approvedTextContainer: "_1reo15vq _18m915vq _y3gnv2br _p12fd36x _1e0ccj1k _1yyjcs5v _sudp1e54",
    progressBarContainer: "_16jlkb7n _1ul9idpf"
};
const $71ab3b007df7d173$var$i18n = (0, $aXWIB.defineMessages)({
    inProgressApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.in-progress-title",
        defaultMessage: "Approval in progress"
    },
    inProgressApprovalDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.in-progress-description",
        defaultMessage: "{approvalCount}/{approverCount} approved"
    },
    approvedApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.approved-approval-title",
        defaultMessage: "Approved by"
    },
    approvedApprovalDescription: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.approved-approval-description",
        defaultMessage: "{approver} and {count} {count, plural, one {other} other {others}}"
    },
    declinedApprovalTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.declined-approval-title",
        defaultMessage: "Approval declined"
    },
    changesRequestedTitle: {
        id: "content-state.contentStateInfoPopup.approvalStatusButton.changes-requested-title",
        defaultMessage: "Changes requested by"
    }
});
var $71ab3b007df7d173$export$fe3858f0a023b119 = /*#__PURE__*/ function(InProgressApprovalButtonVariant) {
    InProgressApprovalButtonVariant["IN_PROGRESS"] = "in-progress";
    InProgressApprovalButtonVariant["APPROVED"] = "approved";
    InProgressApprovalButtonVariant["DECLINED"] = "declined";
    InProgressApprovalButtonVariant["CHANGES_REQUESTED"] = "changes-requested";
    return InProgressApprovalButtonVariant;
}({});
const $71ab3b007df7d173$var$getApprovedDescription = (approvers, formatMessage)=>{
    if (approvers.length === 1) return approvers[0].name;
    return formatMessage($71ab3b007df7d173$var$i18n.approvedApprovalDescription, {
        approver: approvers[0].name,
        count: approvers.length - 1
    });
};
const $71ab3b007df7d173$var$getChangesRequestedDescription = (approvers, formatMessage)=>{
    const deniedApprovers = approvers.filter((a)=>a.status === 'REVIEWER_DENIED');
    if (deniedApprovers.length === 0) return '';
    if (deniedApprovers.length === 1) return deniedApprovers[0].name;
    return formatMessage($71ab3b007df7d173$var$i18n.approvedApprovalDescription, {
        approver: deniedApprovers[0].name,
        count: deniedApprovers.length - 1
    });
};
const $71ab3b007df7d173$var$getTitle = (variant, formatMessage)=>{
    switch(variant){
        case "in-progress":
            return formatMessage($71ab3b007df7d173$var$i18n.inProgressApprovalTitle);
        case "approved":
            return formatMessage($71ab3b007df7d173$var$i18n.approvedApprovalTitle);
        case "changes-requested":
            return formatMessage($71ab3b007df7d173$var$i18n.changesRequestedTitle);
        case "declined":
        default:
            return formatMessage($71ab3b007df7d173$var$i18n.declinedApprovalTitle);
    }
};
const $71ab3b007df7d173$var$getDescription = (variant, approvers, approvalCount, approverCount, formatMessage)=>{
    switch(variant){
        case "in-progress":
        case "declined":
            return formatMessage($71ab3b007df7d173$var$i18n.inProgressApprovalDescription, {
                approvalCount: approvalCount,
                approverCount: approverCount
            });
        case "changes-requested":
            return $71ab3b007df7d173$var$getChangesRequestedDescription(approvers, formatMessage);
        case "approved":
        default:
            return $71ab3b007df7d173$var$getApprovedDescription(approvers, formatMessage);
    }
};
const $71ab3b007df7d173$export$c6f6523970aaa235 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { onClick: onClick, approvalCount: approvalCount, approverCount: approverCount, approvers: approvers, variant: t1 } = t0;
    const variant = t1 === undefined ? "in-progress" : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== variant) {
        t2 = $71ab3b007df7d173$var$getTitle(variant, formatMessage);
        $[0] = formatMessage;
        $[1] = variant;
        $[2] = t2;
    } else t2 = $[2];
    const title = t2;
    let t3;
    if ($[3] !== approvalCount || $[4] !== approverCount || $[5] !== approvers || $[6] !== formatMessage || $[7] !== variant) {
        t3 = $71ab3b007df7d173$var$getDescription(variant, approvers, approvalCount, approverCount, formatMessage);
        $[3] = approvalCount;
        $[4] = approverCount;
        $[5] = approvers;
        $[6] = formatMessage;
        $[7] = variant;
        $[8] = t3;
    } else t3 = $[8];
    const description = t3;
    let t4;
    if ($[9] !== approvers) {
        t4 = $71ab3b007df7d173$var$getAvatarData(approvers);
        $[9] = approvers;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, title);
        $[11] = title;
        $[12] = t5;
    } else t5 = $[12];
    const t6 = variant === "approved" || variant === "changes-requested" ? $71ab3b007df7d173$var$styles.approvedTextContainer : $71ab3b007df7d173$var$styles.textContainer;
    let t7;
    if ($[13] !== description) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "medium",
            weight: "medium"
        }, description);
        $[13] = description;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t6
        }, t7);
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== variant) {
        t9 = variant === "in-progress" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $71ab3b007df7d173$var$styles.progressBarContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j3QkC.ApprovalsProgressBar), null));
        $[18] = variant;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t8 || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "row",
            gap: "space.100",
            alignItems: "center",
            xcss: $71ab3b007df7d173$var$styles.progressRow
        }, t8, t9);
        $[20] = t8;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "column",
            alignItems: "start",
            gap: "space.025",
            xcss: $71ab3b007df7d173$var$styles.fullWidth
        }, t5, t10);
        $[23] = t10;
        $[24] = t5;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== onClick || $[27] !== t11 || $[28] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b46c8b8b93feb0bd$export$6f1e346faba6dd06), {
            onClick: onClick,
            avatarProps: t4
        }, t11);
        $[26] = onClick;
        $[27] = t11;
        $[28] = t4;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
function $71ab3b007df7d173$var$getAvatarData(approvers) {
    return approvers.map((approver)=>{
        const status = approver.status === 'REVIEWER_APPROVED' ? 'approved' : approver.status === 'REVIEWER_DENIED' ? 'declined' : undefined;
        return {
            appearance: 'circle',
            src: approver.avatarUrl,
            status: status,
            name: undefined,
            // Atlaskit requires no name for decorative non-button avatars
            size: 'small'
        };
    });
}


const $df5c0845c72ee01f$var$styles = {
    statusInfo: "_1yt4pxbi",
    updateMetadata: "_1n261g80",
    otherModeWarningWrapper: "_2rko1mok _1reo15vq _18m915vq _195gpxbi _6rthutpp"
};
const $df5c0845c72ee01f$var$i18n = (0, $aXWIB.defineMessages)({
    cancelApproval: {
        id: "content-state.contentStateInfoPopup.cancel-approval-button.text",
        defaultMessage: "Cancel approval"
    },
    updatedByUser: {
        id: "content-state.contentStateInfoPopup.updated-by-user",
        defaultMessage: "Updated {time} by"
    },
    updated: {
        id: "content-state.contentStateInfoPopup.updated",
        defaultMessage: "Updated {time}"
    },
    updatedOnByUser: {
        id: "content-state.contentStateInfoPopup.updated-on-by-user",
        defaultMessage: "Updated on {date} by"
    },
    updatedOn: {
        id: "content-state.contentStateInfoPopup.updated-on",
        defaultMessage: "Updated on {date}"
    },
    updatedByUserOnly: {
        id: "content-state.contentStateInfoPopup.updated-by-user-only",
        defaultMessage: "Updated by"
    },
    otherModeReviewWarningEdit: {
        id: "content-state.contentStateInfoPopup.other-mode-review-warning-edit",
        defaultMessage: "The published version of this page is under review. Complete or cancel that review in order to start a new one here in the editor."
    },
    otherModeReviewWarningView: {
        id: "content-state.contentStateInfoPopup.other-mode-review-warning-view",
        defaultMessage: "The draft version of this page is under review. Complete or cancel that review in order to start a new one here in the published view."
    }
});
const $df5c0845c72ee01f$export$53d4fd7383e067f = (t0)=>{
    const $ = (0, $frIzR.c)(90);
    const { contentState: contentState, activeWorkflowStatus: activeWorkflowStatus, updatedBy: updatedBy, updatedAt: updatedAt, loading: t1, onChangeStatus: onChangeStatus, onClearRequest: onClearRequest, onClose: onClose, canEdit: t2, contentType: contentType, isViewMode: t3 } = t0;
    const loading = t1 === undefined ? false : t1;
    const canEdit = t2 === undefined ? true : t2;
    const isViewMode = t3 === undefined ? false : t3;
    const intl = (0, $aXWIB.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { approvalRequest: approvalRequest, hasEditPermission: hasEditPermission, approvalProgress: approvalProgress, otherModeReviewStatus: otherModeReviewStatus, contentId: contentId, contentStatus: contentStatus } = (0, $laFNM.useApprovals)();
    const approvers = approvalRequest?.review?.approvers;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    let t4;
    if ($[0] !== contentId || $[1] !== contentStatus || $[2] !== onClose || $[3] !== rightSidebarContext) {
        t4 = ()=>{
            if (rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID) && (0, $9wGTI.fg)("confluence_approvals_improvements_batch_1")) {
                onClose?.();
                return;
            }
            (0, $1vpkQ.openApprovalsPaneForContext)({
                contentId: contentId,
                contentStatus: contentStatus,
                rightSidebarContext: rightSidebarContext
            });
        };
        $[0] = contentId;
        $[1] = contentStatus;
        $[2] = onClose;
        $[3] = rightSidebarContext;
        $[4] = t4;
    } else t4 = $[4];
    const handleApprovalStatusButtonClick = t4;
    let t5;
    if ($[5] !== contentId || $[6] !== contentStatus || $[7] !== createAnalyticsEvent || $[8] !== handleApprovalStatusButtonClick) {
        t5 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "startApproval",
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: {
                        contentId: contentId,
                        contentStatus: contentStatus
                    }
                }
            }).fire();
            handleApprovalStatusButtonClick();
        };
        $[5] = contentId;
        $[6] = contentStatus;
        $[7] = createAnalyticsEvent;
        $[8] = handleApprovalStatusButtonClick;
        $[9] = t5;
    } else t5 = $[9];
    const handleStartApprovalClick = t5;
    const isActiveReview = !!approvalRequest?.review && approvalRequest?.review?.reviewStatus !== "CANCELED";
    const approvalStatus = approvalRequest?.review?.reviewStatus;
    const hasOtherModePendingReview = otherModeReviewStatus === "PENDING";
    const wouldShowStartApproval = !isActiveReview && activeWorkflowStatus?.allowsReviews && hasEditPermission;
    const showOtherModeWarning = hasOtherModePendingReview && wouldShowStartApproval;
    let t6;
    if ($[10] !== approvers) {
        t6 = approvers ?? [];
        $[10] = approvers;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t6) {
        t7 = t6.filter($df5c0845c72ee01f$var$_temp);
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    const approvalCount = t7.length;
    const displayName = activeWorkflowStatus?.name ?? contentState?.name;
    let StatusButton;
    let T0;
    let T1;
    let t10;
    let t11;
    let t8;
    let t9;
    if ($[14] !== activeWorkflowStatus || $[15] !== approvalCount || $[16] !== approvalProgress || $[17] !== approvalStatus || $[18] !== approvers || $[19] !== contentState?.color || $[20] !== displayName || $[21] !== handleApprovalStatusButtonClick || $[22] !== handleStartApprovalClick || $[23] !== hasEditPermission || $[24] !== intl || $[25] !== isActiveReview || $[26] !== isPremium || $[27] !== loading || $[28] !== showOtherModeWarning || $[29] !== updatedAt || $[30] !== updatedBy) {
        const timeData = updatedAt ? (0, $1c1fbaf2024b64b3$export$75233be2408e9faa)({
            lastRelevantDate: updatedAt,
            intl: intl
        }) : null;
        const shouldHideRecentUpdateMetadata = timeData?.type === "relative" && timeData.value === "now";
        let t12;
        if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = {
                PENDING: (0, $71ab3b007df7d173$export$fe3858f0a023b119).IN_PROGRESS,
                APPROVED: (0, $71ab3b007df7d173$export$fe3858f0a023b119).APPROVED,
                DENIED: (0, $9wGTI.fg)("hello_100_release_updates") ? (0, $71ab3b007df7d173$export$fe3858f0a023b119).CHANGES_REQUESTED : (0, $71ab3b007df7d173$export$fe3858f0a023b119).DECLINED
            };
            $[38] = t12;
        } else t12 = $[38];
        const approvalStatusToVariant = t12;
        let t13;
        if ($[39] !== activeWorkflowStatus?.allowsReviews || $[40] !== approvalCount || $[41] !== approvalProgress || $[42] !== approvalStatus || $[43] !== approvers || $[44] !== handleApprovalStatusButtonClick || $[45] !== handleStartApprovalClick || $[46] !== hasEditPermission || $[47] !== isActiveReview || $[48] !== isPremium || $[49] !== showOtherModeWarning) {
            t13 = ()=>{
                if (!isPremium) return null;
                if (isActiveReview) {
                    const variant = approvalStatus ? approvalStatusToVariant[approvalStatus] : undefined;
                    if (!variant) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71ab3b007df7d173$export$c6f6523970aaa235), {
                        approvalCount: approvalCount,
                        approverCount: approvalProgress.total || 0,
                        variant: variant,
                        onClick: handleApprovalStatusButtonClick,
                        approvers: approvers ?? []
                    });
                }
                if (activeWorkflowStatus?.allowsReviews && hasEditPermission && !showOtherModeWarning) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90f769427d65b87f$export$96dd91754b6dc986), {
                    onClick: handleStartApprovalClick
                });
                return null;
            };
            $[39] = activeWorkflowStatus?.allowsReviews;
            $[40] = approvalCount;
            $[41] = approvalProgress;
            $[42] = approvalStatus;
            $[43] = approvers;
            $[44] = handleApprovalStatusButtonClick;
            $[45] = handleStartApprovalClick;
            $[46] = hasEditPermission;
            $[47] = isActiveReview;
            $[48] = isPremium;
            $[49] = showOtherModeWarning;
            $[50] = t13;
        } else t13 = $[50];
        StatusButton = t13;
        let t14;
        if ($[51] !== activeWorkflowStatus || $[52] !== contentState?.color) {
            t14 = ()=>{
                if (activeWorkflowStatus) {
                    const isChangesRequested = activeWorkflowStatus.id === "3" && (0, $9wGTI.fg)("hello_100_release_updates");
                    let WorkflowIcon;
                    let iconColor;
                    if (isChangesRequested) {
                        WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bJRX9)));
                        iconColor = "var(--ds-icon-accent-blue, #357DE8)";
                    } else if (activeWorkflowStatus.allowsReviews) {
                        WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($gITTQ)));
                        iconColor = "var(--ds-icon-accent-blue, #357DE8)";
                    } else {
                        WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($imt6g)));
                        iconColor = "var(--ds-icon-accent-lime, #6A9A23)";
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WorkflowIcon, {
                        label: "",
                        color: iconColor
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
                    color: contentState?.color,
                    appearance: "contentStateInfoPopup"
                });
            };
            $[51] = activeWorkflowStatus;
            $[52] = contentState?.color;
            $[53] = t14;
        } else t14 = $[53];
        const renderStatusIcon = t14;
        T1 = (0, $3880951f7018d493$export$7f90d9bc9f9f2bd4);
        T0 = (0, $eyWa4.default);
        t8 = $df5c0845c72ee01f$var$styles.statusInfo;
        t9 = "space.100";
        let t15;
        if ($[54] !== renderStatusIcon) {
            t15 = renderStatusIcon();
            $[54] = renderStatusIcon;
            $[55] = t15;
        } else t15 = $[55];
        let t16;
        if ($[56] !== displayName) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "h2",
                size: "medium"
            }, displayName);
            $[56] = displayName;
            $[57] = t16;
        } else t16 = $[57];
        if ($[58] !== t15 || $[59] !== t16) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center"
            }, t15, t16);
            $[58] = t15;
            $[59] = t16;
            $[60] = t10;
        } else t10 = $[60];
        t11 = !shouldHideRecentUpdateMetadata && (timeData || updatedBy || loading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: loading ? "center" : "start",
            xcss: $df5c0845c72ee01f$var$styles.updateMetadata
        }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small",
            interactionName: "content-state-info-popup"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, timeData && updatedBy && timeData.type === "relative" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedByUser, {
            time: timeData.value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61bfb0a94444c1f4$export$1b0eac9d6652f18c), updatedBy)), timeData && updatedBy && timeData.type === "absolute" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedOnByUser, {
            date: timeData.value
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61bfb0a94444c1f4$export$1b0eac9d6652f18c), updatedBy)), timeData && !updatedBy && timeData.type === "relative" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updated, {
            time: timeData.value
        })), timeData && !updatedBy && timeData.type === "absolute" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedOn, {
            date: timeData.value
        })), !timeData && updatedBy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, intl.formatMessage($df5c0845c72ee01f$var$i18n.updatedByUserOnly)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61bfb0a94444c1f4$export$1b0eac9d6652f18c), updatedBy))));
        $[14] = activeWorkflowStatus;
        $[15] = approvalCount;
        $[16] = approvalProgress;
        $[17] = approvalStatus;
        $[18] = approvers;
        $[19] = contentState?.color;
        $[20] = displayName;
        $[21] = handleApprovalStatusButtonClick;
        $[22] = handleStartApprovalClick;
        $[23] = hasEditPermission;
        $[24] = intl;
        $[25] = isActiveReview;
        $[26] = isPremium;
        $[27] = loading;
        $[28] = showOtherModeWarning;
        $[29] = updatedAt;
        $[30] = updatedBy;
        $[31] = StatusButton;
        $[32] = T0;
        $[33] = T1;
        $[34] = t10;
        $[35] = t11;
        $[36] = t8;
        $[37] = t9;
    } else {
        StatusButton = $[31];
        T0 = $[32];
        T1 = $[33];
        t10 = $[34];
        t11 = $[35];
        t8 = $[36];
        t9 = $[37];
    }
    let t12;
    if ($[61] !== T0 || $[62] !== t10 || $[63] !== t11 || $[64] !== t8 || $[65] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t8,
            space: t9
        }, t10, t11);
        $[61] = T0;
        $[62] = t10;
        $[63] = t11;
        $[64] = t8;
        $[65] = t9;
        $[66] = t12;
    } else t12 = $[66];
    let t13;
    if ($[67] !== intl || $[68] !== isViewMode || $[69] !== showOtherModeWarning) {
        t13 = showOtherModeWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $df5c0845c72ee01f$var$styles.otherModeWarningWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
            appearance: "warning"
        }, intl.formatMessage(isViewMode ? $df5c0845c72ee01f$var$i18n.otherModeReviewWarningView : $df5c0845c72ee01f$var$i18n.otherModeReviewWarningEdit)));
        $[67] = intl;
        $[68] = isViewMode;
        $[69] = showOtherModeWarning;
        $[70] = t13;
    } else t13 = $[70];
    let t14;
    if ($[71] !== StatusButton || $[72] !== contentType || $[73] !== isViewMode) {
        t14 = !(isViewMode && contentType === "blogpost") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StatusButton, null);
        $[71] = StatusButton;
        $[72] = contentType;
        $[73] = isViewMode;
        $[74] = t14;
    } else t14 = $[74];
    let t15;
    if ($[75] !== approvalStatus || $[76] !== canEdit || $[77] !== contentType || $[78] !== intl || $[79] !== isActiveReview || $[80] !== isViewMode || $[81] !== onChangeStatus || $[82] !== onClearRequest) {
        t15 = canEdit && !(isViewMode && contentType === "blogpost") && (isActiveReview && approvalStatus === "PENDING" && onClearRequest ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3880951f7018d493$export$4ea950e74969538a), {
            onClick: onClearRequest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            color: "color.text.subtle"
        }, intl.formatMessage($df5c0845c72ee01f$var$i18n.cancelApproval))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3880951f7018d493$export$1d5dafbf93c17eee), {
            onClick: onChangeStatus
        }));
        $[75] = approvalStatus;
        $[76] = canEdit;
        $[77] = contentType;
        $[78] = intl;
        $[79] = isActiveReview;
        $[80] = isViewMode;
        $[81] = onChangeStatus;
        $[82] = onClearRequest;
        $[83] = t15;
    } else t15 = $[83];
    let t16;
    if ($[84] !== T1 || $[85] !== t12 || $[86] !== t13 || $[87] !== t14 || $[88] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T1, null, t12, t13, t14, t15);
        $[84] = T1;
        $[85] = t12;
        $[86] = t13;
        $[87] = t14;
        $[88] = t15;
        $[89] = t16;
    } else t16 = $[89];
    return t16;
};
function $df5c0845c72ee01f$var$_temp(a) {
    return a.status === "REVIEWER_APPROVED";
}




















const $9e4d91f280782e61$var$styles = {
    body: "_1yt4pxbi"
};
const $9e4d91f280782e61$var$i18n = (0, $aXWIB.defineMessages)({
    heading: {
        id: "content-state.otherModeReviewBlockingPopup.heading",
        defaultMessage: "Approval in progress"
    },
    bodyViewMode: {
        id: "content-state.otherModeReviewBlockingPopup.body-view-mode",
        defaultMessage: "This page has a draft in review. Complete or cancel that review to start a new approval for the published page."
    },
    bodyEditMode: {
        id: "content-state.otherModeReviewBlockingPopup.body-edit-mode",
        defaultMessage: "The published version of this page is in review. Complete or cancel that review to start a new approval for this draft."
    }
});
const $9e4d91f280782e61$export$ef489f24b547890a = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { isViewMode: isViewMode, onChangeStatus: onChangeStatus } = t0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== onChangeStatus) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3880951f7018d493$export$1d5dafbf93c17eee), {
            onClick: onChangeStatus
        });
        $[0] = onChangeStatus;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage($9e4d91f280782e61$var$i18n.heading);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "xsmall"
        }, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = isViewMode ? $9e4d91f280782e61$var$i18n.bodyViewMode : $9e4d91f280782e61$var$i18n.bodyEditMode;
    let t5;
    if ($[6] !== formatMessage || $[7] !== t4) {
        t5 = formatMessage(t4);
        $[6] = formatMessage;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, t5);
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t3 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $9e4d91f280782e61$var$styles.body,
            space: "space.100"
        }, t3, t6);
        $[11] = t3;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t1 || $[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3880951f7018d493$export$7f90d9bc9f9f2bd4), {
            footer: t1
        }, t7);
        $[14] = t1;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
};



var $lJswu = parcelRequire("lJswu");








var $gMc0m = parcelRequire("gMc0m");





var $ghftu = parcelRequire("ghftu");





var $eEA8O = parcelRequire("eEA8O");


var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");


var $6DSrS = parcelRequire("6DSrS");








var $3gadb = parcelRequire("3gadb");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");





var $iquRY = parcelRequire("iquRY");




/* ApprovalsCompletedSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");


var $aWwYt = parcelRequire("aWwYt");













const $e3dc4f9522a67664$export$3c87e1f3199ca8e9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "100%",
        height: "auto",
        viewBox: "0 0 295 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        "clip-path": "url(#clip0_6509_14303)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        opacity: "0.02",
        "clip-path": "url(#clip1_6509_14303)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.776 53.4687C53.8564 50.2591 64.6048 49.4207 71.8615 49.4512C73.6829 49.4785 75.2974 49.5192 76.6724 49.5994C78.0619 49.7189 79.2445 49.8518 80.1684 50.0014C82.0681 50.2972 83.0557 50.676 83.173 51.0788C83.2903 51.4816 82.5563 51.9312 80.9756 52.4114C80.1735 52.6482 79.169 52.882 77.9576 53.1292C76.7607 53.4156 75.3378 53.6925 73.7271 54.0056C67.2652 55.2353 57.6417 56.9666 45.4707 60.2865C36.8568 62.685 28.5398 65.5711 20.6389 69.0661C12.7706 72.5348 5.02964 76.4619 -1.93422 80.8861C-8.87901 85.3331 -15.2336 90.4019 -20.0031 96.2614C-24.8154 102.092 -27.8865 108.791 -27.8654 115.975C-27.7689 123.162 -24.3697 130.715 -18.0249 137.812C-11.7083 144.92 -2.94061 151.523 6.98197 157.44C27.0958 169.314 51.3303 178.869 77.7606 185.628C92.7669 189.512 106.596 192.047 119.303 193.866C132.029 195.708 143.621 196.778 154.349 197.575C175.782 199.072 193.661 199.27 210.258 199.237C226.873 199.138 242.225 198.832 258.285 197.892C274.331 196.913 291.227 195.428 310.267 191.89C326.328 188.923 343.118 184.516 358.834 177.838C366.709 174.529 374.266 170.622 381.234 166.093C388.22 161.587 394.626 156.427 399.947 150.684C405.202 144.906 409.448 138.461 411.829 131.5C414.182 124.549 414.77 117.093 412.629 109.676C411.563 105.995 410.017 102.305 407.72 98.7602C406.717 96.9663 405.287 95.2482 404.068 93.5004C402.577 91.8185 401.278 90.0839 399.586 88.4873C393.299 81.9171 385.26 76.168 376.685 71.258C359.37 61.481 339.617 56.0211 320.877 53.2396C302.103 50.3959 284.311 49.9751 268.33 49.9845C252.298 50.0857 238.093 50.6564 226.294 51.4339C220.422 51.9094 215.066 52.2631 210.422 52.7961C208.096 53.0347 205.9 53.2569 203.888 53.4591C201.887 53.717 200.044 53.9485 198.385 54.1602L192.436 54.9142L186.578 55.7992C182.64 56.351 178.77 57.0272 174.923 57.7099C167.995 58.8811 158.346 60.8877 146.762 64.1054C135.221 67.3525 121.873 71.9874 108.543 79.0431C106.877 79.923 105.202 80.8357 103.504 81.7419C101.905 82.7462 100.279 83.7604 98.6238 84.7844C95.2435 86.8129 92.0719 89.0049 89.1709 91.4129C83.378 96.1959 78.6074 101.967 78.0338 108.546C77.294 114.99 81.4274 122.552 88.811 129.108C96.1002 135.637 106.65 140.846 118.423 144.665C124.317 146.594 130.518 148.237 136.942 149.625C140.136 150.384 143.361 150.941 146.606 151.608C149.863 152.138 153.122 152.757 156.411 153.172C169.575 155.083 183.057 155.934 196.491 155.856C223.392 155.673 249.966 151.343 274.238 143.485C298.497 135.676 320.804 124.452 339.829 111.316C344.396 108.028 348.386 104.528 351.167 100.623C353.907 96.7776 355.441 92.4223 355.261 88.0165C355.106 83.6174 353.201 79.3874 349.491 75.7164C345.809 72.0356 340.509 68.8775 334.697 66.6537C326.531 63.4795 317.512 62.3798 308.798 62.4755C300.056 62.581 291.528 63.8394 283.41 65.4576C267.21 68.7397 253.072 73.8441 241.002 79.9253C228.936 85.9902 218.848 93.0781 210.763 100.455C202.782 107.825 197.127 115.874 193.464 123.98C189.801 132.085 188.125 140.263 187.889 148.011C187.882 151.713 188.363 155.302 189.473 158.731C190.658 162.162 192.162 165.453 194.289 168.51C198.304 174.663 203.712 180.003 209.229 184.579C214.742 189.172 220.44 193.004 225.699 196.309C238.165 204.147 251.531 210.839 264.769 216.985C278.035 223.121 291.304 228.694 304.317 234.001C330.37 244.606 355.485 254.194 379.353 264.248C403.123 274.381 426.095 284.645 446.118 298.134C451.105 301.505 455.84 305.142 460.081 309.101C464.321 313.059 468.174 317.317 471 321.889C476.746 331.061 477.843 341.153 474.68 349.379C474.494 349.962 474.288 350.522 474.11 351.073C473.862 351.604 473.595 352.112 473.351 352.627C472.844 353.633 472.389 354.636 471.834 355.541C470.615 357.285 469.636 358.989 468.39 360.373C467.167 361.764 466.094 363.072 464.962 364.135C463.802 365.207 462.734 366.129 461.746 366.949C457.676 370.092 455.029 371.213 454.252 370.716C453.409 370.183 454.431 368.049 457.02 364.285C457.617 363.321 458.321 362.246 459.146 361.099C459.952 359.928 460.653 358.587 461.574 357.184C462.496 355.781 463.151 354.146 464.093 352.484C464.484 351.622 464.812 350.707 465.193 349.79C465.395 349.334 465.578 348.856 465.785 348.384C465.921 347.892 466.061 347.384 466.202 346.876C468.612 339.536 467.249 331.417 462.292 323.892C459.805 320.118 456.425 316.538 452.59 313.133C448.76 309.711 444.415 306.499 439.738 303.478C420.976 291.308 398.476 281.544 374.941 271.846C351.289 262.205 326.139 252.837 299.728 242.239C286.513 236.928 272.98 231.3 259.27 225.024C245.574 218.698 231.589 211.764 218.081 203.286C212.836 200.02 206.987 196.093 200.977 191.275C194.968 186.457 188.717 180.673 183.474 173.633C178.358 166.593 174.436 158.172 173.834 149.417C173.489 144.965 173.854 140.887 174.452 136.519C175.083 132.214 176.137 127.85 177.718 123.507C180.834 114.81 185.855 106.11 193.127 97.9965C196.74 93.9335 201.013 90.0531 205.609 86.3852C210.19 82.6781 215.281 79.1472 220.807 75.7894C231.854 69.0902 244.755 63.1324 259.595 58.6104C267.025 56.3608 274.938 54.4742 283.28 53.0589C291.627 51.6271 300.694 50.6236 310.645 50.9229C317.141 51.1312 323.851 51.9454 330.693 53.6602C337.498 55.4177 344.095 58.0173 350.1 61.4758C356.048 64.9541 361.46 69.36 365.172 74.4953C368.907 79.6371 370.581 85.1613 370.593 90.1732C370.637 95.6175 368.95 100.618 366.109 105.106C363.278 109.562 359.389 113.337 355.157 116.699C350.902 120.056 346.308 122.983 341.674 125.777C337.056 128.609 332.243 131.317 327.325 133.944C307.617 144.404 285.348 153.01 261.339 158.631C237.31 164.229 211.502 166.707 185.905 165.663C173.124 165.217 160.384 163.794 148.018 161.663C135.656 159.516 123.678 156.717 112.148 152.754C100.67 148.788 89.7517 143.441 81.2253 136.517C72.7988 129.69 66.7865 121.574 64.8409 113.541C63.894 109.522 64.0217 105.66 64.9019 102.2C65.8058 98.746 67.4105 95.6976 69.3248 92.9993C73.1726 87.6257 78.0466 83.5939 82.6551 80.247C92.0818 73.8053 100.231 69.3208 106.216 66.6012C112.058 63.7541 115.484 62.4789 115.484 62.4789C115.484 62.4789 116.74 61.9795 119.11 61.03C121.424 60.0117 125.11 58.8083 129.775 57.1877C139.19 54.0939 153.222 50.1067 171.479 46.9171C189.684 43.6423 212.096 41.319 237.332 40.3583C240.484 40.2595 243.688 40.1574 246.915 40.0618C250.156 40.0054 253.445 39.9622 256.762 39.909C263.392 39.8191 270.216 39.8535 277.21 40.0056C291.19 40.3426 305.948 41.2649 321.188 43.6609C336.423 46.0731 352.153 49.9098 367.262 56.2729C382.205 62.5902 396.194 71.1658 407.084 81.6712C412.519 86.9125 417.104 92.6592 420.42 98.6729C423.737 104.686 425.687 110.957 426.152 116.994C426.665 123.044 425.815 128.876 424.038 134.293C422.233 139.72 419.473 144.741 416.135 149.374C412.792 154.023 408.848 158.277 404.495 162.17C400.127 166.024 395.393 169.548 390.44 172.765C380.552 179.22 369.619 184.311 358.591 188.458C336.469 196.717 313.823 200.898 294.302 203.421C175.383 214.852 112.323 204.229 75.6111 194.875C47.6233 187.686 21.7911 177.477 -0.104841 164.423C-11.0088 157.829 -20.9531 150.336 -28.4577 141.736C-32.1981 137.44 -35.2263 132.864 -37.2862 128.185C-39.318 123.497 -40.367 118.745 -40.3077 114.211C-40.1565 105.117 -36.106 97.1718 -30.4964 90.6626C-24.8732 84.1043 -17.7737 78.73 -10.1393 74.0856C-2.4341 69.4607 5.67446 65.5823 14.1589 62.0899C22.6153 58.6074 31.5348 55.7467 40.7614 53.4294L40.776 53.4687Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M277.604 -1.48903C276.053 0.904158 273.976 2.44629 272.068 3.55908C270.141 4.64897 268.308 5.3063 266.773 5.71108C263.662 6.49118 261.664 6.2741 260.993 5.57717C260.28 4.85081 260.901 3.61181 262.525 1.87371C264.073 0.132401 266.891 -2.1575 268.561 -5.25842C269.676 -7.45452 269.45 -9.66867 268.019 -11.8453C266.541 -14.0351 263.774 -16.2462 260.472 -17.8113C257.298 -19.3766 253.225 -20.4494 248.931 -21.0896C244.59 -21.7428 239.891 -22.0188 234.887 -22.2028C215.034 -22.9815 193.654 -22.6478 172.26 -18.0327C166.213 -16.7413 160.93 -15.2739 156.283 -13.7189C151.698 -12.1115 147.688 -10.4688 144.191 -8.75462C137.146 -5.32294 131.975 -1.77888 127.651 1.82314C123.371 5.45459 119.976 9.18978 117.195 13.5532C114.466 17.9133 112.341 22.9344 111.605 29.2739C111.347 31.9538 111.321 34.8037 111.617 37.7778C111.959 40.7649 112.624 43.8761 113.623 47.0623C115.701 53.4213 119.09 60.09 123.955 66.4785C133.505 79.3474 148.802 90.9122 165.173 99.1409C173.349 103.288 181.725 106.714 189.847 109.312C197.928 112.057 205.755 113.885 212.796 115.338C226.972 118.092 238.193 118.76 244.37 119.021C246.197 119.121 248.032 119.099 249.868 119.165C251.689 119.193 253.535 119.315 255.351 119.27C256.979 119.262 258.96 119.262 261.247 119.26C263.539 119.241 266.101 119.067 268.999 118.969C271.878 118.847 274.975 118.486 278.37 118.243C280.043 118.071 281.763 117.823 283.554 117.595C285.344 117.367 287.205 117.158 289.055 116.805C296.634 115.673 304.787 113.747 313.244 111.181C321.729 108.606 330.397 105.182 338.113 100.613C345.809 96.021 352.423 90.1068 355.938 82.719C359.492 75.377 359.986 66.6955 355.563 58.4361C351.261 50.1044 342.592 42.135 332.258 36.0512C321.829 29.8529 309.648 25.3043 297.285 21.7814C279.717 16.8725 263.409 14.0225 248.796 12.5758C234.149 10.9785 221.318 11.1709 210.117 11.5316C187.82 12.7049 172.43 15.9992 162.203 18.5339C138.239 24.908 119.51 33.5753 105.23 43.79C97.9387 48.8468 91.2838 53.9912 88.5 59.8353C85.6207 65.5648 87.3996 72.5467 91.9001 79.2402C94.3397 82.9127 96.5112 85.7175 97.7048 87.7405C98.9219 89.77 99.2648 91.0111 98.5444 91.4116C97.8758 91.8088 96.1203 91.3588 93.5856 89.7764C91.0745 88.2005 87.6526 85.5086 84.3886 81.3261C81.4253 77.5265 79.0798 73.4215 77.8332 69.1088C76.6057 64.819 76.6369 60.2951 78.2029 56.2836C79.7409 52.282 82.4371 48.777 85.5183 45.6253C88.5849 42.4342 92.1982 39.747 95.8141 36.8665C110.416 25.4885 130.161 15.9027 155.673 9.07476C165.679 6.60259 181.294 2.77078 203.538 1.0537C204.916 0.940661 206.322 0.817765 207.751 0.70139C209.176 0.601409 210.677 0.593054 212.168 0.529024C215.164 0.440248 218.241 0.338257 221.388 0.255844C224.555 0.196347 227.865 0.352888 231.253 0.407773C232.943 0.451604 234.661 0.485561 236.379 0.519521C238.116 0.576396 239.892 0.767527 241.668 0.870216C255.93 1.65561 271.752 3.96563 288.581 7.96477C291.318 8.63301 294.068 9.2521 296.786 9.98588C299.5 10.736 302.224 11.5419 304.911 12.3904C310.303 14.1102 315.684 16.0561 320.913 18.2773C332.141 23.0563 343.568 29.3189 352.888 37.3268C357.528 41.3079 361.627 45.6859 364.91 50.35C368.142 55.0174 370.549 60.0035 371.67 64.9519C373.956 74.878 371.468 84.0663 366.635 91.5311C361.804 99.0843 354.516 104.865 346.94 109.296C339.313 113.731 331.409 116.961 324.076 119.413C320.367 120.61 316.92 121.774 313.532 122.636C311.857 123.09 310.257 123.548 308.704 123.93C307.131 124.289 305.615 124.628 304.179 124.954C301.32 125.645 298.676 126.113 296.351 126.529C294.026 126.945 292.087 127.343 290.409 127.532C287.134 127.985 285.339 128.229 285.339 128.229C285.339 128.229 284.676 128.328 283.412 128.49C282.134 128.613 280.23 128.792 277.781 129.015C275.369 129.283 272.326 129.447 268.799 129.618C265.301 129.868 261.225 129.818 256.76 129.888C247.747 129.778 236.908 129.198 224.832 127.395C212.775 125.614 199.482 122.61 186.12 118.017C172.711 113.499 159.317 107.275 147.197 99.6572C135.069 92.0719 124.396 82.9846 116.457 73.2946C108.564 63.6176 103.438 53.4885 101.116 44.152C98.7234 34.796 99.3468 26.2913 101.34 19.5408C104.43 9.37229 110.385 1.70635 116.67 -4.12228C122.964 -9.98368 129.644 -14.1159 135.817 -17.2419C148.286 -23.4776 158.481 -25.8976 166.123 -27.6299C177.804 -30.186 189.48 -31.3498 200.694 -31.8481C211.945 -32.3006 222.799 -32.0517 233.258 -31.3829C238.452 -31.0583 243.774 -30.6454 249.272 -29.6725C254.736 -28.6734 260.353 -27.1209 265.536 -24.3657C270.567 -21.7053 274.883 -18.1136 277.414 -13.8516C278.632 -11.7336 279.316 -9.42832 279.263 -7.30882C279.258 -5.17628 278.555 -3.18376 277.477 -1.48888L277.604 -1.48903Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M42.7754 35.4C42.7754 32.1415 45.4169 29.5 48.6754 29.5H334.088C337.346 29.5 339.988 32.1415 339.988 35.4V136.438H42.7754V35.4Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "61.9502",
        y: "47.2002",
        width: "97.35",
        height: "7.375",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "259.6",
        height: "7.375",
        transform: "matrix(-1 0 0 1 321.55 94.3994)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "155.613",
        height: "7.375",
        transform: "matrix(-1 0 0 1 217.562 112.1)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "91.4502",
        y: "64.8994",
        width: "27.2875",
        height: "7.375",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "78.5439",
        cy: "68.2188",
        r: "5.53125",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "68.9561",
        cy: "68.2188",
        r: "5.53125",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M219.69 36.7788C220.509 35.6029 219.584 34.7748 218.575 35.7731C217.145 37.1872 215.712 38.7375 213.957 40.8095C212.018 43.203 211.715 43.963 210.351 45.5397C209.207 46.8783 207.663 48.6705 206.139 50.1262C204.647 51.6085 203.323 52.894 202.807 53.3894C202.654 53.5368 202.511 53.6919 202.372 53.8507C201.381 55.0001 197.026 60.029 193.091 64.1883C190.36 67.1716 188.671 69.0168 187.789 69.981C185.709 72.261 184.242 74.0533 182.878 75.8871C182.831 75.9514 182.787 76.0119 182.747 76.0686C182.703 76.1329 182.663 76.1934 182.63 76.2463C182.597 76.4089 182.568 76.5791 182.579 76.6736C182.589 76.7644 182.608 76.8475 182.637 76.9156C182.696 77.0555 182.791 77.1538 182.9 77.203C183.014 77.2521 183.145 77.2483 183.284 77.1916C183.354 77.1614 183.423 77.1198 183.493 77.0631C183.562 77.0063 183.61 76.9837 183.661 76.9345C183.686 76.9232 183.716 76.9118 183.741 76.8967C183.771 76.8778 183.785 76.874 183.836 76.8286C185.537 75.3237 187.19 73.7092 189.285 71.4367C190.097 70.5519 192.002 68.9147 194.426 66.3473C194.821 65.9276 195.194 65.489 195.549 65.039C198.587 61.1294 202.99 56.4937 202.99 56.4937C202.99 56.4937 204.603 54.7355 206.555 52.6067C207.045 52.0735 207.554 51.5177 208.066 50.9619C208.578 50.406 209.093 49.8502 209.554 49.2831C210.497 48.1638 211.368 47.1278 212.018 46.3565C213.971 44.0273 214.915 42.9081 215.492 42.2199C217.237 40.1327 218.527 38.4463 219.687 36.7788H219.69Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M237.166 36.5668C237.272 36.253 236.365 35.3985 236.072 35.5346C235.868 35.6291 235.674 35.7426 235.484 35.8862L236.957 35.8144C236.815 35.6102 236.647 35.4136 236.434 35.2094C235.919 34.8048 235.63 34.888 235.326 34.5628C234.782 34.0524 234.091 32.9256 233.93 32.6534C233.904 32.6118 233.875 32.5815 233.838 32.5551C233.571 32.3698 232.419 31.5417 231.593 30.6418C230.964 30.0557 230.576 29.6927 230.372 29.5037C229.889 29.0613 229.447 28.8193 228.938 28.6681C228.66 28.5849 227.944 29.3978 228.05 29.6776C228.243 30.1843 228.518 30.6153 228.986 31.0729C229.172 31.2468 229.359 31.8366 229.871 32.3887C229.955 32.4794 230.057 32.5475 230.174 32.5967C231.202 33.0088 232.116 34.0259 232.116 34.0259C232.116 34.0259 233.586 35.4174 234.208 36.0035C234.679 36.4421 234.906 36.6538 235.045 36.7824C235.261 36.979 235.469 37.1378 235.678 37.2626L236.544 37.7882L236.877 37.2021C236.998 36.9941 237.089 36.7824 237.162 36.5631L237.166 36.5668Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M222.078 31.8333C221.368 32.8429 222.275 33.6899 223.175 32.8618C224.447 31.6896 225.712 30.3927 227.255 28.642C228.956 26.6116 229.201 25.9385 230.404 24.6114C230.901 24.0404 231.501 23.39 232.133 22.717C232.291 22.5506 232.452 22.3843 232.613 22.2141L233.055 21.8511C233.22 21.7528 233.373 21.6356 233.538 21.5486C233.706 21.4806 233.859 21.3747 234.024 21.3369C234.671 21.1138 235.286 21.1478 235.776 21.2915C236.269 21.4428 236.642 21.6583 236.843 21.7982C236.964 21.87 237.085 21.957 237.213 22.0288C237.443 22.1536 237.86 22.4334 238.364 22.9061C238.865 23.3787 239.458 24.0517 239.966 24.9138C240.478 25.7646 240.931 26.8082 241.107 27.8669C241.195 28.3887 241.209 28.9181 241.118 29.3529C241.07 29.5684 241.005 29.765 240.913 29.9163L240.88 29.973C240.88 29.973 240.869 29.9957 240.862 30.007C240.855 30.0222 240.862 30.007 240.793 30.0864L240.482 30.4305C238.182 33.0471 236.759 34.6654 236.013 35.5086C234.262 37.5088 233.04 39.0855 231.921 40.7114C231.307 41.6038 232.093 42.3449 232.898 41.6302C234.36 40.3295 235.765 38.9267 237.531 36.9379C238.215 36.1627 239.853 34.7524 241.901 32.5101C242.069 32.3286 242.23 32.1396 242.383 31.9468L242.628 31.6367L242.742 31.493L242.822 31.3456L242.954 31.0847C243.283 30.37 243.381 29.6176 243.374 28.9256C243.37 28.2261 243.25 27.5758 243.089 26.9632C242.771 25.7306 242.244 24.6643 241.725 23.7644C241.198 22.872 240.646 22.1687 240.218 21.6999C239.794 21.2272 239.513 20.9701 239.513 20.9701C239.513 20.9701 239.407 20.8756 239.213 20.7092C239.121 20.6223 238.99 20.5315 238.847 20.4181C238.705 20.3046 238.536 20.1836 238.335 20.0626C237.951 19.8055 237.447 19.5522 236.854 19.3404C236.255 19.14 235.542 19.0228 234.792 19.0833C234.046 19.1438 233.271 19.3934 232.623 19.8017C232.448 19.8887 232.305 20.0097 232.152 20.1194C231.998 20.2328 231.845 20.3387 231.709 20.4748C231.57 20.6033 231.431 20.7319 231.296 20.8605C231.172 20.9852 231.08 21.1025 230.974 21.2197C230.144 22.165 229.376 23.0422 228.806 23.6963C227.087 25.6663 226.261 26.6116 225.753 27.1939C224.217 28.9597 223.091 30.4003 222.085 31.8295L222.078 31.8333Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M193.175 84.2328C192.111 85.6129 193.007 86.475 194.258 85.2726C196.035 83.5711 197.83 81.7221 200.054 79.2606C202.526 76.4247 202.964 75.5475 204.69 73.6721C207.568 70.4694 212.673 65.3044 213.905 64.0642C214.088 63.8789 214.264 63.6899 214.432 63.4932C215.639 62.0829 220.937 55.9007 225.683 50.7546C227.336 48.9132 228.671 47.4234 229.731 46.2437C229.867 46.0887 229.998 45.9412 230.126 45.7975C230.305 45.582 230.459 45.3589 230.576 45.1283C230.817 44.6632 230.934 44.183 230.964 43.7368C231.022 42.8407 230.755 42.0996 230.437 41.5929C230.346 41.4417 230.24 41.3018 230.126 41.1656C230.071 41.0976 230.009 41.0371 229.951 40.9766C229.892 40.9161 229.823 40.848 229.786 40.8178C229.618 40.6665 229.45 40.5153 229.285 40.3678C228.953 40.0729 228.634 39.7893 228.32 39.5133C227.691 38.9612 227.091 38.447 226.51 37.9592C225.347 36.9837 224.261 36.1103 223.164 35.2708C221.961 34.3482 221.255 35.1725 222.29 36.2955C223.233 37.3164 224.202 38.326 225.281 39.3998C225.822 39.9368 226.389 40.4888 226.996 41.0635C227.3 41.3509 227.614 41.6458 227.936 41.9483C228.097 42.0996 228.261 42.2508 228.43 42.4058C228.481 42.4512 228.495 42.4701 228.517 42.4966C228.539 42.5231 228.569 42.542 228.587 42.5722C228.631 42.6251 228.671 42.6781 228.708 42.7386C228.825 42.9163 228.905 43.2037 228.868 43.5251C228.846 43.6876 228.795 43.854 228.708 44.009C228.66 44.0847 228.609 44.1603 228.547 44.2284C228.444 44.3304 228.342 44.4325 228.236 44.5422C227.183 45.5933 225.888 46.9016 224.426 48.4897C223.95 49.0077 223.493 49.5446 223.062 50.0929C219.332 54.8458 214.026 60.5818 214.026 60.5818C214.026 60.5818 206.23 69.2481 202.939 72.9083C200.463 75.6647 199.275 76.9919 198.544 77.8086C196.331 80.2815 194.678 82.2704 193.168 84.2252L193.175 84.2328Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M181.866 79.6945C182.122 78.7038 180.988 78.2236 180.498 79.1122C179.8 80.3751 179.156 81.7363 178.436 83.5323C177.679 85.5968 177.712 86.2018 177.138 87.5744C176.673 88.7427 175.975 90.2779 175.331 91.6391C175.171 91.9794 175.013 92.3084 174.867 92.6146C174.794 92.7697 174.721 92.9209 174.651 93.0646C174.527 93.3444 174.41 93.6091 174.297 93.8624C173.821 94.9325 173.448 95.7757 173.24 96.2483C173.112 96.5394 172.995 96.8268 172.892 97.0991C172.779 97.4053 172.6 97.8818 171.803 99.9311C172.713 99.364 174.801 98.1011 177.24 96.6491C178.004 96.1954 178.846 95.7 179.708 95.1858C180.443 94.7585 181.2 94.3275 181.939 93.9229C184.385 92.5012 185.899 91.624 186.689 91.1627C188.554 90.0737 189.889 89.1511 191.147 88.1453C191.838 87.5933 191.318 86.6329 190.503 86.9543C189.018 87.5366 187.559 88.2361 185.687 89.3099C184.959 89.7296 183.303 90.3422 181.146 91.5332C180.795 91.7261 180.454 91.9454 180.133 92.1874C179.551 92.6222 178.919 93.0608 178.286 93.4805C177.968 93.6885 177.65 93.8927 177.343 94.0931C176.926 94.3502 176.995 94.3237 176.886 94.3993C176.56 94.63 176.26 94.7888 176.172 94.8304C176.22 94.7245 176.235 94.6905 176.235 94.6905C176.235 94.6905 178.129 89.9225 178.93 87.9109C179.723 85.8993 180.107 84.9314 180.341 84.3339C181.047 82.5303 181.511 81.0897 181.873 79.6869L181.866 79.6945Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M182.553 76.7456C182.18 76.8779 182.283 78.1446 182.535 78.277C182.915 78.4736 183.303 78.6173 183.826 78.7458C184.429 78.8366 184.66 78.6437 185.054 78.8252C185.395 78.9538 185.804 79.2449 186.093 79.5437C186.385 79.8424 186.55 80.1335 186.583 80.2356C186.598 80.2659 186.616 80.2923 186.645 80.3074C186.751 80.3906 187.062 80.6515 187.413 81.0712C187.764 81.4872 188.144 82.043 188.397 82.6026C188.81 83.3626 188.985 83.8466 189.077 84.0886C189.285 84.6709 189.479 85.0339 189.706 85.4082C189.826 85.5935 190.876 85.8317 191.026 85.4611C191.278 84.8183 191.26 84.1226 191.008 83.3664C190.905 83.079 190.949 82.3493 190.569 81.5288C190.507 81.3964 190.422 81.2754 190.313 81.1771C189.841 80.7423 189.41 80.2054 189.069 79.7743C188.733 79.347 188.492 79.0181 188.492 79.0181C188.492 79.0181 188.389 78.9009 188.225 78.7156C188.031 78.5152 187.757 78.2543 187.439 78.035C186.81 77.5775 186.031 77.2296 185.559 77.0519C184.85 76.791 184.491 76.7229 184.276 76.6662C183.614 76.5225 183.062 76.5603 182.55 76.7381L182.553 76.7456Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M177.729 90.3952C177.587 90.4217 176.643 91.2308 176.581 91.3594C176.49 91.5409 176.464 91.6732 176.53 91.7678C176.654 91.8358 176.877 91.7073 176.91 91.8018C177.002 91.9266 176.899 92.369 176.877 92.4862C176.877 92.5013 176.877 92.5127 176.888 92.5164C176.972 92.5505 177.32 92.6979 177.473 92.9929C177.627 93.1592 177.74 93.2575 177.795 93.3067C177.934 93.4239 178.124 93.4126 178.362 93.2953C178.494 93.2311 179.104 92.3274 179.145 92.195C179.214 91.9493 179.24 91.8056 179.166 91.7262C179.134 91.6959 179.276 91.4199 179.236 91.2989C179.229 91.28 179.203 91.28 179.156 91.2989C178.951 91.3745 178.826 91.3367 178.753 91.2838C178.68 91.2271 178.662 91.159 178.662 91.159C178.662 91.159 178.417 90.8225 178.314 90.6788C178.227 90.5654 178.186 90.5124 178.161 90.4784C178.077 90.3801 177.934 90.3574 177.733 90.3952H177.729Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M168.438 101.285C168.661 101.259 168.87 101.24 169.063 101.202C169.257 101.16 169.433 101.115 169.597 101.066C169.923 100.971 170.19 100.873 170.402 100.775C170.618 100.673 170.753 100.578 170.874 100.476C170.994 100.382 170.954 100.317 170.954 100.268C170.943 100.219 170.928 100.177 170.899 100.143C170.87 100.113 170.83 100.087 170.778 100.083C170.753 100.083 170.724 100.083 170.705 100.068C170.691 100.053 170.724 100.087 170.746 100.117C170.764 100.14 170.778 100.162 170.786 100.174C170.804 100.204 170.811 100.223 170.815 100.227C170.826 100.283 170.735 99.7274 170.771 99.9619L170.76 99.9543L170.735 99.943C170.735 99.943 170.702 99.9278 170.683 99.9203C170.647 99.9051 170.607 99.89 170.563 99.8787C170.475 99.8522 170.376 99.8295 170.267 99.8068C170.043 99.769 169.769 99.7426 169.447 99.7388C169.126 99.7426 168.753 99.7501 168.328 99.7577C167.729 99.769 167.125 99.8144 166.518 99.7652C166.215 99.7539 165.911 99.7388 165.608 99.7274C165.304 99.7048 165.001 99.6556 164.694 99.6216C163.469 99.4892 162.24 99.1943 161.019 98.7632C158.576 97.9011 156.192 96.2753 154.225 93.7343C153.095 92.3088 152.363 90.9779 151.793 89.8095C151.223 88.6374 150.828 87.6089 150.491 86.6334C150.162 85.6578 149.899 84.7352 149.683 83.737C149.573 83.2379 149.482 82.7199 149.405 82.1678C149.369 81.8956 149.325 81.6007 149.321 81.3435C149.314 81.0411 149.31 80.731 149.303 80.402C149.259 79.3055 149.306 78.1031 149.358 76.844C149.409 76.2163 149.464 75.5735 149.515 74.9194C149.584 74.269 149.683 73.6111 149.767 72.9419C150.166 70.2837 150.846 67.5689 151.738 65.1187C152.623 62.6647 153.716 60.483 154.755 58.7928C155.797 57.1027 156.74 55.8738 157.307 55.2272C157.64 54.8416 157.954 54.4408 158.302 54.074C158.452 53.9038 158.635 53.6997 158.85 53.4614C159.066 53.227 159.333 52.985 159.615 52.6977C159.893 52.4065 160.229 52.1229 160.595 51.8167C160.949 51.4953 161.362 51.2003 161.801 50.8789C161.911 50.7995 162.021 50.7163 162.134 50.6369C162.251 50.5651 162.372 50.4895 162.492 50.4139C162.734 50.2664 162.982 50.1076 163.238 49.9526C163.769 49.6879 164.317 49.3778 164.92 49.1661C166.113 48.6972 167.462 48.3758 168.877 48.3909C170.292 48.4023 171.762 48.7766 173.119 49.5404C173.451 49.7446 173.806 49.9147 174.113 50.1756C174.428 50.4252 174.768 50.6369 175.057 50.9394L175.507 51.3629L175.733 51.5747L175.931 51.794C176.194 52.0851 176.428 52.4103 176.651 52.7468C177.51 54.1042 178.008 55.7717 177.935 57.3863C177.902 58.1841 177.744 59.0008 177.445 59.6814C177.137 60.3734 176.684 61.0086 176.143 61.5304C175.759 61.8972 175.338 62.2034 174.903 62.4454C174.464 62.6761 174.015 62.8349 173.572 62.9332C173.126 63.0239 172.695 63.0277 172.278 62.9861C171.868 62.9256 171.473 62.8084 171.108 62.6383C170.376 62.2866 169.769 61.7346 169.301 61.122C168.844 60.4944 168.508 59.8175 168.31 59.1521C167.915 57.8287 168.003 56.5355 168.23 55.4806C168.46 54.4143 168.833 53.556 169.177 52.8867C169.586 52.0927 170.058 51.3554 170.603 50.705C170.738 50.5424 170.859 50.3685 170.998 50.2135C171.14 50.0584 171.279 49.9072 171.418 49.7559C171.685 49.4421 171.996 49.1774 172.285 48.9014C173.47 47.8238 174.757 46.9844 176.07 46.3378C178.702 45.0522 181.408 44.4888 184.092 44.4586C184.462 44.4661 184.787 44.4586 185.069 44.4359C185.35 44.417 185.584 44.4056 185.778 44.3678C186.166 44.296 186.378 44.1712 186.403 44.0162C186.429 43.8649 186.261 43.6872 185.892 43.5095C185.705 43.4225 185.467 43.328 185.178 43.2562C184.886 43.1919 184.542 43.1352 184.147 43.0936C181.273 42.878 178.282 43.2864 175.309 44.5909C173.828 45.245 172.358 46.1374 170.987 47.336C170.65 47.6423 170.296 47.9372 169.985 48.2926C169.824 48.4628 169.66 48.6367 169.499 48.8107C169.338 48.9846 169.191 49.1812 169.038 49.3665C168.413 50.1076 167.857 50.9583 167.37 51.8923C166.997 52.6183 166.555 53.5711 166.226 54.8151C165.915 56.0591 165.703 57.6056 166.08 59.3827C166.273 60.2562 166.613 61.1485 167.129 62.0068C167.645 62.8614 168.35 63.6856 169.279 64.3398C169.74 64.6725 170.27 64.9334 170.833 65.1414C170.976 65.1868 171.122 65.2321 171.268 65.2775C171.415 65.3191 171.568 65.3418 171.718 65.372C172.022 65.4439 172.333 65.4514 172.647 65.4779C173.901 65.5044 175.188 65.1603 176.311 64.4835C177.777 63.61 178.955 62.2602 179.595 60.638C180.275 58.8798 180.344 56.9514 179.949 55.1403C179.551 53.3291 178.688 51.6352 177.463 50.2891C176.242 49.0111 174.867 47.9637 173.345 47.2642C171.832 46.5647 170.226 46.2357 168.738 46.2433C167.25 46.2546 165.9 46.5571 164.734 46.9239C163.589 47.3436 162.613 47.8011 161.852 48.2548C161.476 48.4893 161.125 48.6821 160.84 48.8787C160.558 49.0791 160.313 49.253 160.119 49.3929C159.721 49.6652 159.523 49.8391 159.523 49.8391C159.523 49.8391 159.223 50.0887 158.682 50.5386C158.163 51.0113 157.413 51.6994 156.587 52.6334C154.901 54.4748 152.937 57.3409 151.365 60.7628C150.572 62.4719 149.91 64.3284 149.336 66.2114C149.08 67.1643 148.802 68.1096 148.612 69.0738C148.381 70.0266 148.231 70.987 148.07 71.9247C147.979 72.3936 147.942 72.8625 147.88 73.3275C147.825 73.7926 147.76 74.2464 147.719 74.7001C147.686 75.1538 147.654 75.6 147.621 76.0348C147.588 76.4734 147.551 76.9007 147.548 77.3242C147.537 77.7439 147.526 78.156 147.515 78.5606C147.511 78.761 147.504 78.9614 147.5 79.1543C147.504 79.3509 147.507 79.5437 147.511 79.7366C147.518 80.1185 147.526 80.489 147.533 80.8444C147.537 81.0222 147.54 81.1961 147.544 81.37C147.544 81.5288 147.559 81.7519 147.577 81.9107C147.807 83.9298 148.209 85.6125 148.641 87.072C149.08 88.5277 149.562 89.7452 150.03 90.7737C150.996 92.8231 151.888 94.1162 152.612 95.0577C154.824 97.9087 157.633 99.7539 160.415 100.62C161.809 101.058 163.184 101.319 164.526 101.387C164.862 101.406 165.195 101.437 165.524 101.44C165.853 101.433 166.182 101.425 166.507 101.421C167.162 101.429 167.798 101.338 168.435 101.278L168.438 101.285Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_6509_14303"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_6509_14303"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "560.228",
        height: "332.513",
        fill: "white",
        transform: "matrix(0.963857 0.266421 0.266421 -0.963857 -72.2754 226.095)"
    }))));





const $4279c914d30201b8$export$d1e18b19fc349680 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "100%",
        height: "auto",
        viewBox: "0 0 295 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        "clip-path": "url(#clip0_6509_2098)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        opacity: "0.02",
        "clip-path": "url(#clip1_6509_2098)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.3025 60.3497C59.7178 57.3033 69.9197 56.5075 76.8074 56.5365C78.5362 56.5624 80.0687 56.601 81.3737 56.6771C82.6926 56.7906 83.815 56.9167 84.692 57.0587C86.495 57.3394 87.4324 57.699 87.5438 58.0813C87.6551 58.4636 86.9584 58.8904 85.4581 59.3461C84.6968 59.5709 83.7434 59.7928 82.5935 60.0274C81.4575 60.2993 80.107 60.5621 78.5782 60.8593C72.4448 62.0264 63.3107 63.6697 51.7586 66.8208C43.5826 69.0973 35.6886 71.8367 28.1894 75.154C20.7212 78.4463 13.3738 82.1738 6.76406 86.3729C0.17239 90.5939 -5.85905 95.4049 -10.3861 100.967C-14.9536 106.5 -17.8686 112.859 -17.8485 119.677C-17.757 126.499 -14.5307 133.668 -8.50848 140.405C-2.513 147.151 5.80883 153.418 15.2269 159.035C34.3179 170.304 57.3202 179.374 82.4065 185.789C96.6499 189.475 109.776 191.882 121.837 193.608C133.915 195.357 144.918 196.373 155.101 197.128C175.444 198.55 192.414 198.737 208.167 198.706C223.937 198.612 238.508 198.321 253.752 197.429C268.982 196.5 285.019 195.091 303.09 191.733C318.335 188.916 334.271 184.734 349.188 178.395C356.662 175.255 363.836 171.546 370.449 167.247C377.08 162.97 383.16 158.072 388.211 152.622C393.199 147.138 397.228 141.02 399.488 134.413C401.722 127.816 402.28 120.739 400.247 113.699C399.236 110.205 397.769 106.703 395.589 103.338C394.637 101.636 393.279 100.005 392.122 98.3459C390.707 96.7494 389.474 95.103 387.868 93.5877C381.9 87.3515 374.27 81.8947 366.131 77.2345C349.697 67.9546 330.949 62.7723 313.161 60.1322C295.342 57.4331 278.454 57.0337 263.286 57.0426C248.069 57.1387 234.586 57.6804 223.388 58.4183C217.814 58.8696 212.73 59.2053 208.323 59.7112C206.114 59.9377 204.031 60.1486 202.121 60.3406C200.221 60.5854 198.473 60.8051 196.898 61.006L191.251 61.7217L185.69 62.5617C181.953 63.0854 178.28 63.7272 174.629 64.3752C168.052 65.4869 158.894 67.3914 147.899 70.4455C136.945 73.5275 124.276 77.9267 111.624 84.6237C110.043 85.4589 108.453 86.3251 106.841 87.1852C105.324 88.1385 103.78 89.1011 102.209 90.073C99.0005 91.9984 95.9902 94.079 93.2367 96.3645C87.7383 100.904 83.2104 106.382 82.6659 112.626C81.9637 118.743 85.8869 125.92 92.8951 132.143C99.8137 138.34 109.827 143.284 121.002 146.909C126.596 148.74 132.482 150.3 138.579 151.617C141.611 152.337 144.672 152.865 147.751 153.499C150.843 154.002 153.936 154.589 157.058 154.983C169.552 156.797 182.349 157.605 195.1 157.531C220.633 157.357 245.856 153.247 268.894 145.789C291.919 138.376 313.092 127.724 331.149 115.256C335.484 112.135 339.271 108.813 341.911 105.107C344.511 101.456 345.967 97.3225 345.797 93.1408C345.649 88.9653 343.842 84.9504 340.32 81.4661C336.825 77.9724 331.795 74.975 326.278 72.8642C318.528 69.8514 309.967 68.8077 301.696 68.8985C293.399 68.9987 285.305 70.193 277.599 71.7289C262.223 74.8442 248.804 79.689 237.347 85.4611C225.895 91.2176 216.32 97.945 208.646 104.947C201.071 111.942 195.704 119.582 192.227 127.275C188.75 134.969 187.159 142.731 186.935 150.085C186.928 153.598 187.385 157.005 188.439 160.259C189.564 163.516 190.991 166.64 193.01 169.541C196.82 175.382 201.953 180.45 207.19 184.793C212.423 189.152 217.831 192.79 222.823 195.927C234.655 203.366 247.341 209.718 259.906 215.552C272.498 221.376 285.092 226.665 297.443 231.702C322.171 241.768 346.009 250.868 368.664 260.411C391.225 270.029 413.029 279.772 432.034 292.574C436.767 295.774 441.262 299.226 445.287 302.984C449.311 306.741 452.968 310.782 455.651 315.122C461.104 323.827 462.146 333.406 459.144 341.213C458.967 341.767 458.771 342.299 458.603 342.822C458.367 343.326 458.113 343.808 457.882 344.296C457.401 345.251 456.969 346.203 456.442 347.062C455.285 348.717 454.356 350.335 453.173 351.649C452.013 352.969 450.994 354.21 449.92 355.219C448.819 356.237 447.805 357.112 446.867 357.891C443.004 360.874 440.492 361.937 439.755 361.465C438.954 360.96 439.924 358.934 442.382 355.362C442.948 354.447 443.616 353.426 444.399 352.337C445.165 351.226 445.83 349.954 446.704 348.622C447.579 347.29 448.201 345.738 449.095 344.161C449.466 343.342 449.778 342.475 450.139 341.604C450.331 341.171 450.505 340.717 450.701 340.269C450.83 339.803 450.963 339.32 451.096 338.838C453.384 331.871 452.09 324.165 447.386 317.022C445.024 313.44 441.817 310.043 438.177 306.81C434.542 303.562 430.418 300.514 425.978 297.647C408.171 286.095 386.814 276.828 364.476 267.623C342.027 258.472 318.155 249.58 293.088 239.521C280.545 234.481 267.7 229.139 254.687 223.182C241.687 217.178 228.413 210.596 215.592 202.549C210.614 199.449 205.062 195.722 199.358 191.149C193.654 186.576 187.721 181.086 182.745 174.404C177.889 167.722 174.167 159.729 173.595 151.419C173.268 147.194 173.614 143.323 174.181 139.177C174.78 135.091 175.781 130.948 177.282 126.827C180.239 118.572 185.005 110.314 191.907 102.613C195.336 98.7569 199.392 95.0738 203.754 91.5925C208.102 88.0738 212.934 84.7225 218.179 81.5354C228.665 75.1769 240.909 69.522 254.995 65.2299C262.047 63.0947 269.558 61.3041 277.476 59.9607C285.399 58.6017 294.004 57.6493 303.449 57.9333C309.615 58.1311 315.984 58.9038 322.478 60.5314C328.937 62.1995 335.199 64.6669 340.898 67.9496C346.543 71.2511 351.68 75.433 355.204 80.3071C358.749 85.1874 360.338 90.4308 360.349 95.1879C360.391 100.355 358.79 105.102 356.094 109.362C353.406 113.59 349.715 117.173 345.698 120.365C341.659 123.551 337.299 126.33 332.901 128.981C328.517 131.669 323.949 134.24 319.281 136.733C300.576 146.661 279.439 154.83 256.65 160.165C233.843 165.478 209.348 167.83 185.053 166.839C172.921 166.416 160.829 165.065 149.092 163.043C137.358 161.005 125.989 158.348 115.046 154.586C104.152 150.822 93.788 145.748 85.6951 139.175C77.697 132.696 71.9905 124.992 70.1438 117.367C69.2451 113.553 69.3663 109.887 70.2018 106.603C71.0597 103.325 72.5827 100.431 74.3998 97.8702C78.0519 92.7698 82.6781 88.943 87.0522 85.7664C95.9996 79.6522 103.734 75.3957 109.415 72.8144C114.96 70.112 118.212 68.9018 118.212 68.9018C118.212 68.9018 119.404 68.4277 121.654 67.5265C123.85 66.56 127.348 65.4177 131.776 63.8796C140.713 60.943 154.031 57.1586 171.36 54.1312C188.639 51.0229 209.911 48.8177 233.864 47.9059C236.856 47.8121 239.897 47.7152 242.96 47.6244C246.037 47.571 249.158 47.5299 252.307 47.4795C258.599 47.3941 265.076 47.4268 271.715 47.5711C284.984 47.891 298.991 48.7664 313.456 51.0405C327.916 53.3301 342.847 56.9717 357.187 63.0112C371.371 69.0074 384.649 77.1469 394.985 87.1181C400.144 92.0929 404.495 97.5475 407.643 103.255C410.791 108.963 412.642 114.915 413.083 120.645C413.57 126.387 412.763 131.922 411.076 137.064C409.363 142.215 406.744 146.981 403.575 151.378C400.403 155.791 396.659 159.828 392.527 163.524C388.381 167.182 383.888 170.527 379.187 173.58C369.802 179.707 359.425 184.539 348.958 188.475C327.96 196.314 306.465 200.282 287.937 202.677C175.065 213.527 115.212 203.444 80.3663 194.566C53.8017 187.742 29.283 178.052 8.50041 165.662C-1.84914 159.403 -11.2878 152.291 -18.4107 144.129C-21.961 140.051 -24.8352 135.708 -26.7904 131.267C-28.7189 126.817 -29.7145 122.307 -29.6583 118.003C-29.5148 109.372 -25.6701 101.831 -20.3458 95.6524C-15.0085 89.4275 -8.27004 84.3265 -1.02382 79.9182C6.28959 75.5286 13.9859 71.8473 22.0389 68.5325C30.0653 65.2271 38.5313 62.5118 47.2887 60.3124L47.3025 60.3497Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M272.088 8.1864C270.616 10.4579 268.645 11.9216 266.834 12.9778C265.005 14.0123 263.265 14.6362 261.809 15.0204C258.855 15.7608 256.959 15.5548 256.322 14.8933C255.645 14.2039 256.235 13.0279 257.776 11.3781C259.246 9.72537 261.92 7.55192 263.505 4.60869C264.563 2.52423 264.349 0.422659 262.991 -1.64332C261.588 -3.7217 258.962 -5.82038 255.828 -7.30592C252.815 -8.79161 248.949 -9.80988 244.874 -10.4175C240.753 -11.0375 236.293 -11.2995 231.543 -11.4741C212.7 -12.2132 192.407 -11.8965 172.101 -7.51604C166.361 -6.29032 161.347 -4.89757 156.936 -3.4216C152.585 -1.89595 148.778 -0.336749 145.459 1.29026C138.772 4.54744 133.864 7.9113 129.761 11.3302C125.698 14.777 122.475 18.3222 119.836 22.4638C117.245 26.6022 115.229 31.3679 114.53 37.3851C114.285 39.9287 114.26 42.6338 114.541 45.4566C114.866 48.2918 115.497 51.2449 116.445 54.269C118.418 60.3047 121.635 66.6343 126.252 72.6979C135.317 84.9125 149.835 95.8892 165.374 103.7C173.135 107.636 181.084 110.888 188.793 113.353C196.464 115.959 203.893 117.694 210.576 119.073C224.031 121.687 234.681 122.321 240.544 122.569C242.278 122.663 244.02 122.643 245.762 122.706C247.491 122.732 249.243 122.848 250.967 122.805C252.512 122.797 254.393 122.798 256.563 122.795C258.738 122.777 261.171 122.613 263.921 122.519C266.653 122.404 269.593 122.061 272.815 121.831C274.404 121.667 276.036 121.432 277.735 121.215C279.435 120.999 281.201 120.801 282.958 120.466C290.151 119.391 297.889 117.563 305.916 115.128C313.969 112.683 322.197 109.434 329.52 105.097C336.825 100.738 343.103 95.1248 346.439 88.1127C349.812 81.1439 350.281 72.9039 346.083 65.0644C342 57.1564 333.772 49.5922 323.963 43.8178C314.064 37.9346 302.503 33.6174 290.769 30.2736C274.094 25.6143 258.615 22.9092 244.745 21.5361C230.843 20.02 218.664 20.2026 208.033 20.5449C186.87 21.6586 172.262 24.7854 162.555 27.1912C139.81 33.2412 122.033 41.4678 108.479 51.1631C101.559 55.9628 95.2422 60.8456 92.5998 66.3925C89.867 71.8308 91.5555 78.4576 95.8271 84.8108C98.1427 88.2965 100.204 90.9587 101.337 92.8788C102.492 94.8051 102.817 95.9831 102.134 96.3633C101.499 96.7403 99.8327 96.3132 97.4269 94.8112C95.0435 93.3154 91.7956 90.7605 88.6976 86.7906C85.8849 83.1842 83.6587 79.2879 82.4755 75.1945C81.3104 71.1228 81.34 66.829 82.8264 63.0215C84.2861 59.2234 86.8452 55.8965 89.7698 52.9051C92.6805 49.8763 96.11 47.3257 99.5421 44.5917C113.401 33.7922 132.143 24.6938 156.357 18.213C165.854 15.8666 180.675 12.2296 201.789 10.5998C203.096 10.4926 204.431 10.3759 205.787 10.2654C207.14 10.1705 208.564 10.1626 209.98 10.1018C212.824 10.0176 215.744 9.92077 218.731 9.84256C221.736 9.78608 224.878 9.93466 228.095 9.98676C229.698 10.0284 231.329 10.0606 232.96 10.0928C234.608 10.1468 236.294 10.3282 237.979 10.4257C251.516 11.1711 266.534 13.3637 282.507 17.1595C285.105 17.7938 287.715 18.3814 290.295 19.0778C292.871 19.7899 295.457 20.5547 298.007 21.3601C303.125 22.9925 308.233 24.8394 313.195 26.9477C323.852 31.4836 334.699 37.4279 343.544 45.0286C347.949 48.8072 351.839 52.9626 354.956 57.3895C358.023 61.8196 360.307 66.5522 361.372 71.2489C363.542 80.6704 361.179 89.3915 356.593 96.4767C352.007 103.646 345.09 109.133 337.899 113.339C330.66 117.548 323.158 120.613 316.197 122.941C312.677 124.077 309.406 125.182 306.19 126C304.6 126.431 303.081 126.865 301.607 127.228C300.114 127.568 298.675 127.89 297.312 128.2C294.599 128.856 292.089 129.301 289.882 129.695C287.675 130.089 285.835 130.468 284.242 130.647C281.134 131.077 279.43 131.309 279.43 131.309C279.43 131.309 278.801 131.403 277.601 131.557C276.388 131.673 274.581 131.843 272.256 132.054C269.967 132.309 267.079 132.465 263.731 132.627C260.411 132.865 256.542 132.816 252.304 132.884C243.749 132.779 233.462 132.229 222 130.517C210.556 128.827 197.939 125.975 185.256 121.616C172.529 117.328 159.816 111.42 148.313 104.19C136.801 96.99 126.671 88.3648 119.135 79.1675C111.644 69.9825 106.779 60.3685 104.575 51.5067C102.303 42.6264 102.895 34.5542 104.787 28.1469C107.72 18.4955 113.372 11.2193 119.337 5.68705C125.312 0.123678 131.652 -3.79846 137.511 -6.76549C149.346 -12.6842 159.022 -14.9811 166.276 -16.6253C177.363 -19.0514 188.446 -20.156 199.089 -20.629C209.768 -21.0585 220.07 -20.8222 229.997 -20.1874C234.927 -19.8793 239.979 -19.4874 245.197 -18.564C250.384 -17.6158 255.715 -16.1422 260.634 -13.5271C265.409 -11.0019 269.506 -7.59289 271.908 -3.54758C273.064 -1.5373 273.713 0.6508 273.663 2.66253C273.658 4.68663 272.991 6.57784 271.968 8.18654L272.088 8.1864Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M72.3008 43.1996C72.3008 40.1068 74.808 37.5996 77.9008 37.5996H348.801C351.894 37.5996 354.401 40.1068 354.401 43.1996V139.1H72.3008V43.1996Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "90.5",
        y: "54.3994",
        width: "92.4",
        height: "7",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "246.4",
        height: "7",
        transform: "matrix(-1 0 0 1 336.9 93.5996)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "147.7",
        height: "7",
        transform: "matrix(-1 0 0 1 238.2 110.399)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "118.5",
        y: "71.1992",
        width: "25.9",
        height: "7",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "106.25",
        cy: "74.3496",
        r: "5.25",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "97.1504",
        cy: "74.3496",
        r: "5.25",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        "clip-path": "url(#clip2_6509_2098)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.5342 54.3963C46.7568 53.9604 45.0637 55.714 45.3984 56.4247C45.8732 57.4531 46.4554 58.4104 47.2851 59.5701C47.8048 60.1854 48.2144 60.5247 48.564 60.8248L48.6289 60.8796L48.7227 60.9833L48.9152 61.2063C49.0391 61.3517 49.1546 61.5032 49.269 61.6619C49.499 61.9721 49.7171 62.3098 49.9429 62.7816C50.398 63.6593 50.9237 64.8287 51.5125 66.2001C52.5124 65.2191 53.5647 64.1876 54.4513 63.3137C54.9352 62.8316 55.4108 62.3999 55.8162 62.0379C56.0582 61.819 56.1059 61.7973 56.2062 61.725C56.2897 61.6648 56.3648 61.6106 56.4233 61.5685C56.5224 61.5034 56.6022 61.4205 56.676 61.3292C57.153 60.6617 59.46 57.8056 62.0277 55.98C63.7426 54.5913 64.8666 53.8001 65.4489 53.393C66.8234 52.4212 67.7555 51.5399 68.5948 50.5033C69.0555 49.9364 68.005 48.0919 67.2576 48.2435C65.8944 48.5092 64.6088 49.0235 63.1172 50.0353C62.5372 50.428 61.001 50.8057 59.2984 52.0267C59.0228 52.2254 58.7845 52.467 58.5823 52.7587C57.7127 53.9821 56.5798 55.1923 55.6767 56.1225C54.7747 57.0456 54.0821 57.6782 54.0821 57.6782L53.1314 58.6745L52.6835 59.1624C52.5238 59.3282 52.3632 59.5456 52.2237 59.6778C52.1295 59.4856 52.0342 59.3005 51.9233 59.1202C51.8534 59.0056 51.7883 58.9066 51.7293 58.8159C51.5401 58.5271 51.3739 58.2788 51.2317 58.064C50.939 57.6404 50.7271 57.3553 50.5706 57.1382C49.5883 55.8283 48.596 54.9889 47.515 54.3784L47.5342 54.3963Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M79.8814 39.7076C80.0406 39.9989 80.2033 40.2687 80.3624 40.5158C80.5048 40.7749 80.6279 41.0161 80.7629 41.2297C81.0245 41.663 81.2834 42.0222 81.5275 42.2904C82.0146 42.834 82.4584 43.0535 82.7846 42.9515C83.1109 42.8496 83.3065 42.4167 83.3044 41.6567C83.3075 41.2737 83.2576 40.8083 83.1535 40.2678C83.0937 40 83.0386 39.7034 82.9415 39.3927C82.8349 39.0951 82.7018 38.7785 82.5568 38.4453C80.9627 34.6319 78.5747 30.9848 75.2452 27.7307C71.9195 24.4994 67.652 21.5726 62.156 19.8995C59.0404 19.0106 56.37 18.6955 54.0738 18.8025C53.5006 18.8349 52.9535 18.7978 52.4225 18.8887C51.8939 18.9652 51.3879 19.038 50.8975 19.106C49.9082 19.2036 49.0215 19.5318 48.1524 19.7523C44.7807 20.8058 42.1224 22.1447 38.5784 24.5789C37.8254 25.0837 37.1064 25.6972 36.3382 26.2954C35.6062 26.9437 34.8382 27.5861 34.1138 28.3242C32.6419 29.7596 31.2068 31.378 29.9016 33.1502C28.5904 34.9141 27.3899 36.8139 26.3465 38.7908C25.2887 40.7654 24.4564 42.8504 23.7519 44.8749C22.3311 48.9515 21.6763 53.0344 21.5462 56.428C21.3995 59.8336 21.823 62.5426 22.1132 64.0278C22.2037 64.4703 22.2942 64.9127 22.4002 65.3503L22.7936 66.6531C23.3065 68.1745 24.3531 71.0435 26.6425 74.2985C27.8056 75.9032 29.2385 77.618 31.0407 79.1935C32.8344 80.7751 34.9283 82.28 37.294 83.5634C42.0053 86.164 47.8243 87.801 53.8465 88.0033C56.8522 88.1147 59.9151 87.874 62.8629 87.3417C63.6082 87.2487 64.3421 87.0432 65.0751 86.8892C65.8056 86.7053 66.5471 86.5896 67.2642 86.3519C67.9861 86.1297 68.7008 85.9064 69.4156 85.683C70.1352 85.4752 70.8159 85.1431 71.5149 84.8804C75.406 83.262 78.6532 81.1115 81.2198 78.7916C83.7937 76.4729 85.7016 74.0314 87.1686 71.7618C89.9981 67.1393 91.1866 63.3126 91.8599 60.7077C92.6483 57.6201 93.0267 54.6502 93.1437 51.8372C93.2679 49.0253 93.1174 46.3606 92.739 43.8285C91.9774 38.7932 90.508 34.2109 87.8314 30.2515C87.4939 29.6952 87.0672 29.2794 86.7257 28.929C86.3855 28.5714 86.0266 28.3288 85.7218 28.1614C85.1124 27.8266 84.6958 27.8032 84.4777 28.0112C84.2596 28.2192 84.2555 28.6537 84.4615 29.2476C84.5681 29.5452 84.7216 29.8725 84.8981 30.2846C85.0746 30.6967 85.3481 31.1025 85.5945 31.6292C87.5819 35.3367 88.6142 39.6121 89.0762 44.267C89.3101 46.5986 89.3555 49.0471 89.1812 51.6223C89.0081 54.1902 88.6225 56.886 87.9046 59.6754C87.3551 61.8356 86.1775 65.1405 83.7558 68.8851C82.5192 70.7349 80.991 72.6995 79.0039 74.5382C77.0108 76.3684 74.5935 78.0857 71.732 79.4949C69.8883 80.4496 67.9262 81.1786 65.9545 81.8766C64.8861 82.2343 63.7575 82.5085 62.623 82.8187C61.469 83.0224 60.2889 83.2956 59.107 83.4432C56.7424 83.7898 54.3129 83.8088 51.9364 83.6372C50.7465 83.5622 49.5763 83.3651 48.411 83.1835C47.2645 82.9311 46.1312 82.6883 45.0526 82.3364C42.8833 81.66 40.851 80.8215 39.0753 79.8108C35.5132 77.8096 32.9115 75.389 31.3712 73.4724C30.9932 72.9833 30.6586 72.5456 30.3661 72.1662C30.0999 71.7617 29.8757 71.4156 29.6926 71.1351C29.5095 70.8547 29.3673 70.6398 29.2888 70.487C29.2032 70.333 29.1645 70.253 29.1645 70.253C29.1645 70.253 29.0958 70.1312 28.9763 69.9127C28.8581 69.687 28.652 69.3659 28.443 68.9264C28.2424 68.4809 27.9672 67.9495 27.7095 67.3103C27.4757 66.6602 27.1506 65.9364 26.9267 65.0888C25.8411 61.7783 25.2846 56.8426 26.1542 51.526C26.5771 48.8732 27.3216 46.1471 28.3466 43.5108C29.3681 40.8961 30.718 38.3936 32.2413 36.1405C33.7646 33.8874 35.4829 31.8872 37.2172 30.2435C38.9526 28.5927 40.7171 27.308 42.2903 26.3389C44.6573 24.8864 46.9248 23.9561 48.9247 23.4028C49.4233 23.2846 49.8991 23.17 50.3666 23.0614C50.8232 22.929 51.2936 22.9389 51.7326 22.87C52.1752 22.8237 52.5974 22.7669 53.009 22.7304C53.4219 22.7309 53.8264 22.7376 54.2106 22.7335C57.2927 22.7835 59.4134 23.3044 60.9714 23.7931C65.7398 25.2229 69.583 27.7195 72.6696 30.4696C75.76 33.2423 78.1253 36.3474 79.8932 39.68L79.8814 39.7076Z",
        fill: "#6A9A23"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_6509_2098"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "295",
        height: "135",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_6509_2098"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "531.742",
        height: "315.605",
        fill: "white",
        transform: "matrix(0.963857 0.266421 0.266421 -0.963857 -60 224.198)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_6509_2098"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "70.5432",
        height: "69.0945",
        fill: "white",
        transform: "translate(28.1211 14.165) rotate(9.21254)"
    }))));








const $12f4e4dea8469f82$var$MAX_DISMISSED_REVIEW_IDS = 200;
const $12f4e4dea8469f82$var$getDismissedReviewIds = ()=>{
    try {
        const stored = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_APPROVALS_COMPLETION_SPOTLIGHT_DISMISSED);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) return parsed;
        }
    } catch  {}
    return [];
};
const $12f4e4dea8469f82$var$addDismissedReviewId = (reviewId)=>{
    try {
        const dismissed = $12f4e4dea8469f82$var$getDismissedReviewIds();
        if (!dismissed.includes(reviewId)) {
            const updated = [
                ...dismissed,
                reviewId
            ].slice(-$12f4e4dea8469f82$var$MAX_DISMISSED_REVIEW_IDS);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_APPROVALS_COMPLETION_SPOTLIGHT_DISMISSED, JSON.stringify(updated));
        }
    } catch  {}
};
const $12f4e4dea8469f82$var$styles = {
    body: "_o5721jtm _n3tdu2gc",
    spotlightTargetContainer: "_kqswh2mm _1e0c1o8l",
    spotlightTargetAnchor: "_kqswstnw _94n5ze3t _1xi214no _1bsbze3t _4t3ize3t _lcxvglyw"
};
const $12f4e4dea8469f82$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    changesRequestedApprovalHeadline: {
        id: "approvals.completion-spotlight.denied-headline",
        defaultMessage: "Changes requested"
    },
    approvedApprovalHeadline: {
        id: "approvals.completion-spotlight.approved-headline",
        defaultMessage: "Page is approved"
    },
    changesRequestedApprovalBody: {
        id: "approvals.completion-spotlight.changes-requested-body",
        defaultMessage: "Everyone has responded, but one or more have requested changes be made before your page can be approved."
    },
    approvedApprovalBody: {
        id: "approvals.completion-spotlight.approved-body",
        defaultMessage: "Nice work! Everyone approved your page."
    },
    getDetailsCtaLabel: {
        id: "approvals.completion-spotlight.get-details-cta-label",
        defaultMessage: "Get details"
    }
});
const $12f4e4dea8469f82$export$bd4e7584535e90d7 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { approvalRequest: approvalRequest, contentId: contentId, contentStatus: contentStatus, isCurrentUserRequestor: isCurrentUserRequestor } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const reviewId = approvalRequest?.review?.reviewId;
    const reviewStatus = approvalRequest?.review?.reviewStatus;
    const isCompleted = reviewStatus === 'APPROVED' || reviewStatus === 'DENIED';
    const isChangesRequested = reviewStatus === 'DENIED';
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(()=>reviewId ? $12f4e4dea8469f82$var$getDismissedReviewIds().includes(reviewId) : false); // Reset dismissed state when reviewId changes (new approval cycle)
    (0, $42omo.useEffect)(()=>{
        if (reviewId) setIsDismissed($12f4e4dea8469f82$var$getDismissedReviewIds().includes(reviewId));
    }, [
        reviewId
    ]);
    const dismiss = (0, $42omo.useCallback)(()=>{
        setIsDismissed(true);
        if (reviewId) $12f4e4dea8469f82$var$addDismissedReviewId(reviewId);
    }, [
        reviewId
    ]);
    const dismissAndOpenApprovalsPane = (0, $42omo.useCallback)(()=>{
        dismiss();
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        contentId,
        contentStatus,
        dismiss,
        rightSidebarContext
    ]);
    const isVisible = isCurrentUserRequestor && isCompleted && !isDismissed; // Re-key the PopoverProvider whenever the object sidebar (details panel) opens or closes,
    // which shifts the page content left/right and moves the popup anchor's viewport position.
    // Remounting PopoverProvider forces Popper.js to recalculate from the updated anchor coordinates.
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const [popoverKey, setPopoverKey] = (0, $42omo.useState)(0); // Use a ref so the effect below can read the latest isVisible without needing it as a
    // dependency — we only want to remount when the sidebar state changes, not when visibility changes.
    const isVisibleRef = (0, $42omo.useRef)(isVisible);
    isVisibleRef.current = isVisible;
    (0, $42omo.useEffect)(()=>{
        if (isVisibleRef.current) setPopoverKey((k)=>k + 1);
    }, [
        isObjectSidebarShown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), {
        key: popoverKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $12f4e4dea8469f82$var$styles.spotlightTargetContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $12f4e4dea8469f82$var$styles.spotlightTargetAnchor
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null))), children(dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: dismiss,
        placement: "bottom-end",
        isVisible: isVisible,
        shouldDismissOnClickOutside: false,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage(isChangesRequested ? $12f4e4dea8469f82$export$a7357cdd1f0b0168.changesRequestedApprovalHeadline : $12f4e4dea8469f82$export$a7357cdd1f0b0168.approvedApprovalHeadline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, isChangesRequested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e3dc4f9522a67664$export$3c87e1f3199ca8e9), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4279c914d30201b8$export$d1e18b19fc349680), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $12f4e4dea8469f82$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage(isChangesRequested ? $12f4e4dea8469f82$export$a7357cdd1f0b0168.changesRequestedApprovalBody : $12f4e4dea8469f82$export$a7357cdd1f0b0168.approvedApprovalBody)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: dismissAndOpenApprovalsPane
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $12f4e4dea8469f82$export$a7357cdd1f0b0168.getDetailsCtaLabel)))))));
};






var $Uu0Pb = parcelRequire("Uu0Pb");


var $iNJwL = parcelRequire("iNJwL");




/* eslint-disable check-file/filename-blocklist */ 


const $adbf40b583ec3a51$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    statusLabel: {
        id: "content-state.add-status.floating-toolbar",
        defaultMessage: "Status"
    },
    changeStatus: {
        id: "content-state.change-status",
        defaultMessage: "Change status"
    },
    setPageStatus: {
        id: "content-state.set-page-status",
        defaultMessage: "Set status"
    },
    setBlogStatus: {
        id: "content-state.set-blog-status",
        defaultMessage: "Set blog post status"
    },
    addCustomStatus: {
        id: "content-state.add-custom-status",
        defaultMessage: "Add custom status"
    },
    custom: {
        id: "content-state.custom",
        defaultMessage: "Custom"
    },
    suggested: {
        id: "content-state.suggested",
        defaultMessage: "Suggested"
    },
    save: {
        id: "content-state.save",
        defaultMessage: "Save"
    },
    cancel: {
        id: "content-state.cancel",
        defaultMessage: "Cancel"
    },
    remove: {
        id: "content-state.remove",
        defaultMessage: "Remove"
    },
    showMoreStatuses: {
        id: "content-state.show.more.statuses",
        defaultMessage: "Show more statuses"
    },
    maxLengthEditor: {
        id: "content-state.max.length.editor.creation",
        defaultMessage: "Max length of 20"
    },
    featureDisabled: {
        id: "content-state.feature.disabled.message",
        defaultMessage: "The content status feature is not enabled in this space."
    },
    errorFlagTitle: {
        id: "content-state.error.flag.title",
        defaultMessage: "We can\u2019t set your status"
    },
    errorFlagBody: {
        id: "content-state.error.flag.body",
        defaultMessage: "Refresh and try again."
    },
    removeErrorFlagTitle: {
        id: "content-state.remove-error.flag.title",
        defaultMessage: "Failed to remove content state"
    },
    removeErrorFlagBody: {
        id: "content-state.remove-error.flag.body",
        defaultMessage: "Refresh and try again."
    },
    noneText: {
        id: "content-state.none.text",
        defaultMessage: "None"
    },
    colorOptionAriaLabel: {
        id: "content-state.color-option.aria-label",
        defaultMessage: "{colorName} color option"
    },
    colorPickerButtonAriaLabel: {
        id: "content-state.color-picker-button.aria-label",
        defaultMessage: "Color picker, {colorName} selected"
    },
    removeButtonAriaLabel: {
        id: "content-state.remove-button.aria-label",
        defaultMessage: "Remove status"
    }
});



var $3qCob = parcelRequire("3qCob");

const $32fca6e0bfcfd80d$var$contentStateNameStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025',
    marginRight: 'space.025',
    marginTop: 'space.0',
    marginBottom: 'space.0'
});
const $32fca6e0bfcfd80d$var$subtleContentStateNameStyles = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles = (0, $ecnYn.xcss)({
    font: 'font.body',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
});
const $32fca6e0bfcfd80d$var$chevronDownIconWrapperStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.050'
});
const $32fca6e0bfcfd80d$var$styles = {
    approvalStatusIcon: "_18zr1b66"
};
const $32fca6e0bfcfd80d$var$determineSecondarySSRHex = (primaryColor)=>{
    const upperCasePrimaryColor = primaryColor?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCasePrimaryColor){
        case '#2684FF':
            return '#e9f2ff';
        case '#57D9A3':
            return '#dcfff1';
        case '#FFC400':
            return '#fff7d6';
        case '#8777D9':
            return '#f3f0ff';
        case '#FF7452':
            return '#ffeceb';
        default:
            return '#e9f2ff';
    }
};
const $32fca6e0bfcfd80d$var$getContentStateButtonBackgroundColor = (isWarning, isSelected, isHovered, color, hoverColor, isPressed)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? '#ffeceb' : (0, $Uu0Pb.SECONDARY_COLORS).RED;
    if (isSelected) return color;
    if (isPressed) return "var(--ds-background-neutral-subtle-pressed, #0B120E24)";
    return isHovered ? hoverColor : color;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32fca6e0bfcfd80d$var$HasContentStateButton = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        const { isDetailsPanel: isDetailsPanel, isSubtle: isSubtle, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkofajl _19itglyw _1e0c1txw _4cvr1h6o _1bah1yb4 _80omtlke _syazi7uo _k48p1wq8 _12ji1v1w _j5dh13gf _1j5515iw _cun9by5v",
            __cmplp.isDetailsPanel ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isDetailsPanel ? "_19bv1b66" : !__cmplp.isSubtle ? "_19bv12x7" : "_19bvze3t",
            __cmplp.isDetailsPanel ? "_u5f3v77o" : !__cmplp.isSubtle ? "_u5f312x7" : "_u5f3v77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $32fca6e0bfcfd80d$var$ContentStateButtonBase = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { triggerProps: triggerProps, togglePopup: togglePopup, contentState: contentState, isSelected: isSelected, isWarning: isWarning, userOffline: userOffline, contentStateButtonRef: contentStateButtonRef, floatingToolbarButtonStyle: floatingToolbarButtonStyle, appearance: appearance, primaryColor: primaryColor, secondaryColor: secondaryColor, hoverColor: hoverColor, showChevron: showChevron, colorAppearance: colorAppearance, tooltipContent: tooltipContent, isDetailsPanel: isDetailsPanel } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isPressed, setIsPressed] = (0, $42omo.useState)(false);
    if (!contentState) return null;
    const isContentStateSelectorDisabled = contentState.isCallerPermitted === false || userOffline;
    let t1;
    if ($[0] !== hoverColor || $[1] !== isHovered || $[2] !== isPressed || $[3] !== isSelected || $[4] !== isWarning || $[5] !== secondaryColor) {
        t1 = $32fca6e0bfcfd80d$var$getContentStateButtonBackgroundColor(isWarning, isSelected, isHovered, secondaryColor, hoverColor, isPressed);
        $[0] = hoverColor;
        $[1] = isHovered;
        $[2] = isPressed;
        $[3] = isSelected;
        $[4] = isWarning;
        $[5] = secondaryColor;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== floatingToolbarButtonStyle || $[8] !== t1) {
        t2 = {
            ...floatingToolbarButtonStyle,
            backgroundColor: t1
        };
        $[7] = floatingToolbarButtonStyle;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    const buttonStyles = t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsHovered(true);
        t4 = ()=>setIsHovered(false);
        t5 = ()=>setIsPressed(true);
        t6 = ()=>setIsPressed(false);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
    } else {
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        t6 = $[13];
    }
    const t7 = appearance === "subtle";
    let t8;
    if ($[14] !== colorAppearance || $[15] !== contentState.restrictionLevel || $[16] !== isWarning || $[17] !== primaryColor) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
            dataTestId: "button-color-icon",
            appearance: colorAppearance,
            color: primaryColor,
            restrictionLevel: contentState.restrictionLevel,
            isWarning: isWarning
        });
        $[14] = colorAppearance;
        $[15] = contentState.restrictionLevel;
        $[16] = isWarning;
        $[17] = primaryColor;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = appearance === "subtle" && $32fca6e0bfcfd80d$var$subtleContentStateNameStyles;
    const t10 = isDetailsPanel && $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles;
    let t11;
    if ($[19] !== t10 || $[20] !== t9) {
        t11 = [
            $32fca6e0bfcfd80d$var$contentStateNameStyles,
            t9,
            t10
        ];
        $[19] = t10;
        $[20] = t9;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== contentState.name || $[23] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t11,
            testId: "content-state-name"
        }, contentState.name);
        $[22] = contentState.name;
        $[23] = t11;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== intl || $[26] !== showChevron) {
        t13 = showChevron && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $32fca6e0bfcfd80d$var$chevronDownIconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            color: "currentColor",
            spacing: "compact",
            label: intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).showMoreStatuses),
            testId: "content-state-chevron-down-icon",
            size: "small"
        }));
        $[25] = intl;
        $[26] = showChevron;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== appearance || $[29] !== buttonStyles || $[30] !== isContentStateSelectorDisabled || $[31] !== isDetailsPanel || $[32] !== secondaryColor || $[33] !== t12 || $[34] !== t13 || $[35] !== t7 || $[36] !== t8 || $[37] !== togglePopup || $[38] !== triggerProps) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32fca6e0bfcfd80d$var$HasContentStateButton, {
            ...triggerProps,
            appearance: appearance,
            style: buttonStyles,
            onClick: togglePopup,
            disabled: isContentStateSelectorDisabled,
            color: secondaryColor,
            onMouseEnter: t3,
            onMouseLeave: t4,
            onMouseDown: t5,
            onMouseUp: t6,
            isSubtle: t7,
            isDetailsPanel: isDetailsPanel,
            "data-testid": "content-state-trigger",
            type: "button"
        }, t8, t12, t13);
        $[28] = appearance;
        $[29] = buttonStyles;
        $[30] = isContentStateSelectorDisabled;
        $[31] = isDetailsPanel;
        $[32] = secondaryColor;
        $[33] = t12;
        $[34] = t13;
        $[35] = t7;
        $[36] = t8;
        $[37] = togglePopup;
        $[38] = triggerProps;
        $[39] = t14;
    } else t14 = $[39];
    const button = t14;
    let t15;
    if ($[40] !== button || $[41] !== intl || $[42] !== tooltipContent) {
        t15 = tooltipContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: intl.formatMessage(tooltipContent),
            position: "bottom"
        }, button) : button;
        $[40] = button;
        $[41] = intl;
        $[42] = tooltipContent;
        $[43] = t15;
    } else t15 = $[43];
    let t16;
    if ($[44] !== contentStateButtonRef || $[45] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: contentStateButtonRef
        }, t15);
        $[44] = contentStateButtonRef;
        $[45] = t15;
        $[46] = t16;
    } else t16 = $[46];
    return t16;
};
const $32fca6e0bfcfd80d$var$ContentStateButtonComponent = (t0)=>{
    const $ = (0, $frIzR.c)(72);
    const { triggerProps: triggerProps, togglePopup: togglePopup, contentState: contentState, activeWorkflowStatus: activeWorkflowStatus, isSelected: isSelected, isWarning: isWarning, userOffline: userOffline, contentStateButtonRef: contentStateButtonRef, intl: t1, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: t2, isDetailsPanel: t3, canEdit: t4 } = t0;
    const { formatMessage: formatMessage } = t1;
    const renderPlusButtonEmptyState = t2 === undefined ? false : t2;
    const isDetailsPanel = t3 === undefined ? false : t3;
    const canEdit = t4 === undefined ? true : t4;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [isWorkflowButtonHovered, setIsWorkflowButtonHovered] = (0, $42omo.useState)(false);
    const [isWorkflowButtonPressed, setIsWorkflowButtonPressed] = (0, $42omo.useState)(false);
    const getSecondaryColor = $32fca6e0bfcfd80d$var$_temp;
    let t5;
    if ($[0] !== isDetailsPanel || $[1] !== isLivePage) {
        t5 = (editorContentState)=>{
            const primaryColor_0 = editorContentState.color;
            const isVerifiedContentState = editorContentState?.restrictionLevel === "PAGE_OWNER" && editorContentState.name === "Verified";
            const shouldUseNewEditorBylineButtonStyleProps = !isDetailsPanel && (isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline"));
            if (shouldUseNewEditorBylineButtonStyleProps) return {
                appearance: "subtle",
                primaryColor: primaryColor_0,
                secondaryColor: getSecondaryColor({
                    primaryColor: primaryColor_0,
                    isNeutralBackground: true
                }),
                hoverColor: "var(--ds-surface-hovered, #F0F1F2)",
                showChevron: false,
                colorAppearance: isVerifiedContentState ? "contentStateButton" : "subtleContentStateButton"
            };
            const secondaryColor = getSecondaryColor({
                primaryColor: primaryColor_0,
                isNeutralBackground: isDetailsPanel
            });
            const hoverColor = isDetailsPanel ? "var(--ds-surface-hovered, #F0F1F2)" : (0, $3qCob.determineHoverColor)(secondaryColor);
            const colorAppearance = isDetailsPanel ? "rendererContentState" : "contentStateButton";
            return {
                appearance: "default",
                primaryColor: primaryColor_0,
                secondaryColor: secondaryColor,
                hoverColor: hoverColor,
                showChevron: !isDetailsPanel,
                colorAppearance: colorAppearance
            };
        };
        $[0] = isDetailsPanel;
        $[1] = isLivePage;
        $[2] = t5;
    } else t5 = $[2];
    const getButtonProps = t5;
    const verifiedRestrictedTooltipContent = isRbacEnabled ? (0, $iNJwL.sharedi18n).verifiedRestrictedRbac : (0, $iNJwL.sharedi18n).verifiedRestricted;
    if (activeWorkflowStatus) {
        let t6;
        if ($[3] !== activeWorkflowStatus.id) {
            t6 = activeWorkflowStatus.id === "3" && (0, $9wGTI.fg)("hello_100_release_updates");
            $[3] = activeWorkflowStatus.id;
            $[4] = t6;
        } else t6 = $[4];
        const isChangesRequested = t6;
        let WorkflowIcon;
        let iconColor;
        if ($[5] !== activeWorkflowStatus.allowsReviews || $[6] !== isChangesRequested) {
            if (isChangesRequested) {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($bJRX9)));
                iconColor = "var(--ds-icon-accent-blue, #357DE8)";
            } else if (activeWorkflowStatus.allowsReviews) {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($gITTQ)));
                iconColor = "var(--ds-icon-accent-blue, #357DE8)";
            } else {
                WorkflowIcon = (0, (/*@__PURE__*/$parcel$interopDefault($imt6g)));
                iconColor = "var(--ds-icon-accent-lime, #6A9A23)";
            }
            $[5] = activeWorkflowStatus.allowsReviews;
            $[6] = isChangesRequested;
            $[7] = iconColor;
            $[8] = WorkflowIcon;
        } else {
            iconColor = $[7];
            WorkflowIcon = $[8];
        }
        let t7;
        if ($[9] !== isDetailsPanel || $[10] !== isLivePage) {
            t7 = !isDetailsPanel && (isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline"));
            $[9] = isDetailsPanel;
            $[10] = isLivePage;
            $[11] = t7;
        } else t7 = $[11];
        const shouldUseSubtle = t7;
        const secondaryColor_0 = shouldUseSubtle ? "var(--ds-elevation-surface-current, #FFFFFF)" : "var(--ds-background-neutral, #0515240F)";
        const hoveredWorkflowBackgroundColor = isWorkflowButtonHovered ? "var(--ds-background-neutral-subtle-hovered, #0515240F)" : secondaryColor_0;
        const workflowBackgroundColor = isWorkflowButtonPressed ? "var(--ds-background-neutral-subtle-pressed, #0B120E24)" : hoveredWorkflowBackgroundColor;
        let t8;
        if ($[12] !== floatingToolbarButtonStyle || $[13] !== workflowBackgroundColor) {
            t8 = {
                ...floatingToolbarButtonStyle,
                backgroundColor: workflowBackgroundColor
            };
            $[12] = floatingToolbarButtonStyle;
            $[13] = workflowBackgroundColor;
            $[14] = t8;
        } else t8 = $[14];
        const workflowButtonStyles = t8;
        let t9;
        if ($[15] !== WorkflowIcon || $[16] !== activeWorkflowStatus.name || $[17] !== iconColor || $[18] !== isDetailsPanel || $[19] !== isSelected || $[20] !== shouldUseSubtle || $[21] !== togglePopup || $[22] !== triggerProps || $[23] !== userOffline || $[24] !== workflowButtonStyles) {
            t9 = (dismissSpotlight)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32fca6e0bfcfd80d$var$HasContentStateButton, {
                    ...triggerProps,
                    style: workflowButtonStyles,
                    onClick: ()=>{
                        dismissSpotlight?.();
                        togglePopup();
                    },
                    onMouseEnter: ()=>setIsWorkflowButtonHovered(true),
                    onMouseLeave: ()=>setIsWorkflowButtonHovered(false),
                    onMouseDown: ()=>setIsWorkflowButtonPressed(true),
                    onMouseUp: ()=>setIsWorkflowButtonPressed(false),
                    isSelected: isSelected,
                    disabled: userOffline,
                    isSubtle: shouldUseSubtle,
                    isDetailsPanel: isDetailsPanel,
                    "data-testid": "content-state-trigger",
                    type: "button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $32fca6e0bfcfd80d$var$styles.approvalStatusIcon
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WorkflowIcon, {
                    label: "",
                    size: "small",
                    color: iconColor
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: [
                        $32fca6e0bfcfd80d$var$contentStateNameStyles,
                        shouldUseSubtle && $32fca6e0bfcfd80d$var$subtleContentStateNameStyles,
                        isDetailsPanel && $32fca6e0bfcfd80d$var$detailPanelContentStateNameStyles
                    ],
                    testId: "content-state-name"
                }, activeWorkflowStatus.name));
            $[15] = WorkflowIcon;
            $[16] = activeWorkflowStatus.name;
            $[17] = iconColor;
            $[18] = isDetailsPanel;
            $[19] = isSelected;
            $[20] = shouldUseSubtle;
            $[21] = togglePopup;
            $[22] = triggerProps;
            $[23] = userOffline;
            $[24] = workflowButtonStyles;
            $[25] = t9;
        } else t9 = $[25];
        const workflowButton = t9;
        let t10;
        if ($[26] !== canEdit || $[27] !== formatMessage || $[28] !== workflowButton) {
            t10 = (dismissSpotlight_0)=>canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatus),
                    position: "bottom"
                }, workflowButton(dismissSpotlight_0)) : workflowButton(dismissSpotlight_0);
            $[26] = canEdit;
            $[27] = formatMessage;
            $[28] = workflowButton;
            $[29] = t10;
        } else t10 = $[29];
        const buttonNode = t10;
        let t11;
        if ($[30] !== buttonNode || $[31] !== isDetailsPanel) {
            t11 = !isDetailsPanel && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $12f4e4dea8469f82$export$bd4e7584535e90d7), null, (dismiss)=>buttonNode(dismiss)) : buttonNode();
            $[30] = buttonNode;
            $[31] = isDetailsPanel;
            $[32] = t11;
        } else t11 = $[32];
        let t12;
        if ($[33] !== contentStateButtonRef || $[34] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ref: contentStateButtonRef
            }, t11);
            $[33] = contentStateButtonRef;
            $[34] = t11;
            $[35] = t12;
        } else t12 = $[35];
        return t12;
    }
    if (contentState) {
        const tooltipContent = !canEdit ? (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel : contentState.restrictionLevel === "PAGE_OWNER" ? verifiedRestrictedTooltipContent : (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).changeStatus;
        let t6;
        if ($[36] !== contentState || $[37] !== getButtonProps) {
            t6 = getButtonProps(contentState);
            $[36] = contentState;
            $[37] = getButtonProps;
            $[38] = t6;
        } else t6 = $[38];
        const buttonProps = t6;
        let t7;
        if ($[39] !== buttonProps || $[40] !== contentState || $[41] !== contentStateButtonRef || $[42] !== floatingToolbarButtonStyle || $[43] !== isDetailsPanel || $[44] !== isSelected || $[45] !== isWarning || $[46] !== togglePopup || $[47] !== tooltipContent || $[48] !== triggerProps || $[49] !== userOffline) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                space: "space.0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32fca6e0bfcfd80d$var$ContentStateButtonBase, {
                triggerProps: triggerProps,
                togglePopup: togglePopup,
                contentState: contentState,
                isSelected: isSelected,
                isWarning: isWarning,
                userOffline: userOffline,
                contentStateButtonRef: contentStateButtonRef,
                floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                tooltipContent: tooltipContent,
                isDetailsPanel: isDetailsPanel,
                ...buttonProps
            }));
            $[39] = buttonProps;
            $[40] = contentState;
            $[41] = contentStateButtonRef;
            $[42] = floatingToolbarButtonStyle;
            $[43] = isDetailsPanel;
            $[44] = isSelected;
            $[45] = isWarning;
            $[46] = togglePopup;
            $[47] = tooltipContent;
            $[48] = triggerProps;
            $[49] = userOffline;
            $[50] = t7;
        } else t7 = $[50];
        return t7;
    }
    if (renderPlusButtonEmptyState) {
        let t6;
        if ($[51] !== formatMessage) {
            t6 = formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel);
            $[51] = formatMessage;
            $[52] = t6;
        } else t6 = $[52];
        let t7;
        if ($[53] !== t6 || $[54] !== togglePopup || $[55] !== triggerProps) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
                appearance: "subtle",
                label: t6,
                onClick: togglePopup,
                testId: "content-state-empty-state-add-icon"
            });
            $[53] = t6;
            $[54] = togglePopup;
            $[55] = triggerProps;
            $[56] = t7;
        } else t7 = $[56];
        return t7;
    }
    let t6;
    if ($[57] !== floatingToolbarButtonStyle) {
        t6 = floatingToolbarButtonStyle || {};
        $[57] = floatingToolbarButtonStyle;
        $[58] = t6;
    } else t6 = $[58];
    let t7;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6DSrS))), {
            label: "",
            testId: "content-state-task-icon"
        });
        $[59] = t7;
    } else t7 = $[59];
    let t8;
    if ($[60] !== formatMessage) {
        t8 = formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).statusLabel);
        $[60] = formatMessage;
        $[61] = t8;
    } else t8 = $[61];
    let t9;
    if ($[62] !== isSelected || $[63] !== t6 || $[64] !== t8 || $[65] !== togglePopup || $[66] !== triggerProps || $[67] !== userOffline) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            ...triggerProps,
            appearance: "subtle",
            style: t6,
            onClick: togglePopup,
            iconBefore: t7,
            isSelected: isSelected,
            spacing: "compact",
            testId: "content-state-trigger",
            isDisabled: userOffline
        }, t8));
        $[62] = isSelected;
        $[63] = t6;
        $[64] = t8;
        $[65] = togglePopup;
        $[66] = triggerProps;
        $[67] = userOffline;
        $[68] = t9;
    } else t9 = $[68];
    let t10;
    if ($[69] !== contentStateButtonRef || $[70] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: contentStateButtonRef
        }, t9);
        $[69] = contentStateButtonRef;
        $[70] = t9;
        $[71] = t10;
    } else t10 = $[71];
    return t10;
};
const $32fca6e0bfcfd80d$export$ee3b73f13be68d6d = (0, $aXWIB.injectIntl)($32fca6e0bfcfd80d$var$ContentStateButtonComponent);
function $32fca6e0bfcfd80d$var$_temp(t0) {
    const { primaryColor: primaryColor, isNeutralBackground: isNeutralBackground } = t0;
    if (isNeutralBackground) return "var(--ds-elevation-surface-current, #FFFFFF)";
    else return (0, $3qCob.determineSecondaryColor)(primaryColor);
}

















var $8ccd225f267efb0e$exports = {};
$8ccd225f267efb0e$exports = new URL("GenericError.42a632b0.svg", import.meta.url).toString();


















var $fzqvY = parcelRequire("fzqvY");
















var $7sObp = parcelRequire("7sObp");
















var $cvXh8 = parcelRequire("cvXh8");











// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99a97a10d1a2aa69$var$SelectedColor = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isOpen: isOpen, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1odflos": (0, $7sObp.default)(__cmplp.isOpen ? "var(--ds-border-inverse, #FFFFFF)" : __cmplp.color ? __cmplp.color : "var(--ds-border-accent-gray, #7D818A)"),
                "--_xexnhp": (0, $7sObp.default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itmgv6 _2rko1rr0 _1bsb7vkz _4t3i7vkz _2hwx1i6y _18u0v77o _bfhk1cj8",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $99a97a10d1a2aa69$var$ColorOption = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "button" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, $7sObp.default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _19it1ps9 _2rko1rr0 _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1cj8 _12jia755 _80omtlke",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $99a97a10d1a2aa69$var$ColorOptionWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_80omtlke _16jlkb7n _1e0c1txw _4cvr1h6o _1bah1h6o _ukjc98my",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $99a97a10d1a2aa69$var$DropDownContentWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bahitcz _4cvr1fhb _1bsb10bg _4t3i1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $99a97a10d1a2aa69$var$ButtonIconsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $99a97a10d1a2aa69$var$chevronDownIconWrapperStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.075'
});
const $99a97a10d1a2aa69$export$13cf15360203042f = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { selectedColor: selectedColor, onSelectColor: onSelectColor, isOpen: isOpen, onClose: onClose, onColorPickerToggle: onColorPickerToggle, userOffline: userOffline, colorPickerComponentRef: colorPickerComponentRef } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== intl || $[1] !== onSelectColor || $[2] !== selectedColor) {
        const colorsArray = [
            (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
            (0, $Uu0Pb.PRIMARY_COLORS).GREEN,
            (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
            (0, $Uu0Pb.PRIMARY_COLORS).RED,
            (0, $Uu0Pb.PRIMARY_COLORS).PURPLE
        ];
        t1 = colorsArray.map((color)=>{
            const isSelected = selectedColor === color;
            const colorName = (0, $8miSe.colorCodeToColorName)(color);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$ColorOptionWrapper, {
                onClick: ()=>onSelectColor(color),
                key: `${color}-option`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$ColorOption, {
                color: color,
                "data-testid": `${(0, $8miSe.tokenToHex)(color)}-option`,
                "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorOptionAriaLabel, {
                    colorName: colorName
                })
            }, isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "selected",
                color: "var(--ds-icon-subtle, #505258)"
            })));
        });
        $[0] = intl;
        $[1] = onSelectColor;
        $[2] = selectedColor;
        $[3] = t1;
    } else t1 = $[3];
    const statusColors = t1;
    let t2;
    let t3;
    if ($[4] !== isOpen) {
        t2 = ()=>{
            const colorPickerButton = document.getElementById("content-state-color-picker-button");
            if (!isOpen && colorPickerButton) setTimeout(()=>{
                colorPickerButton.focus();
            }, 0);
        };
        t3 = [
            isOpen
        ];
        $[4] = isOpen;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[7] !== intl || $[8] !== isOpen || $[9] !== onColorPickerToggle || $[10] !== selectedColor || $[11] !== userOffline) {
        t4 = (t5)=>{
            const { ...buttonProps } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...buttonProps,
                id: "content-state-color-picker-button",
                testId: "color-picker-popup-trigger",
                isSelected: isOpen,
                isDisabled: userOffline,
                onClick: onColorPickerToggle,
                "aria-label": intl.formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).colorPickerButtonAriaLabel, {
                    colorName: selectedColor ? (0, $8miSe.colorCodeToColorName)(selectedColor) : ""
                }),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$ButtonIconsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$SelectedColor, {
                    color: selectedColor || undefined,
                    isOpen: isOpen,
                    "data-testid": "selected-color"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $99a97a10d1a2aa69$var$chevronDownIconWrapperStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })))
            });
        };
        $[7] = intl;
        $[8] = isOpen;
        $[9] = onColorPickerToggle;
        $[10] = selectedColor;
        $[11] = userOffline;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== colorPickerComponentRef || $[14] !== statusColors) {
        t5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99a97a10d1a2aa69$var$DropDownContentWrapper, {
                ref: colorPickerComponentRef
            }, statusColors);
        $[13] = colorPickerComponentRef;
        $[14] = statusColors;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== isOpen || $[17] !== onClose || $[18] !== t4 || $[19] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            testId: "color-picker-popup",
            placement: "bottom-start",
            zIndex: 700,
            shouldRenderToParent: true,
            trigger: t4,
            content: t5
        });
        $[16] = isOpen;
        $[17] = onClose;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};













var $4noo5 = parcelRequire("4noo5");


var $fVjjG = parcelRequire("fVjjG");

var $fb3kw = parcelRequire("fb3kw");

var $a4qga = parcelRequire("a4qga");





const $c3e1925399b17e8a$var$ContentStateTextFieldComponent = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { onFocusTextField: onFocusTextField, showFormFooter: showFormFooter, userOffline: userOffline, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    let t2;
    if ($[0] !== onFocusTextField) {
        t2 = (event)=>{
            if (event.key !== "Tab") onFocusTextField();
        };
        $[0] = onFocusTextField;
        $[1] = t2;
    } else t2 = $[1];
    const checkForTab = t2;
    const validateName = $c3e1925399b17e8a$var$_temp;
    let t3;
    if ($[2] !== checkForTab || $[3] !== formatMessage || $[4] !== onFocusTextField || $[5] !== showFormFooter || $[6] !== userOffline) {
        t3 = showFormFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "name",
            validate: validateName
        }, (t4)=>{
            const { fieldProps: fieldProps, error: error } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                ...fieldProps,
                placeholder: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                isCompact: true,
                autoComplete: "off",
                testId: "name-input",
                maxLength: 20,
                isDisabled: userOffline
            }), error === "REQUIRED" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVjjG.ErrorMessage), null, formatMessage((0, $iNJwL.sharedi18n).requiredErrorMessage)), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a4qga.HelperMessage), null, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).maxLengthEditor)));
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "dummy-name"
        }, (t5)=>{
            const { fieldProps: fieldProps_0 } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                ...fieldProps_0,
                onKeyDown: checkForTab,
                onMouseDown: onFocusTextField,
                isDisabled: userOffline,
                placeholder: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).addCustomStatus),
                isCompact: true,
                value: "",
                testId: "dummy-name-input"
            });
        });
        $[2] = checkForTab;
        $[3] = formatMessage;
        $[4] = onFocusTextField;
        $[5] = showFormFooter;
        $[6] = userOffline;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $c3e1925399b17e8a$export$c3a18725b7210022 = (0, $aXWIB.injectIntl)($c3e1925399b17e8a$var$ContentStateTextFieldComponent);
function $c3e1925399b17e8a$var$_temp(value) {
    if (!value) return "REQUIRED";
}


const $45bd28dec8e86674$var$TextFieldWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1o8l _1bsb15w3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$ColorPickerButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2hwx12x7 _1e0c1o8l _s7n4jp4b _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$FormFooterWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isVisible: isVisible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bahesu3 _19pkutpp _p7u6u2gc",
            __cmplp.isVisible ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$ColorAndInputWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $45bd28dec8e86674$var$ContentStateFormComponent = (0, $7aRa9.withFlags)(({ onSubmit: onSubmit, onCancel: onCancel, showFormFooter: showFormFooter, selectedColor: selectedColor, onSelectColor: onSelectColor, isColorPickerOpen: isColorPickerOpen, onColorPickerToggle: onColorPickerToggle, onColorPickerClose: onColorPickerClose, onFocusTextField: onFocusTextField, userOffline: userOffline, colorPickerComponentRef: colorPickerComponentRef, flags: flags, intl: { formatMessage: formatMessage } })=>{
    const handleSubmit = (data)=>{
        const trimmedName = data.name.replace(/\s+/g, ' ').trim();
        if (trimmedName) onSubmit(trimmedName);
        else // show warning flag if user entered all whitespace
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $iNJwL.sharedi18n).emptyStatusFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $iNJwL.sharedi18n).emptyStatusFlagDescription)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        testId: "content-state-form"
    }, ({ formProps: formProps })=>// eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            ref: formProps.ref,
            onKeyDown: formProps.onKeyDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$ColorAndInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$ColorPickerButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99a97a10d1a2aa69$export$13cf15360203042f), {
            onColorPickerToggle: onColorPickerToggle,
            selectedColor: selectedColor,
            onSelectColor: onSelectColor,
            isOpen: isColorPickerOpen,
            onClose: onColorPickerClose,
            userOffline: userOffline,
            colorPickerComponentRef: colorPickerComponentRef
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3e1925399b17e8a$export$c3a18725b7210022), {
            onFocusTextField: onFocusTextField,
            showFormFooter: showFormFooter,
            userOffline: userOffline
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45bd28dec8e86674$var$FormFooterWrapper, {
            isVisible: showFormFooter,
            "data-testid": "content-state-form-footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            onClick: onCancel,
            spacing: "compact",
            appearance: "subtle",
            testId: "content-state-cancel"
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "content-state-submit",
            type: "submit",
            spacing: "compact",
            appearance: "primary",
            onClick: formProps.onSubmit
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).save)))));
});
const $45bd28dec8e86674$export$2ae5c8bd8129bb8e = /*#__PURE__*/ (0, $42omo.memo)((0, $aXWIB.injectIntl)($45bd28dec8e86674$var$ContentStateFormComponent));





/**
 * @generated SignedSource<<b8497b5a38f0d95df8c44c84e1fb08ed>>
 * @relayHash c81edbedabd3a07bb4c131163defdd60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 662dba7b6b58fc2f7fb7095611d6ca086899027bdfe189caf512accfcfab4815
const $5bafe07f9f90b739$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStateInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentStateInput"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "setContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentStateGroupSetContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentStateGroupSetContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c81edbedabd3a07bb4c131163defdd60",
            "id": "662dba7b6b58fc2f7fb7095611d6ca086899027bdfe189caf512accfcfab4815",
            "metadata": {},
            "name": "ContentStateGroupSetContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation ContentStateGroupSetContentStateMutation($contentId:ID!,$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId,contentState:$contentStateInput){name,color,id,restrictionLevel}}"
        }
    };
}();
$5bafe07f9f90b739$var$node.hash = "9bf862412febf809155ba549e5c2b02e";
var $5bafe07f9f90b739$export$2e2bcd8739ae039 = $5bafe07f9f90b739$var$node;







































var $3lWl0 = parcelRequire("3lWl0");


















const $0de1820bd94dcfc9$var$ContentStateWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8fhey _19itglyw _1e0c1txw _4cvr1h6o _80omtlke _4t3i14no _1bsb1osq _bfhksm61 _syazi7uo _12jia755 _j5dh13gf _1j5515iw _cun91j28 _irr3i8nm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0de1820bd94dcfc9$var$contentStateNameStyles = (0, $ecnYn.xcss)({
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap'
});
const $0de1820bd94dcfc9$export$96e9e87da55ad40c = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { contentState: contentState, onClick: onClick, userOffline: userOffline } = t0;
    let t1;
    if ($[0] !== contentState.color || $[1] !== contentState.restrictionLevel) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
            dataTestId: "content-state-color",
            appearance: "editorContentState",
            color: contentState.color,
            restrictionLevel: contentState.restrictionLevel
        });
        $[0] = contentState.color;
        $[1] = contentState.restrictionLevel;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            $0de1820bd94dcfc9$var$contentStateNameStyles
        ];
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== contentState.name) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t2
        }, contentState.name);
        $[4] = contentState.name;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onClick || $[7] !== t1 || $[8] !== t3 || $[9] !== userOffline) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0de1820bd94dcfc9$var$ContentStateWrapper, {
            "data-testid": "content-state",
            onClick: onClick,
            disabled: userOffline
        }, t1, t3);
        $[6] = onClick;
        $[7] = t1;
        $[8] = t3;
        $[9] = userOffline;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



/* eslint-disable check-file/filename-blocklist */ const $c169b00c0122f30f$export$fa2d28b3b2819e2d = 'custom';
const $c169b00c0122f30f$export$b3c3dee917fc137d = 'suggested';





const $742e27b1b03e5e97$var$GroupLabel = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "h3" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _otyrutpp _syazazsu _k48p1wq8 _18u01ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $742e27b1b03e5e97$var$ContentStateListWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _2mzuglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $742e27b1b03e5e97$export$b5eb02bd35e29271 = (t0)=>{
    const $ = (0, $frIzR.c)(41);
    const { contentId: contentId, contentStateState: contentStateState, groupIsEnabled: groupIsEnabled, groupLabel: groupLabel, contentStates: contentStates, flags: flags, userOffline: userOffline, intl: t1, onUpdateSuccess: onUpdateSuccess, setIsContentStateMenuOpen: setIsContentStateMenuOpen } = t0;
    const { formatMessage: formatMessage } = t1;
    const originalContentState = (0, $42omo.useRef)(contentStateState.state.contentState);
    const originalCustomStatesArray = (0, $42omo.useRef)(contentStateState.state.customStatesArray);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [shouldSetAutomationFlag, setShouldSetAutomationFlag] = (0, $42omo.useState)(false);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (!(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE) && (0, $9wGTI.fg)("cc_a4c_smart_button_changeboarding")) setShouldSetAutomationFlag(true);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $42omo.useEffect)(t2, t3);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t4;
    if ($[2] !== contentId || $[3] !== contentStateState || $[4] !== createAnalyticsEvent || $[5] !== flags || $[6] !== isLivePage) {
        t4 = ()=>{
            contentStateState.setContentState(originalContentState.current);
            contentStateState.setCustomStatesArray(originalCustomStatesArray.current);
            flags.showErrorFlag({
                id: "content-state-error-flag",
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    objectId: contentId,
                    name: "contentStateErrorFlag",
                    attributes: {
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = contentStateState;
        $[4] = createAnalyticsEvent;
        $[5] = flags;
        $[6] = isLivePage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== contentStateState || $[9] !== onUpdateSuccess) {
        t5 = ()=>{
            originalContentState.current = contentStateState.state.contentState;
            originalCustomStatesArray.current = contentStateState.state.customStatesArray;
            contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        };
        $[8] = contentStateState;
        $[9] = onUpdateSuccess;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== contentId || $[12] !== isLivePage) {
        t6 = ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true),
                        format: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "MILLIS" : "USER_FRIENDLY"
                    }
                }
            ];
        $[11] = contentId;
        $[12] = isLivePage;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
        t7 = {
            onError: t4,
            onCompleted: t5,
            refetchQueries: t6
        };
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const [setContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $5bafe07f9f90b739$export$2e2bcd8739ae039), {
        ...t7,
        __callerPackage__: "@confluence/content-state"
    });
    let t8;
    if ($[18] !== contentId || $[19] !== contentStateState || $[20] !== createAnalyticsEvent || $[21] !== isLivePage || $[22] !== setContentStateMutation || $[23] !== setIsContentStateMenuOpen || $[24] !== shouldSetAutomationFlag) {
        t8 = (newContentState, label, index)=>{
            contentStateState.setIsUpdating(true);
            setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        color: (0, $8miSe.tokenToHex)(newContentState.color),
                        name: newContentState.name,
                        id: newContentState.id
                    }
                }
            });
            contentStateState.setContentState(newContentState);
            setIsContentStateMenuOpen(false);
            if (label === (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d)) {
                const newCustomStatesArray = (0, $3qCob.createNewCustomStatesArrayWhenExistingCustomSelected)(contentStateState.state.customStatesArray, newContentState, index);
                contentStateState.setCustomStatesArray(newCustomStatesArray);
            }
            if (shouldSetAutomationFlag && (0, $9wGTI.fg)("cc_a4c_smart_button_changeboarding")) {
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
                setShouldSetAutomationFlag(false);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    objectId: contentId,
                    actionSubjectId: "editorContentStateAdded",
                    source: "editorContentState",
                    attributes: {
                        type: label,
                        color: (0, $8miSe.colorCodeToColorName)(newContentState.color.toUpperCase()),
                        restrictionLevel: newContentState.restrictionLevel?.toUpperCase(),
                        uiLocation: "pageTitleSection",
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        $[18] = contentId;
        $[19] = contentStateState;
        $[20] = createAnalyticsEvent;
        $[21] = isLivePage;
        $[22] = setContentStateMutation;
        $[23] = setIsContentStateMenuOpen;
        $[24] = shouldSetAutomationFlag;
        $[25] = t8;
    } else t8 = $[25];
    const handleClick = t8;
    let t9;
    if ($[26] !== contentStates || $[27] !== groupLabel || $[28] !== handleClick || $[29] !== userOffline) {
        let t10;
        if ($[31] !== groupLabel || $[32] !== handleClick || $[33] !== userOffline) {
            t10 = (contentState, index_0)=>{
                if (contentState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0de1820bd94dcfc9$export$96e9e87da55ad40c), {
                    contentState: contentState,
                    userOffline: userOffline,
                    onClick: ()=>handleClick(contentState, groupLabel, index_0),
                    key: `${groupLabel}-content-state-${index_0}`
                });
            };
            $[31] = groupLabel;
            $[32] = handleClick;
            $[33] = userOffline;
            $[34] = t10;
        } else t10 = $[34];
        t9 = contentStates.map(t10);
        $[26] = contentStates;
        $[27] = groupLabel;
        $[28] = handleClick;
        $[29] = userOffline;
        $[30] = t9;
    } else t9 = $[30];
    const contentStateList = t9;
    let t10;
    if ($[35] !== contentStateList || $[36] !== contentStates.length || $[37] !== formatMessage || $[38] !== groupIsEnabled || $[39] !== groupLabel) {
        t10 = groupIsEnabled && contentStates.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": `${groupLabel.toLowerCase()}-content-states`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($742e27b1b03e5e97$var$GroupLabel, null, groupLabel === (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d) ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).custom) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).suggested)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($742e27b1b03e5e97$var$ContentStateListWrapper, {
            "aria-label": groupLabel
        }, contentStateList)) : null;
        $[35] = contentStateList;
        $[36] = contentStates.length;
        $[37] = formatMessage;
        $[38] = groupIsEnabled;
        $[39] = groupLabel;
        $[40] = t10;
    } else t10 = $[40];
    return t10;
};
const $742e27b1b03e5e97$export$710aa0e581cfaff9 = (0, $aXWIB.injectIntl)((0, $7aRa9.withFlags)($742e27b1b03e5e97$export$b5eb02bd35e29271));

















var $gKvd9 = parcelRequire("gKvd9");








const $a14c780b3cacba28$var$RemoveButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(6);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "button" : t2;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, $Uu0Pb.PRIMARY_COLORS).RED);
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== __cmpls) {
            t4 = {
                ...__cmpls,
                "--_1eacras": t3
            };
            $[4] = __cmpls;
            $[5] = t4;
        } else t4 = $[5];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t4,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itglyw _2rkofajl _1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _12ji15c5 _bfhk1j28 _syazi7uo _j5dh13gf _1j5515iw _vbqb1gmx _cun91j28 _jomri8nm _f8pj5u61 _irr3i8nm _30l35u61 _1di6i8nm _9h8h5u61",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $a14c780b3cacba28$var$RemoveButtonPlaceholder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a14c780b3cacba28$var$RemoveButtonComponent = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasContentState: hasContentState, userOffline: userOffline, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    let t2;
    if ($[0] !== onMouseEnter) {
        t2 = ()=>{
            setIsFocused(true);
            onMouseEnter();
        };
        $[0] = onMouseEnter;
        $[1] = t2;
    } else t2 = $[1];
    const handleOnFocus = t2;
    let t3;
    if ($[2] !== onMouseLeave) {
        t3 = ()=>{
            setIsFocused(false);
            onMouseLeave();
        };
        $[2] = onMouseLeave;
        $[3] = t3;
    } else t3 = $[3];
    const handleOnBlur = t3;
    let t4;
    if ($[4] !== isFocused || $[5] !== onMouseLeave) {
        t4 = ()=>{
            if (!isFocused) onMouseLeave();
        };
        $[4] = isFocused;
        $[5] = onMouseLeave;
        $[6] = t4;
    } else t4 = $[6];
    const handleOnMouseLeave = t4;
    let t5;
    if ($[7] !== formatMessage || $[8] !== handleOnBlur || $[9] !== handleOnFocus || $[10] !== handleOnMouseLeave || $[11] !== hasContentState || $[12] !== onClick || $[13] !== onMouseEnter || $[14] !== userOffline) {
        t5 = hasContentState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).remove),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a14c780b3cacba28$var$RemoveButtonWrapper, {
            onClick: onClick,
            "data-testid": "remove-button",
            onMouseEnter: onMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            disabled: userOffline,
            "aria-label": formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeButtonAriaLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a14c780b3cacba28$var$RemoveButtonPlaceholder, {
            "data-testid": "remove-button-placeholder"
        });
        $[7] = formatMessage;
        $[8] = handleOnBlur;
        $[9] = handleOnFocus;
        $[10] = handleOnMouseLeave;
        $[11] = hasContentState;
        $[12] = onClick;
        $[13] = onMouseEnter;
        $[14] = userOffline;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $a14c780b3cacba28$export$4e9d5ce1e6c22a94 = (0, $aXWIB.injectIntl)($a14c780b3cacba28$var$RemoveButtonComponent);




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35470e23ff8dc4a3$var$ContentStateMenuWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt45uws _1bsb1l7m",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$HeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81lhn _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$FormWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81lhn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$HorizontalDivider = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8127m _bfhki8nm _4t3it94y _1bsbgx0z",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$ContentStateGroupsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_yopyv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$ContentStateDisabledDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$FeatureDisabledGraphic = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4t3iymf6 _1bsb12am",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$FeatureDisabledTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8utpp _syaz1gmx _y3gn1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35470e23ff8dc4a3$var$ContentStateMenuComponent = (t0)=>{
    const $ = (0, $frIzR.c)(66);
    const { contentId: contentId, contentStateState: contentStateState, contentType: contentType, isContentStateEnabled: isContentStateEnabled, isCustomEnabled: isCustomEnabled, defaultStatesArray: defaultStatesArray, customStatesArray: customStatesArray, isSuggestedEnabled: isSuggestedEnabled, isCreatingContentState: isCreatingContentState, selectedColor: selectedColor, onSelectColor: onSelectColor, isColorPickerOpen: isColorPickerOpen, onColorPickerClose: onColorPickerClose, onColorPickerToggle: onColorPickerToggle, onSubmit: onSubmit, onRemove: onRemove, onCancel: onCancel, onFocusTextField: onFocusTextField, onMouseEnterRemove: onMouseEnterRemove, onMouseLeaveRemove: onMouseLeaveRemove, userOffline: userOffline, onPopupClose: onPopupClose, contentStateButtonRef: contentStateButtonRef, intl: t1, onUpdateSuccess: onUpdateSuccess, isContentStateMenuOpen: isContentStateMenuOpen, setIsContentStateMenuOpen: setIsContentStateMenuOpen, updatePopup: updatePopup } = t0;
    const { formatMessage: formatMessage } = t1;
    const menuComponent = (0, $42omo.useRef)(null);
    const colorPickerComponent = (0, $42omo.useRef)(null);
    let t2;
    if ($[0] !== contentStateButtonRef || $[1] !== onPopupClose) {
        t2 = (event)=>{
            if (menuComponent?.current && event.target instanceof Node && !menuComponent?.current?.contains(event.target) && !colorPickerComponent?.current?.contains(event.target) && !contentStateButtonRef?.current?.contains(event.target)) onPopupClose();
        };
        $[0] = contentStateButtonRef;
        $[1] = onPopupClose;
        $[2] = t2;
    } else t2 = $[2];
    const handleClickOutside = t2;
    let t3;
    if ($[3] !== isColorPickerOpen || $[4] !== isContentStateMenuOpen || $[5] !== onColorPickerClose || $[6] !== onPopupClose) {
        t3 = (event_0)=>{
            if (event_0.key === "Escape" && isContentStateMenuOpen) {
                if (isColorPickerOpen) onColorPickerClose();
                else onPopupClose();
            }
        };
        $[3] = isColorPickerOpen;
        $[4] = isContentStateMenuOpen;
        $[5] = onColorPickerClose;
        $[6] = onPopupClose;
        $[7] = t3;
    } else t3 = $[7];
    const handleKeydown = t3;
    let t4;
    if ($[8] !== handleKeydown) {
        t4 = ()=>{
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        $[8] = handleKeydown;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== handleKeydown || $[11] !== isColorPickerOpen) {
        t5 = [
            isColorPickerOpen,
            handleKeydown
        ];
        $[10] = handleKeydown;
        $[11] = isColorPickerOpen;
        $[12] = t5;
    } else t5 = $[12];
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[13] !== handleClickOutside) {
        t6 = ()=>{
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        };
        t7 = [
            handleClickOutside
        ];
        $[13] = handleClickOutside;
        $[14] = t6;
        $[15] = t7;
    } else {
        t6 = $[14];
        t7 = $[15];
    }
    (0, $42omo.useEffect)(t6, t7);
    const didRender = (0, $42omo.useRef)(false);
    let t8;
    if ($[16] !== updatePopup) {
        t8 = ()=>{
            if (!didRender.current) {
                didRender.current = true;
                return;
            }
            updatePopup();
        };
        $[16] = updatePopup;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== customStatesArray || $[19] !== defaultStatesArray || $[20] !== updatePopup) {
        t9 = [
            defaultStatesArray,
            customStatesArray,
            updatePopup
        ];
        $[18] = customStatesArray;
        $[19] = defaultStatesArray;
        $[20] = updatePopup;
        $[21] = t9;
    } else t9 = $[21];
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    if ($[22] !== contentType || $[23] !== formatMessage) {
        t10 = contentType === "blogpost" ? formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).setBlogStatus) : formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).setPageStatus);
        $[22] = contentType;
        $[23] = formatMessage;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "xsmall",
            as: "h2"
        }, t10);
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    const t12 = !!contentStateState.state.contentState;
    let t13;
    if ($[27] !== onMouseEnterRemove || $[28] !== onMouseLeaveRemove || $[29] !== onRemove || $[30] !== t12 || $[31] !== userOffline) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a14c780b3cacba28$export$4e9d5ce1e6c22a94), {
            hasContentState: t12,
            onClick: onRemove,
            onMouseEnter: onMouseEnterRemove,
            onMouseLeave: onMouseLeaveRemove,
            userOffline: userOffline
        });
        $[27] = onMouseEnterRemove;
        $[28] = onMouseLeaveRemove;
        $[29] = onRemove;
        $[30] = t12;
        $[31] = userOffline;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t11 || $[34] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$HeaderWrapper, null, t11, t13);
        $[33] = t11;
        $[34] = t13;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== isColorPickerOpen || $[37] !== isContentStateEnabled || $[38] !== isCreatingContentState || $[39] !== isCustomEnabled || $[40] !== onCancel || $[41] !== onColorPickerClose || $[42] !== onColorPickerToggle || $[43] !== onFocusTextField || $[44] !== onSelectColor || $[45] !== onSubmit || $[46] !== selectedColor || $[47] !== userOffline) {
        t15 = isCustomEnabled && isContentStateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$FormWrapper, {
            "data-testid": "form-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45bd28dec8e86674$export$2ae5c8bd8129bb8e), {
            onSubmit: onSubmit,
            onCancel: onCancel,
            showFormFooter: isCreatingContentState,
            selectedColor: selectedColor,
            onSelectColor: onSelectColor,
            isColorPickerOpen: isColorPickerOpen,
            onColorPickerToggle: onColorPickerToggle,
            onColorPickerClose: onColorPickerClose,
            onFocusTextField: onFocusTextField,
            userOffline: userOffline,
            colorPickerComponentRef: colorPickerComponent
        }));
        $[36] = isColorPickerOpen;
        $[37] = isContentStateEnabled;
        $[38] = isCreatingContentState;
        $[39] = isCustomEnabled;
        $[40] = onCancel;
        $[41] = onColorPickerClose;
        $[42] = onColorPickerToggle;
        $[43] = onFocusTextField;
        $[44] = onSelectColor;
        $[45] = onSubmit;
        $[46] = selectedColor;
        $[47] = userOffline;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== contentId || $[50] !== contentStateState || $[51] !== customStatesArray || $[52] !== defaultStatesArray || $[53] !== formatMessage || $[54] !== isContentStateEnabled || $[55] !== isCreatingContentState || $[56] !== isCustomEnabled || $[57] !== isSuggestedEnabled || $[58] !== onUpdateSuccess || $[59] !== setIsContentStateMenuOpen || $[60] !== userOffline) {
        t16 = isContentStateEnabled ? !isCreatingContentState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$HorizontalDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$ContentStateGroupsWrapper, {
            "data-testid": "content-state-group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742e27b1b03e5e97$export$710aa0e581cfaff9), {
            contentId: contentId,
            contentStateState: contentStateState,
            groupIsEnabled: isCustomEnabled,
            groupLabel: (0, $c169b00c0122f30f$export$fa2d28b3b2819e2d),
            contentStates: customStatesArray,
            userOffline: userOffline,
            onUpdateSuccess: onUpdateSuccess,
            setIsContentStateMenuOpen: setIsContentStateMenuOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $742e27b1b03e5e97$export$710aa0e581cfaff9), {
            contentId: contentId,
            contentStateState: contentStateState,
            groupIsEnabled: isSuggestedEnabled,
            groupLabel: (0, $c169b00c0122f30f$export$b3c3dee917fc137d),
            contentStates: defaultStatesArray,
            userOffline: userOffline,
            onUpdateSuccess: onUpdateSuccess,
            setIsContentStateMenuOpen: setIsContentStateMenuOpen
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$ContentStateDisabledDiv, {
            "data-testid": "content-state-disabled"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$HorizontalDivider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$FeatureDisabledGraphic, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8ccd225f267efb0e$exports))),
            alt: "content states disabled graphic"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$FeatureDisabledTextWrapper, {
            "data-testid": "feature-disabled-text"
        }, formatMessage((0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).featureDisabled)));
        $[49] = contentId;
        $[50] = contentStateState;
        $[51] = customStatesArray;
        $[52] = defaultStatesArray;
        $[53] = formatMessage;
        $[54] = isContentStateEnabled;
        $[55] = isCreatingContentState;
        $[56] = isCustomEnabled;
        $[57] = isSuggestedEnabled;
        $[58] = onUpdateSuccess;
        $[59] = setIsContentStateMenuOpen;
        $[60] = userOffline;
        $[61] = t16;
    } else t16 = $[61];
    let t17;
    if ($[62] !== t14 || $[63] !== t15 || $[64] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($35470e23ff8dc4a3$var$ContentStateMenuWrapper, {
            ref: menuComponent
        }, t14, t15, t16);
        $[62] = t14;
        $[63] = t15;
        $[64] = t16;
        $[65] = t17;
    } else t17 = $[65];
    return t17;
};
const $35470e23ff8dc4a3$export$d369faa039f625c2 = (0, $aXWIB.injectIntl)($35470e23ff8dc4a3$var$ContentStateMenuComponent);










































var $56M4r = parcelRequire("56M4r");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $5nBzc = parcelRequire("5nBzc");


var $jluld = parcelRequire("jluld");




















var $bvNVx = parcelRequire("bvNVx");




const $5d70772a7c73eccb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    searchPlaceholder: {
        id: "content-state.menu.v2.search-placeholder",
        defaultMessage: "Search or add"
    },
    defaultWorkflow: {
        id: "content-state.menu.v2.default-workflow",
        defaultMessage: "Default workflow"
    },
    customStatuses: {
        id: "content-state.menu.v2.custom-statuses",
        defaultMessage: "Custom statuses"
    },
    addCustomStatus: {
        id: "content-state.menu.v2.add-custom-status.title",
        defaultMessage: "Add as custom status"
    },
    addCustomStatusDescription: {
        id: "content-state.menu.v2.add-custom-status.description",
        defaultMessage: "Only you can choose this"
    },
    addCustomStatusHeader: {
        id: "content-state.menu.v2.add-custom-status-view.header",
        defaultMessage: "Add custom status"
    },
    statusNamePlaceholder: {
        id: "content-state.menu.v2.status-name.placeholder",
        defaultMessage: "Status name"
    },
    cancel: {
        id: "content-state.menu.v2.cancel",
        defaultMessage: "Cancel"
    },
    save: {
        id: "content-state.menu.v2.save",
        defaultMessage: "Save"
    },
    changeStatus: {
        id: "content-state.menu.v2.change-status",
        defaultMessage: "Change status"
    },
    startApproval: {
        id: "content-state.menu.v2.start-approval",
        defaultMessage: "Start approval"
    },
    approvalBetaTag: {
        id: "content-state.menu.v2.color-picker.option.aria-label",
        defaultMessage: "Beta"
    },
    colorPickerLabel: {
        id: "content-state.menu.v2.color-picker.aria-label",
        defaultMessage: "Color picker selector"
    },
    colorOption: {
        id: "content-state.menu.v2.color-picker.option.aria-label",
        defaultMessage: "Color option"
    },
    featureDisabled: {
        id: "content-state.menu.v2.feature-disabled",
        defaultMessage: "The content status feature is not enabled in this space."
    },
    featureDisabledImg: {
        id: "content-state.menu.v2.feature-disabled-img",
        defaultMessage: "Content states disabled graphic"
    }
});


const $217fbcf232c8becc$var$styles = {
    dialog: "_1ul9nklw _p12f1gwv",
    row: "_4cvr1h6o _bfhksm61 _80omtlke _1bah1yb4",
    searchInput: "_18zrutpp _ca0qu2gc",
    after: "_y4ti12x7",
    workflowStatusBadge: "_zulpu2gc _bfhksm61 _80omtlke _syaz1rpy _4cvr1h6o",
    workflowStatusLabel: "_zulpu2gc _4cvr1h6o",
    badgeWrapperStyles: "_2rkolb4i _1rjcv77o _18zr1b66 _bfhkhfxm",
    iconStyles: "_18u01i6y"
};
const $217fbcf232c8becc$var$StatusOptionRow = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { option: option, onSelect: onSelect, isActive: isActive } = t0;
    let t1;
    if ($[0] !== onSelect || $[1] !== option) {
        t1 = ()=>{
            if (option && option.name) onSelect(option);
        };
        $[0] = onSelect;
        $[1] = option;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    let t2;
    if ($[3] !== option.color || $[4] !== option.restrictionLevel) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
            color: option.color,
            restrictionLevel: option.restrictionLevel,
            appearance: "contentStateButton"
        });
        $[3] = option.color;
        $[4] = option.restrictionLevel;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== handleClick || $[7] !== isActive || $[8] !== option.name || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            isSelected: isActive,
            iconBefore: t2,
            onClick: handleClick
        }, option.name);
        $[6] = handleClick;
        $[7] = isActive;
        $[8] = option.name;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
};
const $217fbcf232c8becc$var$WorkflowStatusOptionRow = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { status: status, onSelect: onSelect } = t0;
    let t1;
    if ($[0] !== onSelect || $[1] !== status) {
        t1 = ()=>onSelect(status);
        $[0] = onSelect;
        $[1] = status;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const Icon = status.id === (0, $bvNVx.CHANGES_REQUESTED_STATUS_ID) && (0, $9wGTI.fg)("hello_100_release_updates") ? (0, (/*@__PURE__*/$parcel$interopDefault($bJRX9))) : (0, (/*@__PURE__*/$parcel$interopDefault($gITTQ)));
    let t2;
    if ($[3] !== Icon) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $217fbcf232c8becc$var$styles.iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            size: "small",
            color: "var(--ds-icon-accent-blue, #357DE8)",
            spacing: "none"
        }));
        $[3] = Icon;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = `workflow-status-option-${status.id}`;
    let t4;
    if ($[5] !== status.allowsReviews || $[6] !== status.name) {
        t4 = status.allowsReviews && (0, $9wGTI.fg)("hello_100_release_updates") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).startApproval) : status.name;
        $[5] = status.allowsReviews;
        $[6] = status.name;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== status.allowsReviews) {
        t5 = status.allowsReviews && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).approvalBetaTag));
        $[8] = status.allowsReviews;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $217fbcf232c8becc$var$styles.workflowStatusLabel
        }, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== status.allowsReviews) {
        t7 = status.allowsReviews && (0, $9wGTI.fg)("hello_100_release_updates") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            size: "small",
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $217fbcf232c8becc$var$styles.workflowStatusBadge
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $217fbcf232c8becc$var$styles.badgeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).startApproval))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            size: "small",
            label: ""
        }));
        $[13] = status.allowsReviews;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $217fbcf232c8becc$var$styles.row
        }, t6, t7);
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleClick || $[19] !== t2 || $[20] !== t3 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            iconBefore: t2,
            onClick: handleClick,
            testId: t3
        }, t8);
        $[18] = handleClick;
        $[19] = t2;
        $[20] = t3;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $217fbcf232c8becc$var$ContentStateMenuV2SelectViewComponent = (t0)=>{
    const $ = (0, $frIzR.c)(48);
    const { searchValue: searchValue, onSearchChange: onSearchChange, filteredDefaultSection: filteredDefaultSection, filteredCustomOptions: filteredCustomOptions, hasResults: hasResults, currentContentState: currentContentState, onSelectStatus: onSelectStatus, onSelectWorkflowStatus: onSelectWorkflowStatus, onAddCustomClick: onAddCustomClick, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    let t2;
    if ($[0] !== onSearchChange) {
        t2 = (e)=>onSearchChange(e.currentTarget.value);
        $[0] = onSearchChange;
        $[1] = t2;
    } else t2 = $[1];
    const handleSearchChange = t2;
    let t3;
    bb0: {
        if (!(0, $9wGTI.fg)("hello_100_release_updates")) {
            let t4;
            if ($[2] !== filteredDefaultSection) {
                t4 = {
                    nonApprovalDefaultRows: filteredDefaultSection,
                    approvalRow: undefined
                };
                $[2] = filteredDefaultSection;
                $[3] = t4;
            } else t4 = $[3];
            t3 = t4;
            break bb0;
        }
        let t4;
        if ($[4] !== filteredDefaultSection) {
            const nonApproval = [];
            let approval;
            for (const item of filteredDefaultSection)if (item.type === "workflowStatus" && item.workflowStatus.allowsReviews && approval === undefined) approval = item;
            else nonApproval.push(item);
            t4 = {
                nonApprovalDefaultRows: nonApproval,
                approvalRow: approval
            };
            $[4] = filteredDefaultSection;
            $[5] = t4;
        } else t4 = $[5];
        t3 = t4;
    }
    const { nonApprovalDefaultRows: nonApprovalDefaultRows, approvalRow: approvalRow } = t3;
    let t4;
    if ($[6] !== filteredCustomOptions.length || $[7] !== formatMessage) {
        t4 = filteredCustomOptions.length > 0 || !(0, $9wGTI.fg)("hello_100_release_updates") ? formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).defaultWorkflow) : undefined;
        $[6] = filteredCustomOptions.length;
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    const defaultSectionTitle = t4;
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).searchPlaceholder);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== formatMessage) {
        t6 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).searchPlaceholder);
        $[11] = formatMessage;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $217fbcf232c8becc$var$styles.after
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: ""
        }));
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== handleSearchChange || $[15] !== searchValue || $[16] !== t5 || $[17] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $217fbcf232c8becc$var$styles.searchInput
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            name: "status-search",
            "aria-label": t5,
            placeholder: t6,
            maxLength: 20,
            isCompact: true,
            value: searchValue,
            onChange: handleSearchChange,
            elemAfterInput: t7,
            testId: "status-search-input"
        })));
        $[14] = handleSearchChange;
        $[15] = searchValue;
        $[16] = t5;
        $[17] = t6;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== currentContentState?.id || $[20] !== defaultSectionTitle || $[21] !== nonApprovalDefaultRows || $[22] !== onSelectStatus || $[23] !== onSelectWorkflowStatus) {
        t9 = nonApprovalDefaultRows.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            title: defaultSectionTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), null, nonApprovalDefaultRows.map((item_0)=>item_0.type === "contentState" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($217fbcf232c8becc$var$StatusOptionRow, {
                key: item_0.contentState.id,
                option: item_0.contentState,
                onSelect: onSelectStatus,
                isActive: currentContentState?.id === item_0.contentState.id
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($217fbcf232c8becc$var$WorkflowStatusOptionRow, {
                key: `workflow-${item_0.workflowStatus.id}`,
                status: item_0.workflowStatus,
                onSelect: onSelectWorkflowStatus
            }))));
        $[19] = currentContentState?.id;
        $[20] = defaultSectionTitle;
        $[21] = nonApprovalDefaultRows;
        $[22] = onSelectStatus;
        $[23] = onSelectWorkflowStatus;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== currentContentState?.id || $[26] !== filteredCustomOptions || $[27] !== formatMessage || $[28] !== onSelectStatus) {
        t10 = filteredCustomOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            title: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).customStatuses)
        }, filteredCustomOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($217fbcf232c8becc$var$StatusOptionRow, {
                key: option.id,
                option: option,
                onSelect: onSelectStatus,
                isActive: currentContentState?.id === option.id
            })));
        $[25] = currentContentState?.id;
        $[26] = filteredCustomOptions;
        $[27] = formatMessage;
        $[28] = onSelectStatus;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== approvalRow || $[31] !== filteredCustomOptions.length || $[32] !== nonApprovalDefaultRows.length || $[33] !== onSelectWorkflowStatus) {
        t11 = approvalRow && approvalRow.type === "workflowStatus" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            hasSeparator: nonApprovalDefaultRows.length > 0 || filteredCustomOptions.length > 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($217fbcf232c8becc$var$WorkflowStatusOptionRow, {
            key: `workflow-${approvalRow.workflowStatus.id}`,
            status: approvalRow.workflowStatus,
            onSelect: onSelectWorkflowStatus
        }));
        $[30] = approvalRow;
        $[31] = filteredCustomOptions.length;
        $[32] = nonApprovalDefaultRows.length;
        $[33] = onSelectWorkflowStatus;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== formatMessage || $[36] !== hasResults || $[37] !== onAddCustomClick || $[38] !== searchValue) {
        t12 = !hasResults && searchValue.trim() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: ""
            }),
            description: formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).addCustomStatusDescription),
            onClick: onAddCustomClick,
            testId: "add-custom-status-button"
        }, formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).addCustomStatus)));
        $[35] = formatMessage;
        $[36] = hasResults;
        $[37] = onAddCustomClick;
        $[38] = searchValue;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
            isScrollable: true
        }, t9, t10, t11, t12);
        $[40] = t10;
        $[41] = t11;
        $[42] = t12;
        $[43] = t9;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== t13 || $[46] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $217fbcf232c8becc$var$styles.dialog,
            testId: "status-selector-popup-menu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), {
            maxHeight: 360
        }, t8, t13));
        $[45] = t13;
        $[46] = t8;
        $[47] = t14;
    } else t14 = $[47];
    return t14;
};
const $217fbcf232c8becc$export$2736d93594f59257 = (0, $aXWIB.injectIntl)($217fbcf232c8becc$var$ContentStateMenuV2SelectViewComponent);












var $ccHMk = parcelRequire("ccHMk");

















var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $bPdpL = parcelRequire("bPdpL");











const $8363866a64cc2105$var$styles = {
    dialog: "_1ul9nklw _p12f1gwv",
    addCustomHeader: "_zulpu2gc _4cvr1h6o _6rthpxbi",
    addCustomForm: "_zulputpp",
    colorAndName: "_zulpu2gc",
    formButtons: "_zulpu2gc _1bahesu3",
    addCustomContainer: "_18zrpxbi _1rjcpxbi",
    colorButtonContent: "_4t3igktf",
    colorPickerButton: "_2rko12b0 _1h6drsbi _189ee4h9 _1dqonqa1 _bfhk1j9a"
};
const $8363866a64cc2105$var$colorsArray = [
    (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
    (0, $Uu0Pb.PRIMARY_COLORS).GREEN,
    (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
    (0, $Uu0Pb.PRIMARY_COLORS).RED,
    (0, $Uu0Pb.PRIMARY_COLORS).PURPLE
];
const $8363866a64cc2105$var$ContentStateMenuV2CreateViewComponent = (t0)=>{
    const $ = (0, $frIzR.c)(54);
    const { initialValue: initialValue, onBack: onBack, onSave: onSave, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    const [statusName, setStatusName] = (0, $42omo.useState)(initialValue);
    const [selectedColorId, setSelectedColorId] = (0, $42omo.useState)($8363866a64cc2105$var$colorsArray[0] || "");
    let t2;
    if ($[0] !== onSave || $[1] !== selectedColorId || $[2] !== statusName) {
        t2 = ()=>{
            if (statusName.trim()) onSave(statusName.trim(), selectedColorId);
        };
        $[0] = onSave;
        $[1] = selectedColorId;
        $[2] = statusName;
        $[3] = t2;
    } else t2 = $[3];
    const handleSave = t2;
    let t3;
    if ($[4] !== onBack) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
            label: "Back",
            spacing: "compact",
            onClick: onBack,
            testId: "back-to-search-button"
        });
        $[4] = onBack;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== formatMessage) {
        t4 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).addCustomStatusHeader);
        $[6] = formatMessage;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "xsmall"
        }, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t3 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $8363866a64cc2105$var$styles.addCustomHeader
        }, t3, t5);
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== formatMessage || $[14] !== selectedColorId) {
        t7 = (t8)=>{
            const { triggerRef: triggerRef, ...triggerProps } = t8;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $8363866a64cc2105$var$styles.colorPickerButton
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                iconAfter: $8363866a64cc2105$var$_temp,
                "aria-label": formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).colorPickerLabel),
                testId: "color-picker-trigger"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignBlock: "center",
                xcss: $8363866a64cc2105$var$styles.colorButtonContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
                color: selectedColorId,
                appearance: "contentStateButton"
            }))));
        };
        $[13] = formatMessage;
        $[14] = selectedColorId;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== formatMessage) {
        t8 = $8363866a64cc2105$var$colorsArray.map((color, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
                key: color,
                onClick: ()=>setSelectedColorId(color || ""),
                testId: `color-option-${index}`,
                "aria-label": formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).colorOption)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                xcss: $8363866a64cc2105$var$styles.colorAndName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
                color: color,
                appearance: "contentStateButton"
            }))));
        $[16] = formatMessage;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, t8);
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== t7 || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            trigger: t7,
            placement: "bottom-start"
        }, t9);
        $[20] = t7;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (e)=>setStatusName(e.currentTarget.value);
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== formatMessage) {
        t12 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).statusNamePlaceholder);
        $[24] = formatMessage;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== statusName || $[27] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            value: statusName,
            onChange: t11,
            placeholder: t12,
            appearance: "standard",
            maxLength: 20,
            isCompact: true,
            testId: "custom-status-name-input"
        });
        $[26] = statusName;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t10 || $[30] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $8363866a64cc2105$var$styles.colorAndName
        }, t10, t13);
        $[29] = t10;
        $[30] = t13;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== formatMessage) {
        t15 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).cancel);
        $[32] = formatMessage;
        $[33] = t15;
    } else t15 = $[33];
    let t16;
    if ($[34] !== onBack || $[35] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: onBack,
            testId: "cancel-custom-status-button"
        }, t15);
        $[34] = onBack;
        $[35] = t15;
        $[36] = t16;
    } else t16 = $[36];
    let t17;
    if ($[37] !== statusName) {
        t17 = statusName.trim();
        $[37] = statusName;
        $[38] = t17;
    } else t17 = $[38];
    const t18 = !t17;
    let t19;
    if ($[39] !== formatMessage) {
        t19 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).save);
        $[39] = formatMessage;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== handleSave || $[42] !== t18 || $[43] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleSave,
            isDisabled: t18,
            testId: "save-custom-status-button"
        }, t19);
        $[41] = handleSave;
        $[42] = t18;
        $[43] = t19;
        $[44] = t20;
    } else t20 = $[44];
    let t21;
    if ($[45] !== t16 || $[46] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            xcss: $8363866a64cc2105$var$styles.formButtons
        }, t16, t20);
        $[45] = t16;
        $[46] = t20;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== t14 || $[49] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $8363866a64cc2105$var$styles.addCustomForm
        }, t14, t21);
        $[48] = t14;
        $[49] = t21;
        $[50] = t22;
    } else t22 = $[50];
    let t23;
    if ($[51] !== t22 || $[52] !== t6) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $8363866a64cc2105$var$styles.dialog,
            testId: "add-custom-status-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $8363866a64cc2105$var$styles.addCustomContainer
        }, t6, t22));
        $[51] = t22;
        $[52] = t6;
        $[53] = t23;
    } else t23 = $[53];
    return t23;
};
const $8363866a64cc2105$export$1b183f966e13e015 = (0, $aXWIB.injectIntl)($8363866a64cc2105$var$ContentStateMenuV2CreateViewComponent);
function $8363866a64cc2105$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        size: "small"
    });
}


















const $07266645e67f8a5c$var$styles = {
    dialog: "_18zrpxbi _p12f1178 _1q51pxbi _85i5u2gc",
    message: "_18s8utpp _syaz1gmx _y3gn1h6o"
};
const $07266645e67f8a5c$var$ContentStateMenuV2DisabledViewComponent = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).featureDisabledImg);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "img",
            height: "var(--ds-space-1000, 80px)",
            width: "var(--ds-space-800, 64px)",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8ccd225f267efb0e$exports))),
            alt: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $5d70772a7c73eccb$export$a7357cdd1f0b0168).featureDisabled);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "p",
            xcss: $07266645e67f8a5c$var$styles.message
        }, t4);
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t3 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            xcss: $07266645e67f8a5c$var$styles.dialog,
            alignInline: "center",
            testId: "content-state-disabled-v2"
        }, t3, t5);
        $[8] = t3;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
};
const $07266645e67f8a5c$export$e173ca5f21a59a52 = (0, $aXWIB.injectIntl)($07266645e67f8a5c$var$ContentStateMenuV2DisabledViewComponent);


var $eeca34bbf5c80885$var$ConstentStateMenuViewTypes = /*#__PURE__*/ function(ConstentStateMenuViewTypes) {
    ConstentStateMenuViewTypes["SELECT"] = "select";
    ConstentStateMenuViewTypes["CREATE"] = "create";
    return ConstentStateMenuViewTypes;
}($eeca34bbf5c80885$var$ConstentStateMenuViewTypes || {});
const $eeca34bbf5c80885$var$ContentStateMenuV2Component = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { contentStateState: contentStateState, contentType: contentType, isLivePage: isLivePage, defaultStatesArray: defaultStatesArray, customStatesArray: customStatesArray, onSelectExistingStatus: onSelectExistingStatus, onSaveCustomStatus: onSaveCustomStatus, onRemove: onRemove, setIsContentStateMenuOpen: setIsContentStateMenuOpen, workflowStatuses: t1, onSelectWorkflowStatus: onSelectWorkflowStatus } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const workflowStatuses = t2;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const [searchValue, setSearchValue] = (0, $42omo.useState)("");
    const [currentView, setCurrentView] = (0, $42omo.useState)("select");
    const menuRef = (0, $42omo.useRef)(null);
    let t3;
    if ($[2] !== defaultStatesArray) {
        t3 = defaultStatesArray || [];
        $[2] = defaultStatesArray;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = t3.filter($eeca34bbf5c80885$var$_temp);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const validDefaultStates = t4;
    let t5;
    if ($[6] !== customStatesArray) {
        t5 = customStatesArray || [];
        $[6] = customStatesArray;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = t5.filter($eeca34bbf5c80885$var$_temp2);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const validCustomStates = t6;
    let t7;
    if ($[10] !== contentType || $[11] !== isLivePage || $[12] !== isPremium || $[13] !== validDefaultStates || $[14] !== workflowStatuses) {
        bb0: {
            const contentStateItems = validDefaultStates.map($eeca34bbf5c80885$var$_temp3);
            if (contentType !== "page" || isLivePage || workflowStatuses.length === 0 || !isPremium) {
                t7 = contentStateItems;
                break bb0;
            }
            const workflowItems = workflowStatuses.map($eeca34bbf5c80885$var$_temp4);
            const restrictedIndex = contentStateItems.findIndex($eeca34bbf5c80885$var$_temp5);
            if (restrictedIndex !== -1) {
                const result = [
                    ...contentStateItems
                ];
                result.splice(restrictedIndex, 0, ...workflowItems);
                t7 = result;
                break bb0;
            }
            t7 = [
                ...contentStateItems,
                ...workflowItems
            ];
        }
        $[10] = contentType;
        $[11] = isLivePage;
        $[12] = isPremium;
        $[13] = validDefaultStates;
        $[14] = workflowStatuses;
        $[15] = t7;
    } else t7 = $[15];
    const mergedDefaultSection = t7;
    const [selectedContentState, setSelectedContentState] = (0, $42omo.useState)(null);
    const currentContentState = selectedContentState ?? contentStateState.state.contentState;
    let t8;
    if ($[16] !== currentContentState?.id || $[17] !== onRemove || $[18] !== onSelectExistingStatus || $[19] !== setIsContentStateMenuOpen) {
        t8 = (selectedStatus)=>{
            if (currentContentState?.id === selectedStatus.id) {
                setSelectedContentState(null);
                onRemove();
                setIsContentStateMenuOpen(false);
                setSearchValue("");
                return;
            }
            setSelectedContentState(selectedStatus);
            onSelectExistingStatus(selectedStatus);
            setIsContentStateMenuOpen(false);
            setSearchValue("");
        };
        $[16] = currentContentState?.id;
        $[17] = onRemove;
        $[18] = onSelectExistingStatus;
        $[19] = setIsContentStateMenuOpen;
        $[20] = t8;
    } else t8 = $[20];
    const handleSelectStatus = t8;
    let t9;
    bb1: {
        if (!searchValue.trim()) {
            t9 = mergedDefaultSection;
            break bb1;
        }
        let t10;
        if ($[21] !== mergedDefaultSection || $[22] !== searchValue) {
            const lowerQuery = searchValue.toLowerCase();
            t10 = mergedDefaultSection.filter((item_0)=>{
                const name = item_0.type === "contentState" ? item_0.contentState.name : item_0.workflowStatus.name;
                return name?.toLowerCase().includes(lowerQuery);
            });
            $[21] = mergedDefaultSection;
            $[22] = searchValue;
            $[23] = t10;
        } else t10 = $[23];
        t9 = t10;
    }
    const filteredDefaultSection = t9;
    let t10;
    bb2: {
        if (!searchValue.trim()) {
            t10 = validCustomStates;
            break bb2;
        }
        let t11;
        if ($[24] !== searchValue || $[25] !== validCustomStates) {
            const lowerQuery_0 = searchValue.toLowerCase();
            t11 = validCustomStates.filter((option)=>option.name?.toLowerCase().includes(lowerQuery_0));
            $[24] = searchValue;
            $[25] = validCustomStates;
            $[26] = t11;
        } else t11 = $[26];
        t10 = t11;
    }
    const filteredCustomOptions = t10;
    const hasResults = filteredDefaultSection.length > 0 || filteredCustomOptions.length > 0;
    let t11;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>{
            setCurrentView("create");
        };
        $[27] = t11;
    } else t11 = $[27];
    const handleAddCustomClick = t11;
    let t12;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setCurrentView("select");
        };
        $[28] = t12;
    } else t12 = $[28];
    const handleBackToSearch = t12;
    let t13;
    if ($[29] !== onSaveCustomStatus || $[30] !== setIsContentStateMenuOpen) {
        t13 = (statusName, colorId)=>{
            onSaveCustomStatus(statusName, colorId);
            setIsContentStateMenuOpen(false);
            setCurrentView("select");
            setSearchValue("");
        };
        $[29] = onSaveCustomStatus;
        $[30] = setIsContentStateMenuOpen;
        $[31] = t13;
    } else t13 = $[31];
    const handleSaveCustomStatus = t13;
    if (!contentStateState.state.isContentStateEnabled) {
        let t14;
        if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                ref: menuRef,
                testId: "content-state-menu-v2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $07266645e67f8a5c$export$e173ca5f21a59a52), null));
            $[32] = t14;
        } else t14 = $[32];
        return t14;
    }
    if (currentView === "create") {
        let t14;
        if ($[33] !== handleSaveCustomStatus || $[34] !== searchValue) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                ref: menuRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8363866a64cc2105$export$1b183f966e13e015), {
                initialValue: searchValue,
                onBack: handleBackToSearch,
                onSave: handleSaveCustomStatus
            }));
            $[33] = handleSaveCustomStatus;
            $[34] = searchValue;
            $[35] = t14;
        } else t14 = $[35];
        return t14;
    }
    let t14;
    if ($[36] !== currentContentState || $[37] !== filteredCustomOptions || $[38] !== filteredDefaultSection || $[39] !== handleSelectStatus || $[40] !== hasResults || $[41] !== onSelectWorkflowStatus || $[42] !== searchValue) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: menuRef,
            testId: "content-state-menu-v2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $217fbcf232c8becc$export$2736d93594f59257), {
            searchValue: searchValue,
            onSearchChange: setSearchValue,
            filteredDefaultSection: filteredDefaultSection,
            filteredCustomOptions: filteredCustomOptions,
            hasResults: hasResults,
            currentContentState: currentContentState,
            onSelectStatus: handleSelectStatus,
            onSelectWorkflowStatus: onSelectWorkflowStatus,
            onAddCustomClick: handleAddCustomClick
        }));
        $[36] = currentContentState;
        $[37] = filteredCustomOptions;
        $[38] = filteredDefaultSection;
        $[39] = handleSelectStatus;
        $[40] = hasResults;
        $[41] = onSelectWorkflowStatus;
        $[42] = searchValue;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
};
const $eeca34bbf5c80885$export$7cb66675cb7730f8 = (0, $aXWIB.injectIntl)($eeca34bbf5c80885$var$ContentStateMenuV2Component);
function $eeca34bbf5c80885$var$_temp(s) {
    return s !== null;
}
function $eeca34bbf5c80885$var$_temp2(s_0) {
    return s_0 !== null;
}
function $eeca34bbf5c80885$var$_temp3(s_1) {
    return {
        type: "contentState",
        contentState: s_1
    };
}
function $eeca34bbf5c80885$var$_temp4(s_2) {
    return {
        type: "workflowStatus",
        workflowStatus: s_2
    };
}
function $eeca34bbf5c80885$var$_temp5(item) {
    return item.type === "contentState" && item.contentState.restrictionLevel !== "NONE";
}









const $1478047e1c32b5f4$export$fd37fef230d4b03a = ({ contentId: contentId, contentType: contentType, contentStateState: contentStateState, userOffline: userOffline, flags: flags, forceContentStatePlacementToTop: forceContentStatePlacementToTop, onUpdateSuccess: onUpdateSuccess, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick, isViewMode: isViewMode, canEdit: canEdit = true })=>{
    const contentStateButtonRef = (0, $42omo.useRef)(null);
    const [isContentStateMenuOpen, setIsContentStateMenuOpen] = (0, $42omo.useState)(false);
    const [isShowingInfoPopup, setIsShowingInfoPopup] = (0, $42omo.useState)(false);
    const [isShowingOtherModeBlockingPopup, setIsShowingOtherModeBlockingPopup] = (0, $42omo.useState)(false);
    const [isCreatingContentState, setIsCreatingContentState] = (0, $42omo.useState)(false);
    const [selectedColor, setSelectedColor] = (0, $42omo.useState)(null);
    const [isColorPickerOpen, setIsColorPickerOpen] = (0, $42omo.useState)(false);
    const [isHoveringRemove, setIsHoveringRemove] = (0, $42omo.useState)(false);
    const [showChangeStatusModal, setShowChangeStatusModal] = (0, $42omo.useState)(false);
    const originalContentState = (0, $42omo.useRef)(contentStateState.state.contentState);
    // Track if we're creating a NEW custom status (V1) vs selecting existing or V2 optimistic
    // Used to determine if onCompleted should update customStatesArray
    const isCreatingNewCustomStatusRef = (0, $42omo.useRef)(false);
    const setIsContentStateMenuOpenWithListener = (0, $42omo.useCallback)((newValue)=>{
        onContentStateMenuToggle?.(newValue);
        setIsContentStateMenuOpen(newValue);
    }, [
        onContentStateMenuToggle
    ]);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Suppress the loading skeleton during SSR/initial-hydration to avoid a CLIENT_MISMATCH
    // hydration error: the server renders no skeleton (multiple sources of truth combine to
    // `false`), but the client's first render of the real ApprovalsProvider has
    // `approvalRequestLoading=true` (initial useState before useEffect runs the fetch).
    // Rendering the skeleton only after hydration completes keeps the first client render
    // identical to the server render. See PR #349185 / CCIMPORTER-1635 follow-up.
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const contentState = contentStateState.state.contentState;
    const contentStateLastUpdated = contentStateState.state.contentStateLastUpdated;
    // Approvals context hooks (safe to call unconditionally — returns defaults when provider absent)
    const { availableWorkflowStatuses: availableWorkflowStatuses, approvalRequest: approvalRequest, approvalRequestLoading: approvalRequestLoading, otherModeReviewStatus: otherModeReviewStatus, isContentApprovalsEnabled: isContentApprovalsEnabled } = (0, $laFNM.useApprovals)();
    const { createWorkflowApplication: createWorkflowApplication, cancelWorkflowApplication: cancelWorkflowApplication, clearApprovalRequestOptimistically: clearApprovalRequestOptimistically } = (0, $laFNM.useApprovalsDispatch)();
    const activeWorkflowStatus = (0, $42omo.useMemo)(()=>{
        const activeStatusId = approvalRequest?.application?.workflowStatusId;
        if (!activeStatusId) return null;
        return availableWorkflowStatuses.find((s)=>s.id === activeStatusId) ?? null;
    }, [
        approvalRequest,
        availableWorkflowStatuses
    ]);
    // Memoize the review-eligible statuses — empty when space-level approvals toggle is off
    const reviewEligibleStatuses = (0, $42omo.useMemo)(()=>isContentApprovalsEnabled ? availableWorkflowStatuses.filter((s_0)=>s_0.allowsReviews) : [], [
        availableWorkflowStatuses,
        isContentApprovalsEnabled
    ]);
    const respondedApproverData = (0, $42omo.useMemo)(()=>{
        if (!approvalRequest?.review?.approvers) return [];
        return approvalRequest.review.approvers.reduce((acc, a)=>{
            if (a.status !== null && a.status !== 'PENDING_REVIEW') acc.push({
                name: a.name,
                src: a.avatarUrl,
                email: a.email
            });
            return acc;
        }, []);
    }, [
        approvalRequest
    ]);
    // Fetch user data for content state (skip when workflow status is active — that data comes from ApprovalsContext)
    const shouldFetchUserData = !activeWorkflowStatus && contentState?.lastModifierAaid && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true);
    const { updatedBy: contentStateUpdatedBy, loading: contentStateUserLoading } = (0, $1b65ee0f5f746ca1$export$54fd6c163aea68e2)(shouldFetchUserData ? contentState.lastModifierAaid : null);
    // Resolve update metadata: workflow status data from ApprovalsContext,
    // content state data from the query above
    const updatedBy = activeWorkflowStatus ? approvalRequest?.application?.applicationLastModifiedBy : contentStateUpdatedBy;
    const updatedAt = activeWorkflowStatus ? approvalRequest?.application?.applicationLastModifiedDate || undefined : contentStateLastUpdated ?? undefined;
    const userDataLoading = activeWorkflowStatus ? false : contentStateUserLoading;
    const [shouldSetAutomationFlag, setShouldSetAutomationFlag] = (0, $42omo.useState)(()=>{
        return !(0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE) && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding');
    });
    const [removeContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $da22f1c63dfdcbcc$export$2e2bcd8739ae039), {
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
                        format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
                    }
                }
            ],
        onCompleted: ()=>{
            onUpdateSuccess?.();
        },
        __callerPackage__: "@confluence/content-state"
    });
    const [setContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $428215775b659cb2$export$2e2bcd8739ae039), {
        onError: ()=>{
            isCreatingNewCustomStatusRef.current = false;
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    objectId: contentId,
                    name: 'contentStateErrorFlag',
                    attributes: {
                        contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onCompleted: (data)=>{
            // Only update customStatesArray when creating a NEW custom status (V1 flow)
            // V2 handles this optimistically before the mutation
            if (data.setContentState && isCreatingNewCustomStatusRef.current) {
                const newCustomStatesArray = (0, $3qCob.createNewCustomStatesArrayWhenNewCustomAdded)(contentStateState.state.customStatesArray, data.setContentState);
                contentStateState.setCustomStatesArray(newCustomStatesArray);
                isCreatingNewCustomStatusRef.current = false;
            }
            if (data.setContentState) originalContentState.current = data.setContentState;
            // When confluence_approvals_byline_changes is on, don't reset isUpdating here —
            // let setInitialValues in EditorContentState reset it when the refetch response
            // arrives. This prevents stale refetch data from clobbering optimistic state.
            if (!(0, $9wGTI.fg)('confluence_approvals_byline_changes')) contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        },
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: !isLivePage,
                        shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : !isLivePage,
                        isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
                        format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
                    }
                }
            ],
        __callerPackage__: "@confluence/content-state"
    });
    const [setContentStateAndPublishMutation] = (0, $308Wd.useMutationInterop)((0, $6e181beeac9c50b9$export$2e2bcd8739ae039), {
        onError: ()=>{
            isCreatingNewCustomStatusRef.current = false;
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            // TODO: Add robust error handling
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'contentState',
                    actionSubjectId: 'setContentStateAndPublish',
                    source: 'editorContentState',
                    attributes: {
                        contentId: contentId,
                        contentStatus: 'CURRENT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onCompleted: (data_0)=>{
            if (data_0.setContentStateAndPublish && isCreatingNewCustomStatusRef.current) {
                const newCustomStatesArray_0 = (0, $3qCob.createNewCustomStatesArrayWhenNewCustomAdded)(contentStateState.state.customStatesArray, data_0.setContentStateAndPublish);
                contentStateState.setCustomStatesArray(newCustomStatesArray_0);
                isCreatingNewCustomStatusRef.current = false;
            }
            if (data_0.setContentStateAndPublish) originalContentState.current = data_0.setContentStateAndPublish;
            if (!(0, $9wGTI.fg)('confluence_approvals_byline_changes')) contentStateState.setIsUpdating(false);
            onUpdateSuccess?.();
        },
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: false,
                        shouldSkipContentStateLastUpdated: false,
                        isApprovalsFgOn: true,
                        format: 'MILLIS'
                    }
                }
            ],
        __callerPackage__: "@confluence/content-state"
    });
    const [removeContentStateAndPublishMutation] = (0, $308Wd.useMutationInterop)((0, $4f8f3df3514c68cc$export$2e2bcd8739ae039), {
        onError: ()=>{
            contentStateState.setContentState(originalContentState.current);
            flags.showErrorFlag({
                id: 'content-state-remove-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeErrorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).removeErrorFlagBody)
            });
            // TODO: Add robust error handling
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'contentState',
                    actionSubjectId: 'removeContentStateAndPublish',
                    source: 'editorContentState',
                    attributes: {
                        contentId: contentId,
                        contentStatus: 'CURRENT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        refetchQueries: ()=>[
                {
                    query: (0, $3lWl0.default),
                    variables: {
                        contentId: contentId,
                        isDraft: false,
                        shouldSkipContentStateLastUpdated: false,
                        isApprovalsFgOn: true,
                        format: 'MILLIS'
                    }
                }
            ],
        onCompleted: ()=>{
            onUpdateSuccess?.();
        },
        __callerPackage__: "@confluence/content-state"
    });
    const activeRemoveMutation = isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? removeContentStateAndPublishMutation : removeContentStateMutation;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const isApprovalsPaneOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID);
    const wasApprovalsPaneOpenRef = (0, $42omo.useRef)(isApprovalsPaneOpen);
    // Close the content state info popup only at the moment the approvals pane opens,
    // not continuously while it is open — users should still be able to reopen the popup.
    // TODO: revisit this logic to see if it can be simplified.
    (0, $42omo.useEffect)(()=>{
        if (isApprovalsPaneOpen && !wasApprovalsPaneOpenRef.current && isShowingInfoPopup) setIsShowingInfoPopup(false);
        wasApprovalsPaneOpenRef.current = isApprovalsPaneOpen;
    }, [
        isApprovalsPaneOpen,
        isShowingInfoPopup
    ]);
    // Reset color picker when menu closes
    (0, $42omo.useEffect)(()=>{
        if (!isContentStateMenuOpen) {
            setSelectedColor(null);
            setIsColorPickerOpen(false);
        }
    }, [
        isContentStateMenuOpen
    ]);
    const applyExistingStatus = (0, $42omo.useCallback)((selectedStatus)=>{
        if (isViewMode && !cloudId) return;
        isCreatingNewCustomStatusRef.current = false;
        contentStateState.setIsUpdating(true);
        if (isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) setContentStateAndPublishMutation({
            variables: {
                contentId: contentId,
                contentStateInput: {
                    color: (0, $8miSe.tokenToHex)(selectedStatus.color),
                    name: selectedStatus.name,
                    id: selectedStatus.id
                },
                suppressDraftPropertyUpdate: true,
                cloudId: cloudId
            }
        });
        else setContentStateMutation({
            variables: {
                contentId: contentId,
                contentStateInput: {
                    color: (0, $8miSe.tokenToHex)(selectedStatus.color),
                    name: selectedStatus.name,
                    id: selectedStatus.id
                }
            }
        });
        contentStateState.setContentState(selectedStatus);
        const customStatesArray = contentStateState.state.customStatesArray;
        const customIndex = customStatesArray.findIndex((s_1)=>s_1 !== null && s_1.id === selectedStatus.id);
        if (customIndex !== -1) {
            const newCustomStatesArray_1 = (0, $3qCob.createNewCustomStatesArrayWhenExistingCustomSelected)(customStatesArray, selectedStatus, customIndex);
            contentStateState.setCustomStatesArray(newCustomStatesArray_1);
        }
        if (!isViewMode && shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        const isCustom = customIndex !== -1;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: isCustom ? 'custom' : 'suggested',
                    color: (0, $8miSe.colorCodeToColorName)(selectedStatus.color?.toUpperCase() || ''),
                    restrictionLevel: selectedStatus.restrictionLevel?.toUpperCase(),
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        isLivePage,
        isViewMode,
        shouldSetAutomationFlag,
        setContentStateAndPublishMutation,
        setContentStateMutation,
        cloudId
    ]);
    const applyCustomStatus = (0, $42omo.useCallback)((statusName, colorId)=>{
        if (isViewMode && !cloudId) return;
        if (!(0, $3qCob.isDuplicate)(contentStateState.state.contentState, {
            color: colorId.toLowerCase(),
            name: statusName
        })) {
            const newContentState = {
                color: colorId,
                name: statusName
            };
            contentStateState.setIsUpdating(true);
            isCreatingNewCustomStatusRef.current = true;
            const optimisticCustomState = {
                ...newContentState,
                id: `temp-${Date.now()}`
            };
            const updatedCustomStatesArray = [
                optimisticCustomState,
                ...contentStateState.state.customStatesArray
            ];
            contentStateState.setCustomStatesArray(updatedCustomStatesArray);
            if (isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) setContentStateAndPublishMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState,
                        color: (0, $8miSe.tokenToHex)(colorId)
                    },
                    suppressDraftPropertyUpdate: true,
                    cloudId: cloudId
                }
            });
            else setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState,
                        color: (0, $8miSe.tokenToHex)(colorId)
                    }
                }
            });
            contentStateState.setContentState(newContentState);
        }
        if (!isViewMode && shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: 'new custom',
                    color: (0, $8miSe.colorCodeToColorName)(colorId),
                    restrictionLevel: 'NONE',
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        isLivePage,
        isViewMode,
        shouldSetAutomationFlag,
        setContentStateAndPublishMutation,
        setContentStateMutation,
        cloudId
    ]);
    const handleSelectExistingStatusV2 = (0, $42omo.useCallback)((selectedStatus_0)=>{
        if (activeWorkflowStatus && approvalRequest?.review && approvalRequest.review.reviewStatus === 'PENDING') {
            setShowChangeStatusModal(true);
            return;
        }
        if (activeWorkflowStatus) {
            clearApprovalRequestOptimistically();
            cancelWorkflowApplication();
        }
        applyExistingStatus(selectedStatus_0);
    }, [
        activeWorkflowStatus,
        approvalRequest,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        applyExistingStatus
    ]);
    const handleSaveCustomStatusV2 = (0, $42omo.useCallback)((statusName_0, colorId_0)=>{
        if (activeWorkflowStatus && approvalRequest?.review && approvalRequest.review.reviewStatus === 'PENDING') {
            setShowChangeStatusModal(true);
            return;
        }
        if (activeWorkflowStatus) {
            clearApprovalRequestOptimistically();
            cancelWorkflowApplication();
        }
        applyCustomStatus(statusName_0, colorId_0);
    }, [
        activeWorkflowStatus,
        approvalRequest,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        applyCustomStatus
    ]);
    const applyRemove = (0, $42omo.useCallback)(()=>{
        isCreatingNewCustomStatusRef.current = false;
        if (contentStateState.state.contentState) {
            if ((0, $9wGTI.fg)('confluence_approvals_byline_changes')) contentStateState.setIsUpdating(true);
            activeRemoveMutation({
                variables: {
                    contentId: contentId,
                    ...isViewMode && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && {
                        doPublish: true,
                        suppressDraftPropertyUpdate: true
                    }
                }
            });
            contentStateState.setContentState(null);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    objectId: contentId,
                    actionSubjectId: 'editorContentStateRemoved',
                    source: 'editorContentState',
                    attributes: {
                        uiLocation: 'pageTitleSection',
                        contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        }
    }, [
        contentStateState,
        activeRemoveMutation,
        contentId,
        createAnalyticsEvent,
        isLivePage,
        isViewMode
    ]);
    const handleRemoveV2 = (0, $42omo.useCallback)(()=>{
        if (activeWorkflowStatus && approvalRequest?.review && approvalRequest.review.reviewStatus === 'PENDING') {
            setShowChangeStatusModal(true);
            return;
        }
        if (activeWorkflowStatus) {
            clearApprovalRequestOptimistically();
            cancelWorkflowApplication();
        }
        setIsContentStateMenuOpenWithListener(false);
        applyRemove();
    }, [
        activeWorkflowStatus,
        approvalRequest,
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        setIsContentStateMenuOpenWithListener,
        applyRemove
    ]);
    const handleSelectWorkflowStatus = (0, $42omo.useCallback)(async (selectedStatus_1)=>{
        const previousContentState = contentStateState.state.contentState;
        const prevStateId = activeWorkflowStatus?.id || contentState?.id || null;
        const analyticsAttributes = {
            contentId: contentId,
            contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
            prevStateId: prevStateId,
            newStateId: selectedStatus_1.id,
            isNewStatusWorkflow: true
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'inReviewStatus',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: analyticsAttributes
            }
        }).fire();
        if ((0, $9wGTI.fg)('confluence_approvals_beta')) {
            // New flow: no optimistic In-Review status, no createWorkflowApplication call.
            // The combined mutation is called later from StartApprovalPane.
            setIsContentStateMenuOpenWithListener(false);
            if (otherModeReviewStatus === 'PENDING') setIsShowingOtherModeBlockingPopup(true);
            else (0, $1vpkQ.openApprovalsPaneForContext)({
                contentId: contentId,
                contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                rightSidebarContext: rightSidebarContext
            });
            return;
        }
        contentStateState.setIsUpdating(true);
        contentStateState.setContentState(null);
        setIsContentStateMenuOpenWithListener(false);
        try {
            const result = await createWorkflowApplication(selectedStatus_1);
            if (otherModeReviewStatus === 'PENDING') // Other mode already has an active pending review — show the info popup
            // (which renders the otherModeReviewWarning SectionMessage) instead of
            // opening the ApprovalsPane / StartApprovalPane.
            setIsShowingInfoPopup(true);
            else (0, $1vpkQ.openApprovalsPaneForContext)({
                contentId: contentId,
                contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                rightSidebarContext: rightSidebarContext
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'approvalWorkflowApplication',
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: {
                        ...analyticsAttributes,
                        applicationId: result.applicationId
                    }
                }
            }).fire();
            contentStateState.setIsUpdating(false);
        } catch (error) {
            contentStateState.setIsUpdating(false);
            contentStateState.setContentState(previousContentState);
            flags.showErrorFlag({
                id: 'workflow-status-error-flag',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $adbf40b583ec3a51$export$a7357cdd1f0b0168).errorFlagBody)
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'approvalWorkflowApplication',
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: {
                        ...analyticsAttributes,
                        failureStatusCode: (0, $2QUbq.getFailureStatusCode)(error)
                    }
                }
            }).fire();
        }
    }, [
        otherModeReviewStatus,
        createWorkflowApplication,
        contentStateState,
        contentState,
        contentId,
        isViewMode,
        activeWorkflowStatus,
        createAnalyticsEvent,
        flags,
        setIsContentStateMenuOpenWithListener,
        setIsShowingOtherModeBlockingPopup,
        rightSidebarContext
    ]);
    const handleColorPickerToggle = (0, $42omo.useCallback)(()=>{
        setIsColorPickerOpen((prev)=>!prev);
    }, []);
    const handleColorPickerClose = (0, $42omo.useCallback)(()=>{
        setIsColorPickerOpen(false);
    }, []);
    const handleSelectColor = (0, $42omo.useCallback)((newColor)=>{
        setSelectedColor(newColor);
        setIsColorPickerOpen(false);
    }, []);
    const handleFocusTextField = (0, $42omo.useCallback)(()=>{
        setIsCreatingContentState(true);
    }, []);
    const handleMouseEnterRemove = (0, $42omo.useCallback)(()=>{
        setIsHoveringRemove(true);
    }, []);
    const handleMouseLeaveRemove = (0, $42omo.useCallback)(()=>{
        setIsHoveringRemove(false);
    }, []);
    const handleContentStatePopupClose = (0, $42omo.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        setIsCreatingContentState(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const handleSubmit = (0, $42omo.useCallback)((name)=>{
        if (!(0, $3qCob.isDuplicate)(contentStateState.state.contentState, {
            color: selectedColor?.toLowerCase() ?? null,
            name: name
        })) {
            const newContentState_0 = {
                color: selectedColor,
                name: name
            };
            contentStateState.setIsUpdating(true);
            // Mark that we're creating a new custom status so onCompleted updates the array
            isCreatingNewCustomStatusRef.current = true;
            setContentStateMutation({
                variables: {
                    contentId: contentId,
                    contentStateInput: {
                        ...newContentState_0,
                        color: (0, $8miSe.tokenToHex)(selectedColor)
                    }
                }
            });
            contentStateState.setContentState(newContentState_0);
        }
        if (shouldSetAutomationFlag && (0, $9wGTI.fg)('cc_a4c_smart_button_changeboarding')) {
            // This flag is used in AutomationMenuButtonWithSmartButtonSpotlight
            // It will check this flag to determine if it should show the spotlight
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AUTOMATION_DISCOVER_SET_CONTENT_STATE, true);
            setShouldSetAutomationFlag(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateAdded',
                source: 'editorContentState',
                attributes: {
                    type: 'new custom',
                    color: (0, $8miSe.colorCodeToColorName)(selectedColor ?? ''),
                    restrictionLevel: 'NONE',
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
        setIsCreatingContentState(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        isLivePage,
        isViewMode,
        selectedColor,
        setContentStateMutation,
        setIsContentStateMenuOpenWithListener,
        shouldSetAutomationFlag
    ]);
    const handleCancel = (0, $42omo.useCallback)(()=>{
        setIsCreatingContentState(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateCancel',
                source: 'editorContentState',
                attributes: {
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isLivePage,
        isViewMode
    ]);
    const handleRemove = (0, $42omo.useCallback)(()=>{
        // check if state exists before mutating since the trash button still shows if the feature is disabled
        // (page might not have a content state)
        if (contentStateState.state.contentState) {
            removeContentStateMutation({
                variables: {
                    contentId: contentId
                }
            });
            setIsCreatingContentState(false);
            setIsHoveringRemove(false);
            contentStateState.setContentState(null);
            setIsContentStateMenuOpenWithListener(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: contentId,
                actionSubjectId: 'editorContentStateRemoved',
                source: 'editorContentState',
                attributes: {
                    uiLocation: 'pageTitleSection',
                    contentStatus: isViewMode ? 'CURRENT' : 'DRAFT',
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        contentStateState,
        createAnalyticsEvent,
        removeContentStateMutation,
        setIsCreatingContentState,
        setIsContentStateMenuOpenWithListener,
        isLivePage,
        isViewMode
    ]);
    const handlePopupToggle = (0, $42omo.useCallback)(()=>{
        setIsContentStateMenuOpenWithListener(!isContentStateMenuOpen);
    }, [
        isContentStateMenuOpen,
        setIsContentStateMenuOpenWithListener
    ]);
    const handlePopupClose = (0, $42omo.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        setIsShowingOtherModeBlockingPopup(false);
        setIsContentStateMenuOpenWithListener(false);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const [showChangeStatusConfirmModal, setShowChangeStatusConfirmModal] = (0, $42omo.useState)(false);
    const handleChangeStatus = (0, $42omo.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        /* Only show the friction confirmation when there is an active review
    associated with the current approval */ if (approvalRequest?.review) setShowChangeStatusConfirmModal(true);
        else setIsContentStateMenuOpenWithListener(true);
    }, [
        approvalRequest,
        setIsContentStateMenuOpenWithListener
    ]);
    const handleConfirmChangeStatus = (0, $42omo.useCallback)(()=>{
        setShowChangeStatusConfirmModal(false);
        setIsContentStateMenuOpenWithListener(true);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const handleCloseChangeStatusConfirmModal = (0, $42omo.useCallback)(()=>{
        setShowChangeStatusConfirmModal(false);
        setIsShowingInfoPopup(true);
    }, []);
    const [showCancelApprovalModal, setShowCancelApprovalModal] = (0, $42omo.useState)(false);
    const handleClearRequest = (0, $42omo.useCallback)(()=>{
        setIsShowingInfoPopup(false);
        setShowCancelApprovalModal(true);
    }, []);
    const handleConfirmClearRequest = (0, $42omo.useCallback)(()=>{
        setShowCancelApprovalModal(false);
        setIsContentStateMenuOpenWithListener(false);
        clearApprovalRequestOptimistically();
        cancelWorkflowApplication();
    }, [
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        setIsContentStateMenuOpenWithListener
    ]);
    const handleCloseCancelApprovalModal = (0, $42omo.useCallback)(()=>{
        setShowCancelApprovalModal(false);
        setIsShowingInfoPopup(true);
    }, []);
    const handleConfirmCancelApproval = (0, $42omo.useCallback)(()=>{
        setShowChangeStatusModal(false);
        setIsContentStateMenuOpenWithListener(false);
        clearApprovalRequestOptimistically();
        cancelWorkflowApplication();
    }, [
        clearApprovalRequestOptimistically,
        cancelWorkflowApplication,
        setIsContentStateMenuOpenWithListener
    ]);
    const handleCloseChangeStatusModal = (0, $42omo.useCallback)(()=>{
        setShowChangeStatusModal(false);
        setIsContentStateMenuOpenWithListener(true);
    }, [
        setIsContentStateMenuOpenWithListener
    ]);
    const togglePopup = (0, $42omo.useCallback)(()=>{
        const shouldShowInfoPopup = (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && (isContentApprovalsEnabled && activeWorkflowStatus !== null || // Show the read-only info popup for view-only users who have a content state
        !canEdit && contentState !== null);
        if (shouldShowInfoPopup) {
            if (isShowingInfoPopup) setIsShowingInfoPopup(false);
            else setIsShowingInfoPopup(true);
        } else if (canEdit) // Only allow opening the content state menu if the user has edit permission
        handlePopupToggle();
        onClick?.();
    }, [
        isContentApprovalsEnabled,
        activeWorkflowStatus,
        isShowingInfoPopup,
        handlePopupToggle,
        onClick,
        canEdit,
        contentState
    ]);
    const renderTrigger = (0, $42omo.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32fca6e0bfcfd80d$export$ee3b73f13be68d6d), {
            triggerProps: {
                ...triggerProps
            },
            togglePopup: togglePopup,
            contentState: contentStateState.state.contentState,
            activeWorkflowStatus: activeWorkflowStatus,
            isSelected: isContentStateMenuOpen,
            isWarning: isHoveringRemove,
            userOffline: userOffline,
            contentStateButtonRef: contentStateButtonRef,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            renderPlusButtonEmptyState: renderPlusButtonEmptyState,
            isDetailsPanel: isDetailsPanel,
            canEdit: canEdit
        }), [
        togglePopup,
        contentStateState.state.contentState,
        activeWorkflowStatus,
        isContentStateMenuOpen,
        isHoveringRemove,
        userOffline,
        floatingToolbarButtonStyle,
        renderPlusButtonEmptyState,
        isDetailsPanel,
        canEdit
    ]);
    if (!renderServerPlaceholder && isContentApprovalsEnabled && approvalRequestLoading && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lJswu.ContentStateSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        testId: "content-state-popup",
        isOpen: isContentStateMenuOpen || isShowingInfoPopup || isShowingOtherModeBlockingPopup,
        onClose: handlePopupClose,
        placement: forceContentStatePlacementToTop ? 'top-end' : 'bottom-start',
        zIndex: (0, $g5lKx.layers).dialog(),
        trigger: renderTrigger,
        content: ({ update: update })=>{
            if (isShowingOtherModeBlockingPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9e4d91f280782e61$export$ef489f24b547890a), {
                isViewMode: isViewMode ?? false,
                onChangeStatus: ()=>{
                    setIsShowingOtherModeBlockingPopup(false);
                    handleChangeStatus();
                }
            });
            if (isShowingInfoPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $df5c0845c72ee01f$export$53d4fd7383e067f), {
                contentState: contentState,
                activeWorkflowStatus: activeWorkflowStatus,
                updatedAt: updatedAt,
                updatedBy: updatedBy,
                loading: userDataLoading,
                onChangeStatus: handleChangeStatus,
                onClearRequest: handleClearRequest,
                onClose: handlePopupClose,
                canEdit: canEdit,
                contentType: contentType,
                isViewMode: isViewMode
            });
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eeca34bbf5c80885$export$7cb66675cb7730f8), {
                contentId: contentId,
                contentStateState: contentStateState,
                contentType: contentType,
                isLivePage: isLivePage,
                defaultStatesArray: contentStateState.state.defaultStatesArray || [],
                customStatesArray: contentStateState.state.customStatesArray || [],
                isContentStateEnabled: contentStateState.state.isContentStateEnabled,
                userOffline: userOffline,
                onSelectExistingStatus: handleSelectExistingStatusV2,
                onSaveCustomStatus: handleSaveCustomStatusV2,
                onRemove: handleRemoveV2,
                isContentStateMenuOpen: isContentStateMenuOpen,
                setIsContentStateMenuOpen: setIsContentStateMenuOpenWithListener,
                workflowStatuses: reviewEligibleStatuses,
                onSelectWorkflowStatus: handleSelectWorkflowStatus
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $35470e23ff8dc4a3$export$d369faa039f625c2), {
                contentId: contentId,
                contentStateState: contentStateState,
                contentType: contentType,
                isContentStateEnabled: contentStateState.state.isContentStateEnabled,
                isSuggestedEnabled: contentStateState.state.isSuggestedEnabled,
                isCustomEnabled: contentStateState.state.isCustomEnabled,
                customStatesArray: contentStateState.state.customStatesArray,
                defaultStatesArray: contentStateState.state.defaultStatesArray,
                isCreatingContentState: isCreatingContentState,
                selectedColor: selectedColor,
                onSelectColor: handleSelectColor,
                isColorPickerOpen: isColorPickerOpen,
                onColorPickerToggle: handleColorPickerToggle,
                onColorPickerClose: handleColorPickerClose,
                onPopupClose: handleContentStatePopupClose,
                onSubmit: handleSubmit,
                onCancel: handleCancel,
                onRemove: handleRemove,
                onFocusTextField: handleFocusTextField,
                onMouseEnterRemove: handleMouseEnterRemove,
                onMouseLeaveRemove: handleMouseLeaveRemove,
                userOffline: userOffline,
                contentStateButtonRef: contentStateButtonRef,
                onUpdateSuccess: onUpdateSuccess,
                isContentStateMenuOpen: isContentStateMenuOpen,
                setIsContentStateMenuOpen: setIsContentStateMenuOpenWithListener,
                updatePopup: update
            });
        }
    }), showChangeStatusModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9e4b1108156656e$export$e3890091771f43d6), {
        approverData: respondedApproverData,
        onCancelApproval: handleConfirmCancelApproval,
        onClose: handleCloseChangeStatusModal
    }), showCancelApprovalModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5fbc7aa463b11615$export$666ae2a1d01b224a), {
        approverData: respondedApproverData,
        onCancelApproval: handleConfirmClearRequest,
        onClose: handleCloseCancelApprovalModal
    }), showChangeStatusConfirmModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b4b201f77954c660$export$64f482d2cfabd4a), {
        variant: "changeStatus",
        onConfirm: handleConfirmChangeStatus,
        onClose: handleCloseChangeStatusConfirmModal
    }));
};
const $1478047e1c32b5f4$export$80f871af2133e26f = (0, $7aRa9.withFlags)($1478047e1c32b5f4$export$fd37fef230d4b03a);
module.exports["EditorContentStateComponentImpl"] = $1478047e1c32b5f4$export$fd37fef230d4b03a;
module.exports["EditorContentStateComponent"] = $1478047e1c32b5f4$export$80f871af2133e26f;

});

parcelRegister("2QUbq", function(module, exports) {
/**
 * Approvals analytics utilities
 *
 * Shared constants and helpers for analytics events fired across the Approvals workflow.
 * All approval-related events should use the APPROVALS_ANALYTICS_SOURCE constant as their source.
 */ const $3b81570c8284038b$export$aafe3d1a02fab97e = 'ConfluenceApprovalsWorkflow';
const $3b81570c8284038b$export$f1487629ac850cbf = (approvers, decisionChange)=>{
    const counts = approvers.reduce((acc, approver)=>{
        if (approver.status === 'REVIEWER_APPROVED') acc.approved++;
        else if (approver.status === 'REVIEWER_DENIED') acc.declined++;
        else if (approver.status === 'PENDING_REVIEW') acc.pending++;
        return acc;
    }, {
        approved: 0,
        declined: 0,
        pending: 0,
        total: approvers.length
    });
    if (decisionChange) {
        const { previousDecision: previousDecision = 'PENDING_REVIEW', newDecision: newDecision } = decisionChange;
        // Decrement the previous bucket (REVIEW_CANCELED is not a counted bucket; treat as no-op)
        if (previousDecision === 'REVIEWER_APPROVED') counts.approved--;
        else if (previousDecision === 'REVIEWER_DENIED') counts.declined--;
        else if (previousDecision === 'PENDING_REVIEW') counts.pending--;
        // Increment the new bucket
        if (newDecision === 'REVIEWER_APPROVED') counts.approved++;
        else counts.declined++;
    }
    return counts;
};
const $3b81570c8284038b$export$571dc04ca9eba9e2 = (error)=>{
    if (error == null || typeof error !== 'object') return null;
    const mutationError = error;
    const { extensions: extensions } = mutationError;
    if (extensions == null) return null;
    const ext = Array.isArray(extensions) ? extensions[0] : extensions;
    if (ext == null) return null;
    const { statusCode: statusCode } = ext;
    if (typeof statusCode === 'number') return statusCode;
    return null;
};
module.exports["APPROVALS_ANALYTICS_SOURCE"] = $3b81570c8284038b$export$aafe3d1a02fab97e;
module.exports["computeReviewStatusCounts"] = $3b81570c8284038b$export$f1487629ac850cbf;
module.exports["getFailureStatusCode"] = $3b81570c8284038b$export$571dc04ca9eba9e2;

});

parcelRegister("ikX4p", function(module, exports) {

let $d597ea596b054fb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d597ea596b054fb9$var$load("7AxCq").then(()=>parcelRequire('akN4j'));

});

parcelRegister("35oNg", function(module, exports) {

let $23f5123aed1b498a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23f5123aed1b498a$var$load("kZCcz").then(()=>parcelRequire('7T100'));

});

parcelRegister("9E7R3", function(module, exports) {

let $705df14881f90716$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $705df14881f90716$var$load("kb6Db").then(()=>parcelRequire('k73x5'));

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("j3QkC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $laFNM = parcelRequire("laFNM");


var $f43UY = parcelRequire("f43UY");

const $98505e88072c3ce6$var$countByStatus = (approvers)=>approvers.reduce((counts, approver)=>{
        if (approver.status === 'REVIEWER_APPROVED') counts.approved++;
        else if (approver.status === 'REVIEWER_DENIED') counts.denied++;
        counts.total++;
        return counts;
    }, {
        approved: 0,
        denied: 0,
        total: 0
    });
const $98505e88072c3ce6$var$i18n = (0, $aXWIB.defineMessages)({
    approvedLabel: {
        id: "approvals.progress-bar.approved-label",
        defaultMessage: "{count} approved"
    },
    deniedLabel: {
        id: "approvals.progress-bar.denied-label",
        defaultMessage: "{count} denied"
    },
    ariaLabel: {
        id: "approvals.progress-bar.aria-label",
        defaultMessage: "Approvals progress"
    }
});
const $98505e88072c3ce6$export$b67a8dfe7ce21df4 = ()=>{
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const approvers = approvalRequest?.review?.approvers;
    const { approved: approved, denied: denied, total: total } = (0, $42omo.useMemo)(()=>$98505e88072c3ce6$var$countByStatus(approvers ?? []), [
        approvers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f43UY.MultiColorProgressBar), {
        segments: [
            {
                count: approved,
                color: "var(--ds-icon-success, #6A9A23)",
                label: formatMessage($98505e88072c3ce6$var$i18n.approvedLabel, {
                    count: approved
                })
            },
            {
                count: denied,
                color: "var(--ds-icon-accent-gray, #7D818A)",
                label: formatMessage($98505e88072c3ce6$var$i18n.deniedLabel, {
                    count: denied
                })
            }
        ],
        total: total,
        ariaLabel: formatMessage($98505e88072c3ce6$var$i18n.ariaLabel)
    });
};
module.exports["ApprovalsProgressBar"] = $98505e88072c3ce6$export$b67a8dfe7ce21df4;

});

parcelRegister("f43UY", function(module, exports) {
/* MultiColorProgressBar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $41481707d81a074d$var$borderRadius = "var(--ds-radius-small, 4px)";
const $41481707d81a074d$var$defaultBarColor = "var(--ds-background-neutral-bold, #292A2E)";
const $41481707d81a074d$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm",
    segment: "_v5641lap _1e0c1ule _4t3ii2wt _kqswstnw"
};
const $41481707d81a074d$var$getSegmentBorderRadius = (isFirst, isLast)=>{
    if (isFirst && isLast) return $41481707d81a074d$var$borderRadius;
    if (isFirst) return `${$41481707d81a074d$var$borderRadius} 0 0 ${$41481707d81a074d$var$borderRadius}`;
    if (isLast) return `0 ${$41481707d81a074d$var$borderRadius} ${$41481707d81a074d$var$borderRadius} 0`;
    return '0';
};
const $41481707d81a074d$export$6fe94d7699460647 = ({ segments: segments, total: total, ariaLabel: ariaLabel, testId: testId = 'multi-color-progress-bar' })=>{
    const clampedTotal = Math.max(total, 0); // Precalculate segments
    const segmentLayout = (0, $42omo.useMemo)(()=>{
        const activeIndices = segments.reduce((set, segment, index)=>{
            if (segment.count > 0) set.add(index);
            return set;
        }, new Set());
        let cumulative = 0;
        let activeIndex = 0;
        const activeCount = activeIndices.size;
        return segments.map((segment, index)=>{
            const isActive = activeIndices.has(index);
            const widthPercent = isActive && clampedTotal > 0 ? segment.count / clampedTotal * 100 : 0;
            const leftPercent = cumulative;
            cumulative += widthPercent;
            const isFirstActive = isActive && activeIndex === 0;
            const isLastActive = isActive && activeIndex === activeCount - 1;
            const gap = isActive && !isFirstActive ? 1 : 0;
            if (isActive) activeIndex++;
            return {
                widthPercent: widthPercent,
                leftPercent: leftPercent,
                color: segment.color,
                label: segment.label,
                isFirst: isFirstActive,
                isLast: isLastActive,
                gap: gap
            };
        });
    }, [
        segments,
        clampedTotal
    ]);
    // Used only for aria-valuenow
    const totalCount = (0, $42omo.useMemo)(()=>segmentLayout.reduce((sum, segment)=>sum + segment.widthPercent, 0), [
        segmentLayout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": 0,
        "aria-valuenow": clampedTotal > 0 ? Math.round(totalCount / 100 * clampedTotal) : 0,
        "aria-valuemax": clampedTotal,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $41481707d81a074d$var$styles.container
        ])
    }, clampedTotal > 0 && segmentLayout.map((layout, index)=>{
        const segment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            style: {
                left: `calc(${layout.leftPercent}% + ${layout.gap}px)`,
                width: `calc(${layout.widthPercent}% - ${layout.gap}px)`,
                backgroundColor: layout.color ?? $41481707d81a074d$var$defaultBarColor,
                borderRadius: $41481707d81a074d$var$getSegmentBorderRadius(layout.isFirst, layout.isLast)
            },
            "data-testid": `${testId}--segment-${index}`,
            className: (0, $gMc0m.default)([
                $41481707d81a074d$var$styles.segment
            ])
        });
        return layout.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: index,
            content: layout.label
        }, segment) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: index
        }, segment);
    }));
};
module.exports["MultiColorProgressBar"] = $41481707d81a074d$export$6fe94d7699460647;

});

parcelRegister("lJswu", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kpYGL = parcelRequire("kpYGL");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("iquRY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $frIzR.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t0,
        __callerPackage__: "@confluence/space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<312885e46175f1caad2e8c88a205c3bc>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("3qCob", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES = 3;
function $41e22d3f43a50651$export$86566dc9e85acb0c(primaryColor) {
    const tokenPrimaryColor = (0, $8miSe.hexToToken)(primaryColor ?? (0, $Uu0Pb.PRIMARY_COLORS).BLUE);
    switch(tokenPrimaryColor){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return (0, $Uu0Pb.SECONDARY_COLORS).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return (0, $Uu0Pb.SECONDARY_COLORS).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return (0, $Uu0Pb.SECONDARY_COLORS).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return (0, $Uu0Pb.SECONDARY_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$6844ce2c0353a555(secondaryColor) {
    const tokenSecondaryColor = (0, $8miSe.hexToToken)(secondaryColor ?? (0, $Uu0Pb.SECONDARY_COLORS).BLUE);
    switch(tokenSecondaryColor){
        case (0, $Uu0Pb.SECONDARY_COLORS).BLUE:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
        case (0, $Uu0Pb.SECONDARY_COLORS).GREEN:
            return (0, $Uu0Pb.HOVER_COLORS).GREEN;
        case (0, $Uu0Pb.SECONDARY_COLORS).YELLOW:
            return (0, $Uu0Pb.HOVER_COLORS).YELLOW;
        case (0, $Uu0Pb.SECONDARY_COLORS).RED:
            return (0, $Uu0Pb.HOVER_COLORS).RED;
        case (0, $Uu0Pb.SECONDARY_COLORS).PURPLE:
            return (0, $Uu0Pb.HOVER_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$ccc9fe24e363c71e(oldContentState, newContentState) {
    if (!oldContentState) return false; // can't be duplicate if we don't even have a content state originally
    return oldContentState.name === newContentState.name && oldContentState.color === newContentState.color;
}
function $41e22d3f43a50651$export$a2f9d64eff18382c(customStatesArray, newCustomState) {
    for(let i = 0; i < customStatesArray.length; ++i){
        if ($41e22d3f43a50651$export$ccc9fe24e363c71e(customStatesArray[i], newCustomState)) return {
            index: i,
            id: customStatesArray[i]?.id
        };
    }
    // if we don't find a match just return null
    return null;
}
function $41e22d3f43a50651$export$cd8fa131e8c8f91e(oldCustomStatesArray, newCustomState) {
    /* Need to check if the state user entered matches an existing custom one in the array.
   If it's a duplicate, it means the state the user just typed in is one that already exists. We must find the index
   and id in the old array and handle it like if an existing custom state was selected
    */ const idAndIndex = $41e22d3f43a50651$export$a2f9d64eff18382c(oldCustomStatesArray, newCustomState);
    if (idAndIndex) // user typed in an existing custom state
    return $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, {
        ...newCustomState,
        id: idAndIndex.id
    }, idAndIndex.index);
    else {
        const newArray = [
            newCustomState,
            ...oldCustomStatesArray
        ];
        if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.pop();
        return newArray;
    }
}
function $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, selectedCustomState, index) {
    // removed the selected custom state by index and then add it to the top of the new array
    const newArray = [
        ...oldCustomStatesArray
    ];
    newArray.splice(index, 1);
    newArray.unshift(selectedCustomState);
    return newArray;
}
module.exports["determineSecondaryColor"] = $41e22d3f43a50651$export$86566dc9e85acb0c;
module.exports["determineHoverColor"] = $41e22d3f43a50651$export$6844ce2c0353a555;
module.exports["isDuplicate"] = $41e22d3f43a50651$export$ccc9fe24e363c71e;
module.exports["createNewCustomStatesArrayWhenNewCustomAdded"] = $41e22d3f43a50651$export$cd8fa131e8c8f91e;
module.exports["createNewCustomStatesArrayWhenExistingCustomSelected"] = $41e22d3f43a50651$export$1c741d2b42a2932b;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<020826b2d97213ec125edeb03abfc3f5>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $0412590977f134ac$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $42omo.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $gMc0m.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("i3jcY", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $1xpoY.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "@confluence/entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<ad0100fe29e950a1379a2ddc53821b8d>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<47caf30fb1e1105daac0e1107cd5ed40>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<f845cfcec4db37305d62ff3698bca4f3>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<bba9a13a8c149665bd220be9731de503>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<b96ce0d5fd9337cf16cb77dc6aae256c>>
 * @relayHash e4d3106ab141a2f59d322ffcf93f9edf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v14 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v15 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v16 = [
        v11 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "success"
    }, v18 = {
        "kind": "ScalarField",
        "name": "message"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v21 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v23 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v24 = [
        v11 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v26 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v27 = {
        "kind": "ScalarField",
        "name": "value"
    }, v28 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v29 = [
        v6 /*: any*/ ,
        v26 /*: any*/ ,
        v25 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v27 /*: any*/ ,
                v28 /*: any*/ 
            ]
        }
    ], v30 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v29 /*: any*/ 
    }, v31 = [
        v27 /*: any*/ 
    ], v32 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v25 /*: any*/ ,
            v30 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v29 /*: any*/ 
            }
        ]
    }, v33 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            v30 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            v26 /*: any*/ ,
                            v25 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v28 /*: any*/ ,
                                    v27 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v6 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v16 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v21 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v21 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v16 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v34 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v34 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e4d3106ab141a2f59d322ffcf93f9edf",
            "id": "9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "dc99427393f687e09e4c81762eb96704";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});


//# sourceMappingURL=EditorContentStateComponent.121c9285.js.map
